
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ctZJO", function(module, exports) {

$parcel$export(module.exports, "Pane", () => $9168155af81732ad$export$fd2e1a4921eb839b);
/*! Tweakpane 4.0.5 (c) 2016 cocopon, licensed under the MIT license. */ function $9168155af81732ad$var$forceCast(v) {
    return v;
}
function $9168155af81732ad$var$isEmpty(value) {
    return value === null || value === undefined;
}
function $9168155af81732ad$var$isObject$1(value) {
    return value !== null && typeof value === 'object';
}
function $9168155af81732ad$var$isRecord(value) {
    return value !== null && typeof value === 'object';
}
function $9168155af81732ad$var$deepEqualsArray(a1, a2) {
    if (a1.length !== a2.length) return false;
    for(let i = 0; i < a1.length; i++){
        if (a1[i] !== a2[i]) return false;
    }
    return true;
}
function $9168155af81732ad$var$deepMerge(r1, r2) {
    const keys = Array.from(new Set([
        ...Object.keys(r1),
        ...Object.keys(r2)
    ]));
    return keys.reduce((result, key)=>{
        const v1 = r1[key];
        const v2 = r2[key];
        return $9168155af81732ad$var$isRecord(v1) && $9168155af81732ad$var$isRecord(v2) ? Object.assign(Object.assign({}, result), {
            [key]: $9168155af81732ad$var$deepMerge(v1, v2)
        }) : Object.assign(Object.assign({}, result), {
            [key]: key in r2 ? v2 : v1
        });
    }, {});
}
function $9168155af81732ad$var$isBinding(value) {
    if (!$9168155af81732ad$var$isObject$1(value)) return false;
    return 'target' in value;
}
const $9168155af81732ad$var$CREATE_MESSAGE_MAP = {
    alreadydisposed: ()=>'View has been already disposed',
    invalidparams: (context)=>`Invalid parameters for '${context.name}'`,
    nomatchingcontroller: (context)=>`No matching controller for '${context.key}'`,
    nomatchingview: (context)=>`No matching view for '${JSON.stringify(context.params)}'`,
    notbindable: ()=>`Value is not bindable`,
    notcompatible: (context)=>`Not compatible with  plugin '${context.id}'`,
    propertynotfound: (context)=>`Property '${context.name}' not found`,
    shouldneverhappen: ()=>'This error should never happen'
};
class $9168155af81732ad$var$TpError {
    static alreadyDisposed() {
        return new $9168155af81732ad$var$TpError({
            type: 'alreadydisposed'
        });
    }
    static notBindable() {
        return new $9168155af81732ad$var$TpError({
            type: 'notbindable'
        });
    }
    static notCompatible(bundleId, id) {
        return new $9168155af81732ad$var$TpError({
            type: 'notcompatible',
            context: {
                id: `${bundleId}.${id}`
            }
        });
    }
    static propertyNotFound(name) {
        return new $9168155af81732ad$var$TpError({
            type: 'propertynotfound',
            context: {
                name: name
            }
        });
    }
    static shouldNeverHappen() {
        return new $9168155af81732ad$var$TpError({
            type: 'shouldneverhappen'
        });
    }
    constructor(config){
        var _a;
        this.message = (_a = $9168155af81732ad$var$CREATE_MESSAGE_MAP[config.type]($9168155af81732ad$var$forceCast(config.context))) !== null && _a !== void 0 ? _a : 'Unexpected error';
        this.name = this.constructor.name;
        this.stack = new Error(this.message).stack;
        this.type = config.type;
    }
    toString() {
        return this.message;
    }
}
class $9168155af81732ad$var$BindingTarget {
    constructor(obj, key){
        this.obj_ = obj;
        this.key = key;
    }
    static isBindable(obj) {
        if (obj === null) return false;
        if (typeof obj !== 'object' && typeof obj !== 'function') return false;
        return true;
    }
    read() {
        return this.obj_[this.key];
    }
    write(value) {
        this.obj_[this.key] = value;
    }
    writeProperty(name, value) {
        const valueObj = this.read();
        if (!$9168155af81732ad$var$BindingTarget.isBindable(valueObj)) throw $9168155af81732ad$var$TpError.notBindable();
        if (!(name in valueObj)) throw $9168155af81732ad$var$TpError.propertyNotFound(name);
        valueObj[name] = value;
    }
}
class $9168155af81732ad$var$Emitter {
    constructor(){
        this.observers_ = {};
    }
    on(eventName, handler, opt_options) {
        var _a;
        let observers = this.observers_[eventName];
        if (!observers) observers = this.observers_[eventName] = [];
        observers.push({
            handler: handler,
            key: (_a = opt_options === null || opt_options === void 0 ? void 0 : opt_options.key) !== null && _a !== void 0 ? _a : handler
        });
        return this;
    }
    off(eventName, key) {
        const observers = this.observers_[eventName];
        if (observers) this.observers_[eventName] = observers.filter((observer)=>{
            return observer.key !== key;
        });
        return this;
    }
    emit(eventName, event) {
        const observers = this.observers_[eventName];
        if (!observers) return;
        observers.forEach((observer)=>{
            observer.handler(event);
        });
    }
}
class $9168155af81732ad$var$ComplexValue {
    constructor(initialValue, config){
        var _a;
        this.constraint_ = config === null || config === void 0 ? void 0 : config.constraint;
        this.equals_ = (_a = config === null || config === void 0 ? void 0 : config.equals) !== null && _a !== void 0 ? _a : (v1, v2)=>v1 === v2;
        this.emitter = new $9168155af81732ad$var$Emitter();
        this.rawValue_ = initialValue;
    }
    get constraint() {
        return this.constraint_;
    }
    get rawValue() {
        return this.rawValue_;
    }
    set rawValue(rawValue) {
        this.setRawValue(rawValue, {
            forceEmit: false,
            last: true
        });
    }
    setRawValue(rawValue, options) {
        const opts = options !== null && options !== void 0 ? options : {
            forceEmit: false,
            last: true
        };
        const constrainedValue = this.constraint_ ? this.constraint_.constrain(rawValue) : rawValue;
        const prevValue = this.rawValue_;
        const changed = !this.equals_(prevValue, constrainedValue);
        if (!changed && !opts.forceEmit) return;
        this.emitter.emit('beforechange', {
            sender: this
        });
        this.rawValue_ = constrainedValue;
        this.emitter.emit('change', {
            options: opts,
            previousRawValue: prevValue,
            rawValue: constrainedValue,
            sender: this
        });
    }
}
class $9168155af81732ad$var$PrimitiveValue {
    constructor(initialValue){
        this.emitter = new $9168155af81732ad$var$Emitter();
        this.value_ = initialValue;
    }
    get rawValue() {
        return this.value_;
    }
    set rawValue(value) {
        this.setRawValue(value, {
            forceEmit: false,
            last: true
        });
    }
    setRawValue(value, options) {
        const opts = options !== null && options !== void 0 ? options : {
            forceEmit: false,
            last: true
        };
        const prevValue = this.value_;
        if (prevValue === value && !opts.forceEmit) return;
        this.emitter.emit('beforechange', {
            sender: this
        });
        this.value_ = value;
        this.emitter.emit('change', {
            options: opts,
            previousRawValue: prevValue,
            rawValue: this.value_,
            sender: this
        });
    }
}
class $9168155af81732ad$var$ReadonlyPrimitiveValue {
    constructor(value){
        this.emitter = new $9168155af81732ad$var$Emitter();
        this.onValueBeforeChange_ = this.onValueBeforeChange_.bind(this);
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.value_ = value;
        this.value_.emitter.on('beforechange', this.onValueBeforeChange_);
        this.value_.emitter.on('change', this.onValueChange_);
    }
    get rawValue() {
        return this.value_.rawValue;
    }
    onValueBeforeChange_(ev) {
        this.emitter.emit('beforechange', Object.assign(Object.assign({}, ev), {
            sender: this
        }));
    }
    onValueChange_(ev) {
        this.emitter.emit('change', Object.assign(Object.assign({}, ev), {
            sender: this
        }));
    }
}
function $9168155af81732ad$var$createValue(initialValue, config) {
    const constraint = config === null || config === void 0 ? void 0 : config.constraint;
    const equals = config === null || config === void 0 ? void 0 : config.equals;
    if (!constraint && !equals) return new $9168155af81732ad$var$PrimitiveValue(initialValue);
    return new $9168155af81732ad$var$ComplexValue(initialValue, config);
}
function $9168155af81732ad$var$createReadonlyValue(value) {
    return [
        new $9168155af81732ad$var$ReadonlyPrimitiveValue(value),
        (rawValue, options)=>{
            value.setRawValue(rawValue, options);
        }
    ];
}
class $9168155af81732ad$var$ValueMap {
    constructor(valueMap){
        this.emitter = new $9168155af81732ad$var$Emitter();
        this.valMap_ = valueMap;
        for(const key in this.valMap_){
            const v = this.valMap_[key];
            v.emitter.on('change', ()=>{
                this.emitter.emit('change', {
                    key: key,
                    sender: this
                });
            });
        }
    }
    static createCore(initialValue) {
        const keys = Object.keys(initialValue);
        return keys.reduce((o, key)=>{
            return Object.assign(o, {
                [key]: $9168155af81732ad$var$createValue(initialValue[key])
            });
        }, {});
    }
    static fromObject(initialValue) {
        const core = this.createCore(initialValue);
        return new $9168155af81732ad$var$ValueMap(core);
    }
    get(key) {
        return this.valMap_[key].rawValue;
    }
    set(key, value) {
        this.valMap_[key].rawValue = value;
    }
    value(key) {
        return this.valMap_[key];
    }
}
class $9168155af81732ad$var$DefiniteRangeConstraint {
    constructor(config){
        this.values = $9168155af81732ad$var$ValueMap.fromObject({
            max: config.max,
            min: config.min
        });
    }
    constrain(value) {
        const max = this.values.get('max');
        const min = this.values.get('min');
        return Math.min(Math.max(value, min), max);
    }
}
class $9168155af81732ad$var$RangeConstraint {
    constructor(config){
        this.values = $9168155af81732ad$var$ValueMap.fromObject({
            max: config.max,
            min: config.min
        });
    }
    constrain(value) {
        const max = this.values.get('max');
        const min = this.values.get('min');
        let result = value;
        if (!$9168155af81732ad$var$isEmpty(min)) result = Math.max(result, min);
        if (!$9168155af81732ad$var$isEmpty(max)) result = Math.min(result, max);
        return result;
    }
}
class $9168155af81732ad$var$StepConstraint {
    constructor(step, origin = 0){
        this.step = step;
        this.origin = origin;
    }
    constrain(value) {
        const o = this.origin % this.step;
        const r = Math.round((value - o) / this.step);
        return o + r * this.step;
    }
}
class $9168155af81732ad$var$NumberLiteralNode {
    constructor(text){
        this.text = text;
    }
    evaluate() {
        return Number(this.text);
    }
    toString() {
        return this.text;
    }
}
const $9168155af81732ad$var$BINARY_OPERATION_MAP = {
    '**': (v1, v2)=>Math.pow(v1, v2),
    '*': (v1, v2)=>v1 * v2,
    '/': (v1, v2)=>v1 / v2,
    '%': (v1, v2)=>v1 % v2,
    '+': (v1, v2)=>v1 + v2,
    '-': (v1, v2)=>v1 - v2,
    '<<': (v1, v2)=>v1 << v2,
    '>>': (v1, v2)=>v1 >> v2,
    '>>>': (v1, v2)=>v1 >>> v2,
    '&': (v1, v2)=>v1 & v2,
    '^': (v1, v2)=>v1 ^ v2,
    '|': (v1, v2)=>v1 | v2
};
class $9168155af81732ad$var$BinaryOperationNode {
    constructor(operator, left, right){
        this.left = left;
        this.operator = operator;
        this.right = right;
    }
    evaluate() {
        const op = $9168155af81732ad$var$BINARY_OPERATION_MAP[this.operator];
        if (!op) throw new Error(`unexpected binary operator: '${this.operator}`);
        return op(this.left.evaluate(), this.right.evaluate());
    }
    toString() {
        return [
            'b(',
            this.left.toString(),
            this.operator,
            this.right.toString(),
            ')'
        ].join(' ');
    }
}
const $9168155af81732ad$var$UNARY_OPERATION_MAP = {
    '+': (v)=>v,
    '-': (v)=>-v,
    '~': (v)=>~v
};
class $9168155af81732ad$var$UnaryOperationNode {
    constructor(operator, expr){
        this.operator = operator;
        this.expression = expr;
    }
    evaluate() {
        const op = $9168155af81732ad$var$UNARY_OPERATION_MAP[this.operator];
        if (!op) throw new Error(`unexpected unary operator: '${this.operator}`);
        return op(this.expression.evaluate());
    }
    toString() {
        return [
            'u(',
            this.operator,
            this.expression.toString(),
            ')'
        ].join(' ');
    }
}
function $9168155af81732ad$var$combineReader(parsers) {
    return (text, cursor)=>{
        for(let i = 0; i < parsers.length; i++){
            const result = parsers[i](text, cursor);
            if (result !== '') return result;
        }
        return '';
    };
}
function $9168155af81732ad$var$readWhitespace(text, cursor) {
    var _a;
    const m = text.substr(cursor).match(/^\s+/);
    return (_a = m && m[0]) !== null && _a !== void 0 ? _a : '';
}
function $9168155af81732ad$var$readNonZeroDigit(text, cursor) {
    const ch = text.substr(cursor, 1);
    return ch.match(/^[1-9]$/) ? ch : '';
}
function $9168155af81732ad$var$readDecimalDigits(text, cursor) {
    var _a;
    const m = text.substr(cursor).match(/^[0-9]+/);
    return (_a = m && m[0]) !== null && _a !== void 0 ? _a : '';
}
function $9168155af81732ad$var$readSignedInteger(text, cursor) {
    const ds = $9168155af81732ad$var$readDecimalDigits(text, cursor);
    if (ds !== '') return ds;
    const sign = text.substr(cursor, 1);
    cursor += 1;
    if (sign !== '-' && sign !== '+') return '';
    const sds = $9168155af81732ad$var$readDecimalDigits(text, cursor);
    if (sds === '') return '';
    return sign + sds;
}
function $9168155af81732ad$var$readExponentPart(text, cursor) {
    const e = text.substr(cursor, 1);
    cursor += 1;
    if (e.toLowerCase() !== 'e') return '';
    const si = $9168155af81732ad$var$readSignedInteger(text, cursor);
    if (si === '') return '';
    return e + si;
}
function $9168155af81732ad$var$readDecimalIntegerLiteral(text, cursor) {
    const ch = text.substr(cursor, 1);
    if (ch === '0') return ch;
    const nzd = $9168155af81732ad$var$readNonZeroDigit(text, cursor);
    cursor += nzd.length;
    if (nzd === '') return '';
    return nzd + $9168155af81732ad$var$readDecimalDigits(text, cursor);
}
function $9168155af81732ad$var$readDecimalLiteral1(text, cursor) {
    const dil = $9168155af81732ad$var$readDecimalIntegerLiteral(text, cursor);
    cursor += dil.length;
    if (dil === '') return '';
    const dot = text.substr(cursor, 1);
    cursor += dot.length;
    if (dot !== '.') return '';
    const dds = $9168155af81732ad$var$readDecimalDigits(text, cursor);
    cursor += dds.length;
    return dil + dot + dds + $9168155af81732ad$var$readExponentPart(text, cursor);
}
function $9168155af81732ad$var$readDecimalLiteral2(text, cursor) {
    const dot = text.substr(cursor, 1);
    cursor += dot.length;
    if (dot !== '.') return '';
    const dds = $9168155af81732ad$var$readDecimalDigits(text, cursor);
    cursor += dds.length;
    if (dds === '') return '';
    return dot + dds + $9168155af81732ad$var$readExponentPart(text, cursor);
}
function $9168155af81732ad$var$readDecimalLiteral3(text, cursor) {
    const dil = $9168155af81732ad$var$readDecimalIntegerLiteral(text, cursor);
    cursor += dil.length;
    if (dil === '') return '';
    return dil + $9168155af81732ad$var$readExponentPart(text, cursor);
}
const $9168155af81732ad$var$readDecimalLiteral = $9168155af81732ad$var$combineReader([
    $9168155af81732ad$var$readDecimalLiteral1,
    $9168155af81732ad$var$readDecimalLiteral2,
    $9168155af81732ad$var$readDecimalLiteral3
]);
function $9168155af81732ad$var$parseBinaryDigits(text, cursor) {
    var _a;
    const m = text.substr(cursor).match(/^[01]+/);
    return (_a = m && m[0]) !== null && _a !== void 0 ? _a : '';
}
function $9168155af81732ad$var$readBinaryIntegerLiteral(text, cursor) {
    const prefix = text.substr(cursor, 2);
    cursor += prefix.length;
    if (prefix.toLowerCase() !== '0b') return '';
    const bds = $9168155af81732ad$var$parseBinaryDigits(text, cursor);
    if (bds === '') return '';
    return prefix + bds;
}
function $9168155af81732ad$var$readOctalDigits(text, cursor) {
    var _a;
    const m = text.substr(cursor).match(/^[0-7]+/);
    return (_a = m && m[0]) !== null && _a !== void 0 ? _a : '';
}
function $9168155af81732ad$var$readOctalIntegerLiteral(text, cursor) {
    const prefix = text.substr(cursor, 2);
    cursor += prefix.length;
    if (prefix.toLowerCase() !== '0o') return '';
    const ods = $9168155af81732ad$var$readOctalDigits(text, cursor);
    if (ods === '') return '';
    return prefix + ods;
}
function $9168155af81732ad$var$readHexDigits(text, cursor) {
    var _a;
    const m = text.substr(cursor).match(/^[0-9a-f]+/i);
    return (_a = m && m[0]) !== null && _a !== void 0 ? _a : '';
}
function $9168155af81732ad$var$readHexIntegerLiteral(text, cursor) {
    const prefix = text.substr(cursor, 2);
    cursor += prefix.length;
    if (prefix.toLowerCase() !== '0x') return '';
    const hds = $9168155af81732ad$var$readHexDigits(text, cursor);
    if (hds === '') return '';
    return prefix + hds;
}
const $9168155af81732ad$var$readNonDecimalIntegerLiteral = $9168155af81732ad$var$combineReader([
    $9168155af81732ad$var$readBinaryIntegerLiteral,
    $9168155af81732ad$var$readOctalIntegerLiteral,
    $9168155af81732ad$var$readHexIntegerLiteral
]);
const $9168155af81732ad$var$readNumericLiteral = $9168155af81732ad$var$combineReader([
    $9168155af81732ad$var$readNonDecimalIntegerLiteral,
    $9168155af81732ad$var$readDecimalLiteral
]);
function $9168155af81732ad$var$parseLiteral(text, cursor) {
    const num = $9168155af81732ad$var$readNumericLiteral(text, cursor);
    cursor += num.length;
    if (num === '') return null;
    return {
        evaluable: new $9168155af81732ad$var$NumberLiteralNode(num),
        cursor: cursor
    };
}
function $9168155af81732ad$var$parseParenthesizedExpression(text, cursor) {
    const op = text.substr(cursor, 1);
    cursor += op.length;
    if (op !== '(') return null;
    const expr = $9168155af81732ad$var$parseExpression(text, cursor);
    if (!expr) return null;
    cursor = expr.cursor;
    cursor += $9168155af81732ad$var$readWhitespace(text, cursor).length;
    const cl = text.substr(cursor, 1);
    cursor += cl.length;
    if (cl !== ')') return null;
    return {
        evaluable: expr.evaluable,
        cursor: cursor
    };
}
function $9168155af81732ad$var$parsePrimaryExpression(text, cursor) {
    var _a;
    return (_a = $9168155af81732ad$var$parseLiteral(text, cursor)) !== null && _a !== void 0 ? _a : $9168155af81732ad$var$parseParenthesizedExpression(text, cursor);
}
function $9168155af81732ad$var$parseUnaryExpression(text, cursor) {
    const expr = $9168155af81732ad$var$parsePrimaryExpression(text, cursor);
    if (expr) return expr;
    const op = text.substr(cursor, 1);
    cursor += op.length;
    if (op !== '+' && op !== '-' && op !== '~') return null;
    const num = $9168155af81732ad$var$parseUnaryExpression(text, cursor);
    if (!num) return null;
    cursor = num.cursor;
    return {
        cursor: cursor,
        evaluable: new $9168155af81732ad$var$UnaryOperationNode(op, num.evaluable)
    };
}
function $9168155af81732ad$var$readBinaryOperator(ops, text, cursor) {
    cursor += $9168155af81732ad$var$readWhitespace(text, cursor).length;
    const op = ops.filter((op)=>text.startsWith(op, cursor))[0];
    if (!op) return null;
    cursor += op.length;
    cursor += $9168155af81732ad$var$readWhitespace(text, cursor).length;
    return {
        cursor: cursor,
        operator: op
    };
}
function $9168155af81732ad$var$createBinaryOperationExpressionParser(exprParser, ops) {
    return (text, cursor)=>{
        const firstExpr = exprParser(text, cursor);
        if (!firstExpr) return null;
        cursor = firstExpr.cursor;
        let expr = firstExpr.evaluable;
        for(;;){
            const op = $9168155af81732ad$var$readBinaryOperator(ops, text, cursor);
            if (!op) break;
            cursor = op.cursor;
            const nextExpr = exprParser(text, cursor);
            if (!nextExpr) return null;
            cursor = nextExpr.cursor;
            expr = new $9168155af81732ad$var$BinaryOperationNode(op.operator, expr, nextExpr.evaluable);
        }
        return expr ? {
            cursor: cursor,
            evaluable: expr
        } : null;
    };
}
const $9168155af81732ad$var$parseBinaryOperationExpression = [
    [
        '**'
    ],
    [
        '*',
        '/',
        '%'
    ],
    [
        '+',
        '-'
    ],
    [
        '<<',
        '>>>',
        '>>'
    ],
    [
        '&'
    ],
    [
        '^'
    ],
    [
        '|'
    ]
].reduce((parser, ops)=>{
    return $9168155af81732ad$var$createBinaryOperationExpressionParser(parser, ops);
}, $9168155af81732ad$var$parseUnaryExpression);
function $9168155af81732ad$var$parseExpression(text, cursor) {
    cursor += $9168155af81732ad$var$readWhitespace(text, cursor).length;
    return $9168155af81732ad$var$parseBinaryOperationExpression(text, cursor);
}
function $9168155af81732ad$var$parseEcmaNumberExpression(text) {
    const expr = $9168155af81732ad$var$parseExpression(text, 0);
    if (!expr) return null;
    const cursor = expr.cursor + $9168155af81732ad$var$readWhitespace(text, expr.cursor).length;
    if (cursor !== text.length) return null;
    return expr.evaluable;
}
function $9168155af81732ad$var$parseNumber(text) {
    var _a;
    const r = $9168155af81732ad$var$parseEcmaNumberExpression(text);
    return (_a = r === null || r === void 0 ? void 0 : r.evaluate()) !== null && _a !== void 0 ? _a : null;
}
function $9168155af81732ad$var$numberFromUnknown(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
        const pv = $9168155af81732ad$var$parseNumber(value);
        if (!$9168155af81732ad$var$isEmpty(pv)) return pv;
    }
    return 0;
}
function $9168155af81732ad$var$numberToString(value) {
    return String(value);
}
function $9168155af81732ad$var$createNumberFormatter(digits) {
    return (value)=>{
        return value.toFixed(Math.max(Math.min(digits, 20), 0));
    };
}
function $9168155af81732ad$var$mapRange(value, start1, end1, start2, end2) {
    const p = (value - start1) / (end1 - start1);
    return start2 + p * (end2 - start2);
}
function $9168155af81732ad$var$getDecimalDigits(value) {
    const text = String(value.toFixed(10));
    const frac = text.split('.')[1];
    return frac.replace(/0+$/, '').length;
}
function $9168155af81732ad$var$constrainRange(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $9168155af81732ad$var$loopRange(value, max) {
    return (value % max + max) % max;
}
function $9168155af81732ad$var$getSuitableDecimalDigits(params, rawValue) {
    return !$9168155af81732ad$var$isEmpty(params.step) ? $9168155af81732ad$var$getDecimalDigits(params.step) : Math.max($9168155af81732ad$var$getDecimalDigits(rawValue), 2);
}
function $9168155af81732ad$var$getSuitableKeyScale(params) {
    var _a;
    return (_a = params.step) !== null && _a !== void 0 ? _a : 1;
}
function $9168155af81732ad$var$getSuitablePointerScale(params, rawValue) {
    var _a;
    const base = Math.abs((_a = params.step) !== null && _a !== void 0 ? _a : rawValue);
    return base === 0 ? 0.1 : Math.pow(10, Math.floor(Math.log10(base)) - 1);
}
function $9168155af81732ad$var$createStepConstraint(params, initialValue) {
    if (!$9168155af81732ad$var$isEmpty(params.step)) return new $9168155af81732ad$var$StepConstraint(params.step, initialValue);
    return null;
}
function $9168155af81732ad$var$createRangeConstraint(params) {
    if (!$9168155af81732ad$var$isEmpty(params.max) && !$9168155af81732ad$var$isEmpty(params.min)) return new $9168155af81732ad$var$DefiniteRangeConstraint({
        max: params.max,
        min: params.min
    });
    if (!$9168155af81732ad$var$isEmpty(params.max) || !$9168155af81732ad$var$isEmpty(params.min)) return new $9168155af81732ad$var$RangeConstraint({
        max: params.max,
        min: params.min
    });
    return null;
}
function $9168155af81732ad$var$createNumberTextPropsObject(params, initialValue) {
    var _a, _b, _c;
    return {
        formatter: (_a = params.format) !== null && _a !== void 0 ? _a : $9168155af81732ad$var$createNumberFormatter($9168155af81732ad$var$getSuitableDecimalDigits(params, initialValue)),
        keyScale: (_b = params.keyScale) !== null && _b !== void 0 ? _b : $9168155af81732ad$var$getSuitableKeyScale(params),
        pointerScale: (_c = params.pointerScale) !== null && _c !== void 0 ? _c : $9168155af81732ad$var$getSuitablePointerScale(params, initialValue)
    };
}
function $9168155af81732ad$var$createNumberTextInputParamsParser(p) {
    return {
        format: p.optional.function,
        keyScale: p.optional.number,
        max: p.optional.number,
        min: p.optional.number,
        pointerScale: p.optional.number,
        step: p.optional.number
    };
}
function $9168155af81732ad$var$createPointAxis(config) {
    return {
        constraint: config.constraint,
        textProps: $9168155af81732ad$var$ValueMap.fromObject($9168155af81732ad$var$createNumberTextPropsObject(config.params, config.initialValue))
    };
}
class $9168155af81732ad$export$248680fe6a940b95 {
    constructor(controller){
        this.controller = controller;
    }
    get element() {
        return this.controller.view.element;
    }
    get disabled() {
        return this.controller.viewProps.get('disabled');
    }
    set disabled(disabled) {
        this.controller.viewProps.set('disabled', disabled);
    }
    get hidden() {
        return this.controller.viewProps.get('hidden');
    }
    set hidden(hidden) {
        this.controller.viewProps.set('hidden', hidden);
    }
    dispose() {
        this.controller.viewProps.set('disposed', true);
    }
    importState(state) {
        return this.controller.importState(state);
    }
    exportState() {
        return this.controller.exportState();
    }
}
class $9168155af81732ad$var$TpEvent {
    constructor(target){
        this.target = target;
    }
}
class $9168155af81732ad$export$684748b171755c8d extends $9168155af81732ad$var$TpEvent {
    constructor(target, value, last){
        super(target);
        this.value = value;
        this.last = last !== null && last !== void 0 ? last : true;
    }
}
class $9168155af81732ad$var$TpFoldEvent extends $9168155af81732ad$var$TpEvent {
    constructor(target, expanded){
        super(target);
        this.expanded = expanded;
    }
}
class $9168155af81732ad$var$TpTabSelectEvent extends $9168155af81732ad$var$TpEvent {
    constructor(target, index){
        super(target);
        this.index = index;
    }
}
class $9168155af81732ad$var$TpMouseEvent extends $9168155af81732ad$var$TpEvent {
    constructor(target, nativeEvent){
        super(target);
        this.native = nativeEvent;
    }
}
class $9168155af81732ad$var$BindingApi extends $9168155af81732ad$export$248680fe6a940b95 {
    constructor(controller){
        super(controller);
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.emitter_ = new $9168155af81732ad$var$Emitter();
        this.controller.value.emitter.on('change', this.onValueChange_);
    }
    get label() {
        return this.controller.labelController.props.get('label');
    }
    set label(label) {
        this.controller.labelController.props.set('label', label);
    }
    get key() {
        return this.controller.value.binding.target.key;
    }
    get tag() {
        return this.controller.tag;
    }
    set tag(tag) {
        this.controller.tag = tag;
    }
    on(eventName, handler) {
        const bh = handler.bind(this);
        this.emitter_.on(eventName, (ev)=>{
            bh(ev);
        }, {
            key: handler
        });
        return this;
    }
    off(eventName, handler) {
        this.emitter_.off(eventName, handler);
        return this;
    }
    refresh() {
        this.controller.value.fetch();
    }
    onValueChange_(ev) {
        const value = this.controller.value;
        this.emitter_.emit('change', new $9168155af81732ad$export$684748b171755c8d(this, $9168155af81732ad$var$forceCast(value.binding.target.read()), ev.options.last));
    }
}
class $9168155af81732ad$var$InputBindingValue {
    constructor(value, binding){
        this.onValueBeforeChange_ = this.onValueBeforeChange_.bind(this);
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.binding = binding;
        this.value_ = value;
        this.value_.emitter.on('beforechange', this.onValueBeforeChange_);
        this.value_.emitter.on('change', this.onValueChange_);
        this.emitter = new $9168155af81732ad$var$Emitter();
    }
    get rawValue() {
        return this.value_.rawValue;
    }
    set rawValue(rawValue) {
        this.value_.rawValue = rawValue;
    }
    setRawValue(rawValue, options) {
        this.value_.setRawValue(rawValue, options);
    }
    fetch() {
        this.value_.rawValue = this.binding.read();
    }
    push() {
        this.binding.write(this.value_.rawValue);
    }
    onValueBeforeChange_(ev) {
        this.emitter.emit('beforechange', Object.assign(Object.assign({}, ev), {
            sender: this
        }));
    }
    onValueChange_(ev) {
        this.push();
        this.emitter.emit('change', Object.assign(Object.assign({}, ev), {
            sender: this
        }));
    }
}
function $9168155af81732ad$var$isInputBindingValue(v) {
    if (!('binding' in v)) return false;
    const b = v['binding'];
    return $9168155af81732ad$var$isBinding(b) && 'read' in b && 'write' in b;
}
function $9168155af81732ad$var$parseObject(value, keyToParserMap) {
    const keys = Object.keys(keyToParserMap);
    const result = keys.reduce((tmp, key)=>{
        if (tmp === undefined) return undefined;
        const parser = keyToParserMap[key];
        const result = parser(value[key]);
        return result.succeeded ? Object.assign(Object.assign({}, tmp), {
            [key]: result.value
        }) : undefined;
    }, {});
    return $9168155af81732ad$var$forceCast(result);
}
function $9168155af81732ad$var$parseArray(value, parseItem) {
    return value.reduce((tmp, item)=>{
        if (tmp === undefined) return undefined;
        const result = parseItem(item);
        if (!result.succeeded || result.value === undefined) return undefined;
        return [
            ...tmp,
            result.value
        ];
    }, []);
}
function $9168155af81732ad$var$isObject(value) {
    if (value === null) return false;
    return typeof value === 'object';
}
function $9168155af81732ad$var$createMicroParserBuilder(parse) {
    return (optional)=>(v)=>{
            if (!optional && v === undefined) return {
                succeeded: false,
                value: undefined
            };
            if (optional && v === undefined) return {
                succeeded: true,
                value: undefined
            };
            const result = parse(v);
            return result !== undefined ? {
                succeeded: true,
                value: result
            } : {
                succeeded: false,
                value: undefined
            };
        };
}
function $9168155af81732ad$var$createMicroParserBuilders(optional) {
    return {
        custom: (parse)=>$9168155af81732ad$var$createMicroParserBuilder(parse)(optional),
        boolean: $9168155af81732ad$var$createMicroParserBuilder((v)=>typeof v === 'boolean' ? v : undefined)(optional),
        number: $9168155af81732ad$var$createMicroParserBuilder((v)=>typeof v === 'number' ? v : undefined)(optional),
        string: $9168155af81732ad$var$createMicroParserBuilder((v)=>typeof v === 'string' ? v : undefined)(optional),
        function: $9168155af81732ad$var$createMicroParserBuilder((v)=>typeof v === 'function' ? v : undefined)(optional),
        constant: (value)=>$9168155af81732ad$var$createMicroParserBuilder((v)=>v === value ? value : undefined)(optional),
        raw: $9168155af81732ad$var$createMicroParserBuilder((v)=>v)(optional),
        object: (keyToParserMap)=>$9168155af81732ad$var$createMicroParserBuilder((v)=>{
                if (!$9168155af81732ad$var$isObject(v)) return undefined;
                return $9168155af81732ad$var$parseObject(v, keyToParserMap);
            })(optional),
        array: (itemParser)=>$9168155af81732ad$var$createMicroParserBuilder((v)=>{
                if (!Array.isArray(v)) return undefined;
                return $9168155af81732ad$var$parseArray(v, itemParser);
            })(optional)
    };
}
const $9168155af81732ad$var$MicroParsers = {
    optional: $9168155af81732ad$var$createMicroParserBuilders(true),
    required: $9168155af81732ad$var$createMicroParserBuilders(false)
};
function $9168155af81732ad$var$parseRecord(value, keyToParserMap) {
    const map = keyToParserMap($9168155af81732ad$var$MicroParsers);
    const result = $9168155af81732ad$var$MicroParsers.required.object(map)(value);
    return result.succeeded ? result.value : undefined;
}
function $9168155af81732ad$var$importBladeState(state, superImport, parser, callback) {
    if (superImport && !superImport(state)) return false;
    const result = $9168155af81732ad$var$parseRecord(state, parser);
    return result ? callback(result) : false;
}
function $9168155af81732ad$var$exportBladeState(superExport, thisState) {
    var _a;
    return $9168155af81732ad$var$deepMerge((_a = superExport === null || superExport === void 0 ? void 0 : superExport()) !== null && _a !== void 0 ? _a : {}, thisState);
}
function $9168155af81732ad$var$isValueBladeController(bc) {
    return 'value' in bc;
}
function $9168155af81732ad$var$isBindingValue(v) {
    if (!$9168155af81732ad$var$isObject$1(v) || !('binding' in v)) return false;
    const b = v.binding;
    return $9168155af81732ad$var$isBinding(b);
}
const $9168155af81732ad$var$SVG_NS = 'http://www.w3.org/2000/svg';
function $9168155af81732ad$var$forceReflow(element) {
    element.offsetHeight;
}
function $9168155af81732ad$var$disableTransitionTemporarily(element, callback) {
    const t = element.style.transition;
    element.style.transition = 'none';
    callback();
    element.style.transition = t;
}
function $9168155af81732ad$var$supportsTouch(doc) {
    return doc.ontouchstart !== undefined;
}
function $9168155af81732ad$var$getGlobalObject() {
    return globalThis;
}
function $9168155af81732ad$var$getWindowDocument() {
    const globalObj = $9168155af81732ad$var$forceCast($9168155af81732ad$var$getGlobalObject());
    return globalObj.document;
}
function $9168155af81732ad$var$getCanvasContext(canvasElement) {
    const win = canvasElement.ownerDocument.defaultView;
    if (!win) return null;
    const isBrowser = 'document' in win;
    return isBrowser ? canvasElement.getContext('2d', {
        willReadFrequently: true
    }) : null;
}
const $9168155af81732ad$var$ICON_ID_TO_INNER_HTML_MAP = {
    check: '<path d="M2 8l4 4l8 -8"/>',
    dropdown: '<path d="M5 7h6l-3 3 z"/>',
    p2dpad: '<path d="M8 4v8"/><path d="M4 8h8"/><circle cx="12" cy="12" r="1.2"/>'
};
function $9168155af81732ad$var$createSvgIconElement(document, iconId) {
    const elem = document.createElementNS($9168155af81732ad$var$SVG_NS, 'svg');
    elem.innerHTML = $9168155af81732ad$var$ICON_ID_TO_INNER_HTML_MAP[iconId];
    return elem;
}
function $9168155af81732ad$var$insertElementAt(parentElement, element, index) {
    parentElement.insertBefore(element, parentElement.children[index]);
}
function $9168155af81732ad$var$removeElement(element) {
    if (element.parentElement) element.parentElement.removeChild(element);
}
function $9168155af81732ad$var$removeChildElements(element) {
    while(element.children.length > 0)element.removeChild(element.children[0]);
}
function $9168155af81732ad$var$removeChildNodes(element) {
    while(element.childNodes.length > 0)element.removeChild(element.childNodes[0]);
}
function $9168155af81732ad$var$findNextTarget(ev) {
    if (ev.relatedTarget) return $9168155af81732ad$var$forceCast(ev.relatedTarget);
    if ('explicitOriginalTarget' in ev) return ev.explicitOriginalTarget;
    return null;
}
function $9168155af81732ad$var$bindValue(value, applyValue) {
    value.emitter.on('change', (ev)=>{
        applyValue(ev.rawValue);
    });
    applyValue(value.rawValue);
}
function $9168155af81732ad$var$bindValueMap(valueMap, key, applyValue) {
    $9168155af81732ad$var$bindValue(valueMap.value(key), applyValue);
}
const $9168155af81732ad$var$PREFIX = 'tp';
function $9168155af81732ad$var$ClassName(viewName) {
    const fn = (opt_elementName, opt_modifier)=>{
        return [
            $9168155af81732ad$var$PREFIX,
            '-',
            viewName,
            'v',
            opt_elementName ? `_${opt_elementName}` : '',
            opt_modifier ? `-${opt_modifier}` : ''
        ].join('');
    };
    return fn;
}
const $9168155af81732ad$var$cn$r = $9168155af81732ad$var$ClassName('lbl');
function $9168155af81732ad$var$createLabelNode(doc, label) {
    const frag = doc.createDocumentFragment();
    const lineNodes = label.split('\n').map((line)=>{
        return doc.createTextNode(line);
    });
    lineNodes.forEach((lineNode, index)=>{
        if (index > 0) frag.appendChild(doc.createElement('br'));
        frag.appendChild(lineNode);
    });
    return frag;
}
class $9168155af81732ad$var$LabelView {
    constructor(doc, config){
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$r());
        config.viewProps.bindClassModifiers(this.element);
        const labelElem = doc.createElement('div');
        labelElem.classList.add($9168155af81732ad$var$cn$r('l'));
        $9168155af81732ad$var$bindValueMap(config.props, 'label', (value)=>{
            if ($9168155af81732ad$var$isEmpty(value)) this.element.classList.add($9168155af81732ad$var$cn$r(undefined, 'nol'));
            else {
                this.element.classList.remove($9168155af81732ad$var$cn$r(undefined, 'nol'));
                $9168155af81732ad$var$removeChildNodes(labelElem);
                labelElem.appendChild($9168155af81732ad$var$createLabelNode(doc, value));
            }
        });
        this.element.appendChild(labelElem);
        this.labelElement = labelElem;
        const valueElem = doc.createElement('div');
        valueElem.classList.add($9168155af81732ad$var$cn$r('v'));
        this.element.appendChild(valueElem);
        this.valueElement = valueElem;
    }
}
class $9168155af81732ad$var$LabelController {
    constructor(doc, config){
        this.props = config.props;
        this.valueController = config.valueController;
        this.viewProps = config.valueController.viewProps;
        this.view = new $9168155af81732ad$var$LabelView(doc, {
            props: config.props,
            viewProps: this.viewProps
        });
        this.view.valueElement.appendChild(this.valueController.view.element);
    }
    importProps(state) {
        return $9168155af81732ad$var$importBladeState(state, null, (p)=>({
                label: p.optional.string
            }), (result)=>{
            this.props.set('label', result.label);
            return true;
        });
    }
    exportProps() {
        return $9168155af81732ad$var$exportBladeState(null, {
            label: this.props.get('label')
        });
    }
}
function $9168155af81732ad$var$getAllBladePositions() {
    return [
        'veryfirst',
        'first',
        'last',
        'verylast'
    ];
}
const $9168155af81732ad$var$cn$q = $9168155af81732ad$var$ClassName('');
const $9168155af81732ad$var$POS_TO_CLASS_NAME_MAP = {
    veryfirst: 'vfst',
    first: 'fst',
    last: 'lst',
    verylast: 'vlst'
};
class $9168155af81732ad$var$BladeController {
    constructor(config){
        this.parent_ = null;
        this.blade = config.blade;
        this.view = config.view;
        this.viewProps = config.viewProps;
        const elem = this.view.element;
        this.blade.value('positions').emitter.on('change', ()=>{
            $9168155af81732ad$var$getAllBladePositions().forEach((pos)=>{
                elem.classList.remove($9168155af81732ad$var$cn$q(undefined, $9168155af81732ad$var$POS_TO_CLASS_NAME_MAP[pos]));
            });
            this.blade.get('positions').forEach((pos)=>{
                elem.classList.add($9168155af81732ad$var$cn$q(undefined, $9168155af81732ad$var$POS_TO_CLASS_NAME_MAP[pos]));
            });
        });
        this.viewProps.handleDispose(()=>{
            $9168155af81732ad$var$removeElement(elem);
        });
    }
    get parent() {
        return this.parent_;
    }
    set parent(parent) {
        this.parent_ = parent;
        this.viewProps.set('parent', this.parent_ ? this.parent_.viewProps : null);
    }
    importState(state) {
        return $9168155af81732ad$var$importBladeState(state, null, (p)=>({
                disabled: p.required.boolean,
                hidden: p.required.boolean
            }), (result)=>{
            this.viewProps.importState(result);
            return true;
        });
    }
    exportState() {
        return $9168155af81732ad$var$exportBladeState(null, Object.assign({}, this.viewProps.exportState()));
    }
}
class $9168155af81732ad$var$LabeledValueBladeController extends $9168155af81732ad$var$BladeController {
    constructor(doc, config){
        if (config.value !== config.valueController.value) throw $9168155af81732ad$var$TpError.shouldNeverHappen();
        const viewProps = config.valueController.viewProps;
        const lc = new $9168155af81732ad$var$LabelController(doc, {
            blade: config.blade,
            props: config.props,
            valueController: config.valueController
        });
        super(Object.assign(Object.assign({}, config), {
            view: new $9168155af81732ad$var$LabelView(doc, {
                props: config.props,
                viewProps: viewProps
            }),
            viewProps: viewProps
        }));
        this.labelController = lc;
        this.value = config.value;
        this.valueController = config.valueController;
        this.view.valueElement.appendChild(this.valueController.view.element);
    }
    importState(state) {
        return $9168155af81732ad$var$importBladeState(state, (s)=>{
            var _a, _b, _c;
            return super.importState(s) && this.labelController.importProps(s) && ((_c = (_b = (_a = this.valueController).importProps) === null || _b === void 0 ? void 0 : _b.call(_a, state)) !== null && _c !== void 0 ? _c : true);
        }, (p)=>({
                value: p.optional.raw
            }), (result)=>{
            if (result.value) this.value.rawValue = result.value;
            return true;
        });
    }
    exportState() {
        var _a, _b, _c;
        return $9168155af81732ad$var$exportBladeState(()=>super.exportState(), Object.assign(Object.assign({
            value: this.value.rawValue
        }, this.labelController.exportProps()), (_c = (_b = (_a = this.valueController).exportProps) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : {}));
    }
}
function $9168155af81732ad$var$excludeValue(state) {
    const result = Object.assign({}, state);
    delete result.value;
    return result;
}
class $9168155af81732ad$var$BindingController extends $9168155af81732ad$var$LabeledValueBladeController {
    constructor(doc, config){
        super(doc, config);
        this.tag = config.tag;
    }
    importState(state) {
        return $9168155af81732ad$var$importBladeState(state, (_s)=>super.importState($9168155af81732ad$var$excludeValue(state)), (p)=>({
                tag: p.optional.string
            }), (result)=>{
            this.tag = result.tag;
            return true;
        });
    }
    exportState() {
        return $9168155af81732ad$var$exportBladeState(()=>$9168155af81732ad$var$excludeValue(super.exportState()), {
            binding: {
                key: this.value.binding.target.key,
                value: this.value.binding.target.read()
            },
            tag: this.tag
        });
    }
}
function $9168155af81732ad$var$isBindingController(bc) {
    return $9168155af81732ad$var$isValueBladeController(bc) && $9168155af81732ad$var$isBindingValue(bc.value);
}
class $9168155af81732ad$var$InputBindingController extends $9168155af81732ad$var$BindingController {
    importState(state) {
        return $9168155af81732ad$var$importBladeState(state, (s)=>super.importState(s), (p)=>({
                binding: p.required.object({
                    value: p.required.raw
                })
            }), (result)=>{
            this.value.binding.inject(result.binding.value);
            this.value.fetch();
            return true;
        });
    }
}
function $9168155af81732ad$var$isInputBindingController(bc) {
    return $9168155af81732ad$var$isValueBladeController(bc) && $9168155af81732ad$var$isInputBindingValue(bc.value);
}
function $9168155af81732ad$var$fillBuffer(buffer, bufferSize) {
    while(buffer.length < bufferSize)buffer.push(undefined);
}
function $9168155af81732ad$var$initializeBuffer(bufferSize) {
    const buffer = [];
    $9168155af81732ad$var$fillBuffer(buffer, bufferSize);
    return buffer;
}
function $9168155af81732ad$var$createTrimmedBuffer(buffer) {
    const index = buffer.indexOf(undefined);
    return $9168155af81732ad$var$forceCast(index < 0 ? buffer : buffer.slice(0, index));
}
function $9168155af81732ad$var$createPushedBuffer(buffer, newValue) {
    const newBuffer = [
        ...$9168155af81732ad$var$createTrimmedBuffer(buffer),
        newValue
    ];
    if (newBuffer.length > buffer.length) newBuffer.splice(0, newBuffer.length - buffer.length);
    else $9168155af81732ad$var$fillBuffer(newBuffer, buffer.length);
    return newBuffer;
}
class $9168155af81732ad$var$MonitorBindingValue {
    constructor(config){
        this.emitter = new $9168155af81732ad$var$Emitter();
        this.onTick_ = this.onTick_.bind(this);
        this.onValueBeforeChange_ = this.onValueBeforeChange_.bind(this);
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.binding = config.binding;
        this.value_ = $9168155af81732ad$var$createValue($9168155af81732ad$var$initializeBuffer(config.bufferSize));
        this.value_.emitter.on('beforechange', this.onValueBeforeChange_);
        this.value_.emitter.on('change', this.onValueChange_);
        this.ticker = config.ticker;
        this.ticker.emitter.on('tick', this.onTick_);
        this.fetch();
    }
    get rawValue() {
        return this.value_.rawValue;
    }
    set rawValue(rawValue) {
        this.value_.rawValue = rawValue;
    }
    setRawValue(rawValue, options) {
        this.value_.setRawValue(rawValue, options);
    }
    fetch() {
        this.value_.rawValue = $9168155af81732ad$var$createPushedBuffer(this.value_.rawValue, this.binding.read());
    }
    onTick_() {
        this.fetch();
    }
    onValueBeforeChange_(ev) {
        this.emitter.emit('beforechange', Object.assign(Object.assign({}, ev), {
            sender: this
        }));
    }
    onValueChange_(ev) {
        this.emitter.emit('change', Object.assign(Object.assign({}, ev), {
            sender: this
        }));
    }
}
function $9168155af81732ad$var$isMonitorBindingValue(v) {
    if (!('binding' in v)) return false;
    const b = v['binding'];
    return $9168155af81732ad$var$isBinding(b) && 'read' in b && !('write' in b);
}
class $9168155af81732ad$var$MonitorBindingController extends $9168155af81732ad$var$BindingController {
    exportState() {
        return $9168155af81732ad$var$exportBladeState(()=>super.exportState(), {
            binding: {
                readonly: true
            }
        });
    }
}
function $9168155af81732ad$var$isMonitorBindingController(bc) {
    return $9168155af81732ad$var$isValueBladeController(bc) && $9168155af81732ad$var$isMonitorBindingValue(bc.value);
}
class $9168155af81732ad$export$ab4d760fe715e733 extends $9168155af81732ad$export$248680fe6a940b95 {
    get label() {
        return this.controller.labelController.props.get('label');
    }
    set label(label) {
        this.controller.labelController.props.set('label', label);
    }
    get title() {
        var _a;
        return (_a = this.controller.buttonController.props.get('title')) !== null && _a !== void 0 ? _a : '';
    }
    set title(title) {
        this.controller.buttonController.props.set('title', title);
    }
    on(eventName, handler) {
        const bh = handler.bind(this);
        const emitter = this.controller.buttonController.emitter;
        emitter.on(eventName, (ev)=>{
            bh(new $9168155af81732ad$var$TpMouseEvent(this, ev.nativeEvent));
        });
        return this;
    }
    off(eventName, handler) {
        const emitter = this.controller.buttonController.emitter;
        emitter.off(eventName, handler);
        return this;
    }
}
function $9168155af81732ad$var$applyClass(elem, className, active) {
    if (active) elem.classList.add(className);
    else elem.classList.remove(className);
}
function $9168155af81732ad$var$valueToClassName(elem, className) {
    return (value)=>{
        $9168155af81732ad$var$applyClass(elem, className, value);
    };
}
function $9168155af81732ad$var$bindValueToTextContent(value, elem) {
    $9168155af81732ad$var$bindValue(value, (text)=>{
        elem.textContent = text !== null && text !== void 0 ? text : '';
    });
}
const $9168155af81732ad$var$cn$p = $9168155af81732ad$var$ClassName('btn');
class $9168155af81732ad$var$ButtonView {
    constructor(doc, config){
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$p());
        config.viewProps.bindClassModifiers(this.element);
        const buttonElem = doc.createElement('button');
        buttonElem.classList.add($9168155af81732ad$var$cn$p('b'));
        config.viewProps.bindDisabled(buttonElem);
        this.element.appendChild(buttonElem);
        this.buttonElement = buttonElem;
        const titleElem = doc.createElement('div');
        titleElem.classList.add($9168155af81732ad$var$cn$p('t'));
        $9168155af81732ad$var$bindValueToTextContent(config.props.value('title'), titleElem);
        this.buttonElement.appendChild(titleElem);
    }
}
class $9168155af81732ad$var$ButtonController {
    constructor(doc, config){
        this.emitter = new $9168155af81732ad$var$Emitter();
        this.onClick_ = this.onClick_.bind(this);
        this.props = config.props;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$ButtonView(doc, {
            props: this.props,
            viewProps: this.viewProps
        });
        this.view.buttonElement.addEventListener('click', this.onClick_);
    }
    importProps(state) {
        return $9168155af81732ad$var$importBladeState(state, null, (p)=>({
                title: p.optional.string
            }), (result)=>{
            this.props.set('title', result.title);
            return true;
        });
    }
    exportProps() {
        return $9168155af81732ad$var$exportBladeState(null, {
            title: this.props.get('title')
        });
    }
    onClick_(ev) {
        this.emitter.emit('click', {
            nativeEvent: ev,
            sender: this
        });
    }
}
class $9168155af81732ad$var$ButtonBladeController extends $9168155af81732ad$var$BladeController {
    constructor(doc, config){
        const bc = new $9168155af81732ad$var$ButtonController(doc, {
            props: config.buttonProps,
            viewProps: config.viewProps
        });
        const lc = new $9168155af81732ad$var$LabelController(doc, {
            blade: config.blade,
            props: config.labelProps,
            valueController: bc
        });
        super({
            blade: config.blade,
            view: lc.view,
            viewProps: config.viewProps
        });
        this.buttonController = bc;
        this.labelController = lc;
    }
    importState(state) {
        return $9168155af81732ad$var$importBladeState(state, (s)=>super.importState(s) && this.buttonController.importProps(s) && this.labelController.importProps(s), ()=>({}), ()=>true);
    }
    exportState() {
        return $9168155af81732ad$var$exportBladeState(()=>super.exportState(), Object.assign(Object.assign({}, this.buttonController.exportProps()), this.labelController.exportProps()));
    }
}
class $9168155af81732ad$export$10303f3d0f41e8b2 {
    constructor(text){
        const [core, prerelease] = text.split('-');
        const coreComps = core.split('.');
        this.major = parseInt(coreComps[0], 10);
        this.minor = parseInt(coreComps[1], 10);
        this.patch = parseInt(coreComps[2], 10);
        this.prerelease = prerelease !== null && prerelease !== void 0 ? prerelease : null;
    }
    toString() {
        const core = [
            this.major,
            this.minor,
            this.patch
        ].join('.');
        return this.prerelease !== null ? [
            core,
            this.prerelease
        ].join('-') : core;
    }
}
const $9168155af81732ad$var$VERSION$1 = new $9168155af81732ad$export$10303f3d0f41e8b2('2.0.5');
function $9168155af81732ad$var$createPlugin(plugin) {
    return Object.assign({
        core: $9168155af81732ad$var$VERSION$1
    }, plugin);
}
const $9168155af81732ad$var$ButtonBladePlugin = $9168155af81732ad$var$createPlugin({
    id: 'button',
    type: 'blade',
    accept (params) {
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                title: p.required.string,
                view: p.required.constant('button'),
                label: p.optional.string
            }));
        return result ? {
            params: result
        } : null;
    },
    controller (args) {
        return new $9168155af81732ad$var$ButtonBladeController(args.document, {
            blade: args.blade,
            buttonProps: $9168155af81732ad$var$ValueMap.fromObject({
                title: args.params.title
            }),
            labelProps: $9168155af81732ad$var$ValueMap.fromObject({
                label: args.params.label
            }),
            viewProps: args.viewProps
        });
    },
    api (args) {
        if (args.controller instanceof $9168155af81732ad$var$ButtonBladeController) return new $9168155af81732ad$export$ab4d760fe715e733(args.controller);
        return null;
    }
});
function $9168155af81732ad$var$addButtonAsBlade(api, params) {
    return api.addBlade(Object.assign(Object.assign({}, params), {
        view: 'button'
    }));
}
function $9168155af81732ad$var$addFolderAsBlade(api, params) {
    return api.addBlade(Object.assign(Object.assign({}, params), {
        view: 'folder'
    }));
}
function $9168155af81732ad$var$addTabAsBlade(api, params) {
    return api.addBlade(Object.assign(Object.assign({}, params), {
        view: 'tab'
    }));
}
function $9168155af81732ad$var$isRefreshable(value) {
    if (!$9168155af81732ad$var$isObject$1(value)) return false;
    return 'refresh' in value && typeof value.refresh === 'function';
}
function $9168155af81732ad$var$createBindingTarget(obj, key) {
    if (!$9168155af81732ad$var$BindingTarget.isBindable(obj)) throw $9168155af81732ad$var$TpError.notBindable();
    return new $9168155af81732ad$var$BindingTarget(obj, key);
}
class $9168155af81732ad$var$RackApi {
    constructor(controller, pool){
        this.onRackValueChange_ = this.onRackValueChange_.bind(this);
        this.controller_ = controller;
        this.emitter_ = new $9168155af81732ad$var$Emitter();
        this.pool_ = pool;
        const rack = this.controller_.rack;
        rack.emitter.on('valuechange', this.onRackValueChange_);
    }
    get children() {
        return this.controller_.rack.children.map((bc)=>this.pool_.createApi(bc));
    }
    addBinding(object, key, opt_params) {
        const params = opt_params !== null && opt_params !== void 0 ? opt_params : {};
        const doc = this.controller_.element.ownerDocument;
        const bc = this.pool_.createBinding(doc, $9168155af81732ad$var$createBindingTarget(object, key), params);
        const api = this.pool_.createBindingApi(bc);
        return this.add(api, params.index);
    }
    addFolder(params) {
        return $9168155af81732ad$var$addFolderAsBlade(this, params);
    }
    addButton(params) {
        return $9168155af81732ad$var$addButtonAsBlade(this, params);
    }
    addTab(params) {
        return $9168155af81732ad$var$addTabAsBlade(this, params);
    }
    add(api, opt_index) {
        const bc = api.controller;
        this.controller_.rack.add(bc, opt_index);
        return api;
    }
    remove(api) {
        this.controller_.rack.remove(api.controller);
    }
    addBlade(params) {
        const doc = this.controller_.element.ownerDocument;
        const bc = this.pool_.createBlade(doc, params);
        const api = this.pool_.createApi(bc);
        return this.add(api, params.index);
    }
    on(eventName, handler) {
        const bh = handler.bind(this);
        this.emitter_.on(eventName, (ev)=>{
            bh(ev);
        }, {
            key: handler
        });
        return this;
    }
    off(eventName, handler) {
        this.emitter_.off(eventName, handler);
        return this;
    }
    refresh() {
        this.children.forEach((c)=>{
            if ($9168155af81732ad$var$isRefreshable(c)) c.refresh();
        });
    }
    onRackValueChange_(ev) {
        const bc = ev.bladeController;
        const api = this.pool_.createApi(bc);
        const binding = $9168155af81732ad$var$isBindingValue(bc.value) ? bc.value.binding : null;
        this.emitter_.emit('change', new $9168155af81732ad$export$684748b171755c8d(api, binding ? binding.target.read() : bc.value.rawValue, ev.options.last));
    }
}
class $9168155af81732ad$var$ContainerBladeApi extends $9168155af81732ad$export$248680fe6a940b95 {
    constructor(controller, pool){
        super(controller);
        this.rackApi_ = new $9168155af81732ad$var$RackApi(controller.rackController, pool);
    }
    refresh() {
        this.rackApi_.refresh();
    }
}
class $9168155af81732ad$var$ContainerBladeController extends $9168155af81732ad$var$BladeController {
    constructor(config){
        super({
            blade: config.blade,
            view: config.view,
            viewProps: config.rackController.viewProps
        });
        this.rackController = config.rackController;
    }
    importState(state) {
        return $9168155af81732ad$var$importBladeState(state, (s)=>super.importState(s), (p)=>({
                children: p.required.array(p.required.raw)
            }), (result)=>{
            return this.rackController.rack.children.every((c, index)=>{
                return c.importState(result.children[index]);
            });
        });
    }
    exportState() {
        return $9168155af81732ad$var$exportBladeState(()=>super.exportState(), {
            children: this.rackController.rack.children.map((c)=>c.exportState())
        });
    }
}
function $9168155af81732ad$var$isContainerBladeController(bc) {
    return 'rackController' in bc;
}
class $9168155af81732ad$var$NestedOrderedSet {
    constructor(extract){
        this.emitter = new $9168155af81732ad$var$Emitter();
        this.items_ = [];
        this.cache_ = new Set();
        this.onSubListAdd_ = this.onSubListAdd_.bind(this);
        this.onSubListRemove_ = this.onSubListRemove_.bind(this);
        this.extract_ = extract;
    }
    get items() {
        return this.items_;
    }
    allItems() {
        return Array.from(this.cache_);
    }
    find(callback) {
        for (const item of this.allItems()){
            if (callback(item)) return item;
        }
        return null;
    }
    includes(item) {
        return this.cache_.has(item);
    }
    add(item, opt_index) {
        if (this.includes(item)) throw $9168155af81732ad$var$TpError.shouldNeverHappen();
        const index = opt_index !== undefined ? opt_index : this.items_.length;
        this.items_.splice(index, 0, item);
        this.cache_.add(item);
        const subList = this.extract_(item);
        if (subList) {
            subList.emitter.on('add', this.onSubListAdd_);
            subList.emitter.on('remove', this.onSubListRemove_);
            subList.allItems().forEach((i)=>{
                this.cache_.add(i);
            });
        }
        this.emitter.emit('add', {
            index: index,
            item: item,
            root: this,
            target: this
        });
    }
    remove(item) {
        const index = this.items_.indexOf(item);
        if (index < 0) return;
        this.items_.splice(index, 1);
        this.cache_.delete(item);
        const subList = this.extract_(item);
        if (subList) {
            subList.allItems().forEach((i)=>{
                this.cache_.delete(i);
            });
            subList.emitter.off('add', this.onSubListAdd_);
            subList.emitter.off('remove', this.onSubListRemove_);
        }
        this.emitter.emit('remove', {
            index: index,
            item: item,
            root: this,
            target: this
        });
    }
    onSubListAdd_(ev) {
        this.cache_.add(ev.item);
        this.emitter.emit('add', {
            index: ev.index,
            item: ev.item,
            root: this,
            target: ev.target
        });
    }
    onSubListRemove_(ev) {
        this.cache_.delete(ev.item);
        this.emitter.emit('remove', {
            index: ev.index,
            item: ev.item,
            root: this,
            target: ev.target
        });
    }
}
function $9168155af81732ad$var$findValueBladeController(bcs, v) {
    for(let i = 0; i < bcs.length; i++){
        const bc = bcs[i];
        if ($9168155af81732ad$var$isValueBladeController(bc) && bc.value === v) return bc;
    }
    return null;
}
function $9168155af81732ad$var$findSubBladeControllerSet(bc) {
    return $9168155af81732ad$var$isContainerBladeController(bc) ? bc.rackController.rack['bcSet_'] : null;
}
class $9168155af81732ad$var$Rack {
    constructor(config){
        var _a, _b;
        this.emitter = new $9168155af81732ad$var$Emitter();
        this.onBladePositionsChange_ = this.onBladePositionsChange_.bind(this);
        this.onSetAdd_ = this.onSetAdd_.bind(this);
        this.onSetRemove_ = this.onSetRemove_.bind(this);
        this.onChildDispose_ = this.onChildDispose_.bind(this);
        this.onChildPositionsChange_ = this.onChildPositionsChange_.bind(this);
        this.onChildValueChange_ = this.onChildValueChange_.bind(this);
        this.onChildViewPropsChange_ = this.onChildViewPropsChange_.bind(this);
        this.onRackLayout_ = this.onRackLayout_.bind(this);
        this.onRackValueChange_ = this.onRackValueChange_.bind(this);
        this.blade_ = (_a = config.blade) !== null && _a !== void 0 ? _a : null;
        (_b = this.blade_) === null || _b === void 0 || _b.value('positions').emitter.on('change', this.onBladePositionsChange_);
        this.viewProps = config.viewProps;
        this.bcSet_ = new $9168155af81732ad$var$NestedOrderedSet($9168155af81732ad$var$findSubBladeControllerSet);
        this.bcSet_.emitter.on('add', this.onSetAdd_);
        this.bcSet_.emitter.on('remove', this.onSetRemove_);
    }
    get children() {
        return this.bcSet_.items;
    }
    add(bc, opt_index) {
        var _a;
        (_a = bc.parent) === null || _a === void 0 || _a.remove(bc);
        bc.parent = this;
        this.bcSet_.add(bc, opt_index);
    }
    remove(bc) {
        bc.parent = null;
        this.bcSet_.remove(bc);
    }
    find(finder) {
        return this.bcSet_.allItems().filter(finder);
    }
    onSetAdd_(ev) {
        this.updatePositions_();
        const root = ev.target === ev.root;
        this.emitter.emit('add', {
            bladeController: ev.item,
            index: ev.index,
            root: root,
            sender: this
        });
        if (!root) return;
        const bc = ev.item;
        bc.viewProps.emitter.on('change', this.onChildViewPropsChange_);
        bc.blade.value('positions').emitter.on('change', this.onChildPositionsChange_);
        bc.viewProps.handleDispose(this.onChildDispose_);
        if ($9168155af81732ad$var$isValueBladeController(bc)) bc.value.emitter.on('change', this.onChildValueChange_);
        else if ($9168155af81732ad$var$isContainerBladeController(bc)) {
            const rack = bc.rackController.rack;
            if (rack) {
                const emitter = rack.emitter;
                emitter.on('layout', this.onRackLayout_);
                emitter.on('valuechange', this.onRackValueChange_);
            }
        }
    }
    onSetRemove_(ev) {
        this.updatePositions_();
        const root = ev.target === ev.root;
        this.emitter.emit('remove', {
            bladeController: ev.item,
            root: root,
            sender: this
        });
        if (!root) return;
        const bc = ev.item;
        if ($9168155af81732ad$var$isValueBladeController(bc)) bc.value.emitter.off('change', this.onChildValueChange_);
        else if ($9168155af81732ad$var$isContainerBladeController(bc)) {
            const rack = bc.rackController.rack;
            if (rack) {
                const emitter = rack.emitter;
                emitter.off('layout', this.onRackLayout_);
                emitter.off('valuechange', this.onRackValueChange_);
            }
        }
    }
    updatePositions_() {
        const visibleItems = this.bcSet_.items.filter((bc)=>!bc.viewProps.get('hidden'));
        const firstVisibleItem = visibleItems[0];
        const lastVisibleItem = visibleItems[visibleItems.length - 1];
        this.bcSet_.items.forEach((bc)=>{
            const ps = [];
            if (bc === firstVisibleItem) {
                ps.push('first');
                if (!this.blade_ || this.blade_.get('positions').includes('veryfirst')) ps.push('veryfirst');
            }
            if (bc === lastVisibleItem) {
                ps.push('last');
                if (!this.blade_ || this.blade_.get('positions').includes('verylast')) ps.push('verylast');
            }
            bc.blade.set('positions', ps);
        });
    }
    onChildPositionsChange_() {
        this.updatePositions_();
        this.emitter.emit('layout', {
            sender: this
        });
    }
    onChildViewPropsChange_(_ev) {
        this.updatePositions_();
        this.emitter.emit('layout', {
            sender: this
        });
    }
    onChildDispose_() {
        const disposedUcs = this.bcSet_.items.filter((bc)=>{
            return bc.viewProps.get('disposed');
        });
        disposedUcs.forEach((bc)=>{
            this.bcSet_.remove(bc);
        });
    }
    onChildValueChange_(ev) {
        const bc = $9168155af81732ad$var$findValueBladeController(this.find($9168155af81732ad$var$isValueBladeController), ev.sender);
        if (!bc) throw $9168155af81732ad$var$TpError.alreadyDisposed();
        this.emitter.emit('valuechange', {
            bladeController: bc,
            options: ev.options,
            sender: this
        });
    }
    onRackLayout_(_) {
        this.updatePositions_();
        this.emitter.emit('layout', {
            sender: this
        });
    }
    onRackValueChange_(ev) {
        this.emitter.emit('valuechange', {
            bladeController: ev.bladeController,
            options: ev.options,
            sender: this
        });
    }
    onBladePositionsChange_() {
        this.updatePositions_();
    }
}
class $9168155af81732ad$var$RackController {
    constructor(config){
        this.onRackAdd_ = this.onRackAdd_.bind(this);
        this.onRackRemove_ = this.onRackRemove_.bind(this);
        this.element = config.element;
        this.viewProps = config.viewProps;
        const rack = new $9168155af81732ad$var$Rack({
            blade: config.root ? undefined : config.blade,
            viewProps: config.viewProps
        });
        rack.emitter.on('add', this.onRackAdd_);
        rack.emitter.on('remove', this.onRackRemove_);
        this.rack = rack;
        this.viewProps.handleDispose(()=>{
            for(let i = this.rack.children.length - 1; i >= 0; i--){
                const bc = this.rack.children[i];
                bc.viewProps.set('disposed', true);
            }
        });
    }
    onRackAdd_(ev) {
        if (!ev.root) return;
        $9168155af81732ad$var$insertElementAt(this.element, ev.bladeController.view.element, ev.index);
    }
    onRackRemove_(ev) {
        if (!ev.root) return;
        $9168155af81732ad$var$removeElement(ev.bladeController.view.element);
    }
}
function $9168155af81732ad$var$createBlade() {
    return new $9168155af81732ad$var$ValueMap({
        positions: $9168155af81732ad$var$createValue([], {
            equals: $9168155af81732ad$var$deepEqualsArray
        })
    });
}
class $9168155af81732ad$var$Foldable extends $9168155af81732ad$var$ValueMap {
    constructor(valueMap){
        super(valueMap);
    }
    static create(expanded) {
        const coreObj = {
            completed: true,
            expanded: expanded,
            expandedHeight: null,
            shouldFixHeight: false,
            temporaryExpanded: null
        };
        const core = $9168155af81732ad$var$ValueMap.createCore(coreObj);
        return new $9168155af81732ad$var$Foldable(core);
    }
    get styleExpanded() {
        var _a;
        return (_a = this.get('temporaryExpanded')) !== null && _a !== void 0 ? _a : this.get('expanded');
    }
    get styleHeight() {
        if (!this.styleExpanded) return '0';
        const exHeight = this.get('expandedHeight');
        if (this.get('shouldFixHeight') && !$9168155af81732ad$var$isEmpty(exHeight)) return `${exHeight}px`;
        return 'auto';
    }
    bindExpandedClass(elem, expandedClassName) {
        const onExpand = ()=>{
            const expanded = this.styleExpanded;
            if (expanded) elem.classList.add(expandedClassName);
            else elem.classList.remove(expandedClassName);
        };
        $9168155af81732ad$var$bindValueMap(this, 'expanded', onExpand);
        $9168155af81732ad$var$bindValueMap(this, 'temporaryExpanded', onExpand);
    }
    cleanUpTransition() {
        this.set('shouldFixHeight', false);
        this.set('expandedHeight', null);
        this.set('completed', true);
    }
}
function $9168155af81732ad$var$computeExpandedFolderHeight(folder, containerElement) {
    let height = 0;
    $9168155af81732ad$var$disableTransitionTemporarily(containerElement, ()=>{
        folder.set('expandedHeight', null);
        folder.set('temporaryExpanded', true);
        $9168155af81732ad$var$forceReflow(containerElement);
        height = containerElement.clientHeight;
        folder.set('temporaryExpanded', null);
        $9168155af81732ad$var$forceReflow(containerElement);
    });
    return height;
}
function $9168155af81732ad$var$applyHeight(foldable, elem) {
    elem.style.height = foldable.styleHeight;
}
function $9168155af81732ad$var$bindFoldable(foldable, elem) {
    foldable.value('expanded').emitter.on('beforechange', ()=>{
        foldable.set('completed', false);
        if ($9168155af81732ad$var$isEmpty(foldable.get('expandedHeight'))) {
            const h = $9168155af81732ad$var$computeExpandedFolderHeight(foldable, elem);
            if (h > 0) foldable.set('expandedHeight', h);
        }
        foldable.set('shouldFixHeight', true);
        $9168155af81732ad$var$forceReflow(elem);
    });
    foldable.emitter.on('change', ()=>{
        $9168155af81732ad$var$applyHeight(foldable, elem);
    });
    $9168155af81732ad$var$applyHeight(foldable, elem);
    elem.addEventListener('transitionend', (ev)=>{
        if (ev.propertyName !== 'height') return;
        foldable.cleanUpTransition();
    });
}
class $9168155af81732ad$export$c37d4c4ec53b1dee extends $9168155af81732ad$var$ContainerBladeApi {
    constructor(controller, pool){
        super(controller, pool);
        this.emitter_ = new $9168155af81732ad$var$Emitter();
        this.controller.foldable.value('expanded').emitter.on('change', (ev)=>{
            this.emitter_.emit('fold', new $9168155af81732ad$var$TpFoldEvent(this, ev.sender.rawValue));
        });
        this.rackApi_.on('change', (ev)=>{
            this.emitter_.emit('change', ev);
        });
    }
    get expanded() {
        return this.controller.foldable.get('expanded');
    }
    set expanded(expanded) {
        this.controller.foldable.set('expanded', expanded);
    }
    get title() {
        return this.controller.props.get('title');
    }
    set title(title) {
        this.controller.props.set('title', title);
    }
    get children() {
        return this.rackApi_.children;
    }
    addBinding(object, key, opt_params) {
        return this.rackApi_.addBinding(object, key, opt_params);
    }
    addFolder(params) {
        return this.rackApi_.addFolder(params);
    }
    addButton(params) {
        return this.rackApi_.addButton(params);
    }
    addTab(params) {
        return this.rackApi_.addTab(params);
    }
    add(api, opt_index) {
        return this.rackApi_.add(api, opt_index);
    }
    remove(api) {
        this.rackApi_.remove(api);
    }
    addBlade(params) {
        return this.rackApi_.addBlade(params);
    }
    on(eventName, handler) {
        const bh = handler.bind(this);
        this.emitter_.on(eventName, (ev)=>{
            bh(ev);
        }, {
            key: handler
        });
        return this;
    }
    off(eventName, handler) {
        this.emitter_.off(eventName, handler);
        return this;
    }
}
const $9168155af81732ad$var$bladeContainerClassName = $9168155af81732ad$var$ClassName('cnt');
class $9168155af81732ad$var$FolderView {
    constructor(doc, config){
        var _a;
        this.className_ = $9168155af81732ad$var$ClassName((_a = config.viewName) !== null && _a !== void 0 ? _a : 'fld');
        this.element = doc.createElement('div');
        this.element.classList.add(this.className_(), $9168155af81732ad$var$bladeContainerClassName());
        config.viewProps.bindClassModifiers(this.element);
        this.foldable_ = config.foldable;
        this.foldable_.bindExpandedClass(this.element, this.className_(undefined, 'expanded'));
        $9168155af81732ad$var$bindValueMap(this.foldable_, 'completed', $9168155af81732ad$var$valueToClassName(this.element, this.className_(undefined, 'cpl')));
        const buttonElem = doc.createElement('button');
        buttonElem.classList.add(this.className_('b'));
        $9168155af81732ad$var$bindValueMap(config.props, 'title', (title)=>{
            if ($9168155af81732ad$var$isEmpty(title)) this.element.classList.add(this.className_(undefined, 'not'));
            else this.element.classList.remove(this.className_(undefined, 'not'));
        });
        config.viewProps.bindDisabled(buttonElem);
        this.element.appendChild(buttonElem);
        this.buttonElement = buttonElem;
        const indentElem = doc.createElement('div');
        indentElem.classList.add(this.className_('i'));
        this.element.appendChild(indentElem);
        const titleElem = doc.createElement('div');
        titleElem.classList.add(this.className_('t'));
        $9168155af81732ad$var$bindValueToTextContent(config.props.value('title'), titleElem);
        this.buttonElement.appendChild(titleElem);
        this.titleElement = titleElem;
        const markElem = doc.createElement('div');
        markElem.classList.add(this.className_('m'));
        this.buttonElement.appendChild(markElem);
        const containerElem = doc.createElement('div');
        containerElem.classList.add(this.className_('c'));
        this.element.appendChild(containerElem);
        this.containerElement = containerElem;
    }
}
class $9168155af81732ad$var$FolderController extends $9168155af81732ad$var$ContainerBladeController {
    constructor(doc, config){
        var _a;
        const foldable = $9168155af81732ad$var$Foldable.create((_a = config.expanded) !== null && _a !== void 0 ? _a : true);
        const view = new $9168155af81732ad$var$FolderView(doc, {
            foldable: foldable,
            props: config.props,
            viewName: config.root ? 'rot' : undefined,
            viewProps: config.viewProps
        });
        super(Object.assign(Object.assign({}, config), {
            rackController: new $9168155af81732ad$var$RackController({
                blade: config.blade,
                element: view.containerElement,
                root: config.root,
                viewProps: config.viewProps
            }),
            view: view
        }));
        this.onTitleClick_ = this.onTitleClick_.bind(this);
        this.props = config.props;
        this.foldable = foldable;
        $9168155af81732ad$var$bindFoldable(this.foldable, this.view.containerElement);
        this.rackController.rack.emitter.on('add', ()=>{
            this.foldable.cleanUpTransition();
        });
        this.rackController.rack.emitter.on('remove', ()=>{
            this.foldable.cleanUpTransition();
        });
        this.view.buttonElement.addEventListener('click', this.onTitleClick_);
    }
    get document() {
        return this.view.element.ownerDocument;
    }
    importState(state) {
        return $9168155af81732ad$var$importBladeState(state, (s)=>super.importState(s), (p)=>({
                expanded: p.required.boolean,
                title: p.optional.string
            }), (result)=>{
            this.foldable.set('expanded', result.expanded);
            this.props.set('title', result.title);
            return true;
        });
    }
    exportState() {
        return $9168155af81732ad$var$exportBladeState(()=>super.exportState(), {
            expanded: this.foldable.get('expanded'),
            title: this.props.get('title')
        });
    }
    onTitleClick_() {
        this.foldable.set('expanded', !this.foldable.get('expanded'));
    }
}
const $9168155af81732ad$var$FolderBladePlugin = $9168155af81732ad$var$createPlugin({
    id: 'folder',
    type: 'blade',
    accept (params) {
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                title: p.required.string,
                view: p.required.constant('folder'),
                expanded: p.optional.boolean
            }));
        return result ? {
            params: result
        } : null;
    },
    controller (args) {
        return new $9168155af81732ad$var$FolderController(args.document, {
            blade: args.blade,
            expanded: args.params.expanded,
            props: $9168155af81732ad$var$ValueMap.fromObject({
                title: args.params.title
            }),
            viewProps: args.viewProps
        });
    },
    api (args) {
        if (!(args.controller instanceof $9168155af81732ad$var$FolderController)) return null;
        return new $9168155af81732ad$export$c37d4c4ec53b1dee(args.controller, args.pool);
    }
});
const $9168155af81732ad$var$cn$o = $9168155af81732ad$var$ClassName('');
function $9168155af81732ad$var$valueToModifier(elem, modifier) {
    return $9168155af81732ad$var$valueToClassName(elem, $9168155af81732ad$var$cn$o(undefined, modifier));
}
class $9168155af81732ad$var$ViewProps extends $9168155af81732ad$var$ValueMap {
    constructor(valueMap){
        var _a;
        super(valueMap);
        this.onDisabledChange_ = this.onDisabledChange_.bind(this);
        this.onParentChange_ = this.onParentChange_.bind(this);
        this.onParentGlobalDisabledChange_ = this.onParentGlobalDisabledChange_.bind(this);
        [this.globalDisabled_, this.setGlobalDisabled_] = $9168155af81732ad$var$createReadonlyValue($9168155af81732ad$var$createValue(this.getGlobalDisabled_()));
        this.value('disabled').emitter.on('change', this.onDisabledChange_);
        this.value('parent').emitter.on('change', this.onParentChange_);
        (_a = this.get('parent')) === null || _a === void 0 || _a.globalDisabled.emitter.on('change', this.onParentGlobalDisabledChange_);
    }
    static create(opt_initialValue) {
        var _a, _b, _c;
        const initialValue = opt_initialValue !== null && opt_initialValue !== void 0 ? opt_initialValue : {};
        return new $9168155af81732ad$var$ViewProps($9168155af81732ad$var$ValueMap.createCore({
            disabled: (_a = initialValue.disabled) !== null && _a !== void 0 ? _a : false,
            disposed: false,
            hidden: (_b = initialValue.hidden) !== null && _b !== void 0 ? _b : false,
            parent: (_c = initialValue.parent) !== null && _c !== void 0 ? _c : null
        }));
    }
    get globalDisabled() {
        return this.globalDisabled_;
    }
    bindClassModifiers(elem) {
        $9168155af81732ad$var$bindValue(this.globalDisabled_, $9168155af81732ad$var$valueToModifier(elem, 'disabled'));
        $9168155af81732ad$var$bindValueMap(this, 'hidden', $9168155af81732ad$var$valueToModifier(elem, 'hidden'));
    }
    bindDisabled(target) {
        $9168155af81732ad$var$bindValue(this.globalDisabled_, (disabled)=>{
            target.disabled = disabled;
        });
    }
    bindTabIndex(elem) {
        $9168155af81732ad$var$bindValue(this.globalDisabled_, (disabled)=>{
            elem.tabIndex = disabled ? -1 : 0;
        });
    }
    handleDispose(callback) {
        this.value('disposed').emitter.on('change', (disposed)=>{
            if (disposed) callback();
        });
    }
    importState(state) {
        this.set('disabled', state.disabled);
        this.set('hidden', state.hidden);
    }
    exportState() {
        return {
            disabled: this.get('disabled'),
            hidden: this.get('hidden')
        };
    }
    getGlobalDisabled_() {
        const parent = this.get('parent');
        const parentDisabled = parent ? parent.globalDisabled.rawValue : false;
        return parentDisabled || this.get('disabled');
    }
    updateGlobalDisabled_() {
        this.setGlobalDisabled_(this.getGlobalDisabled_());
    }
    onDisabledChange_() {
        this.updateGlobalDisabled_();
    }
    onParentGlobalDisabledChange_() {
        this.updateGlobalDisabled_();
    }
    onParentChange_(ev) {
        var _a;
        const prevParent = ev.previousRawValue;
        prevParent === null || prevParent === void 0 || prevParent.globalDisabled.emitter.off('change', this.onParentGlobalDisabledChange_);
        (_a = this.get('parent')) === null || _a === void 0 || _a.globalDisabled.emitter.on('change', this.onParentGlobalDisabledChange_);
        this.updateGlobalDisabled_();
    }
}
const $9168155af81732ad$var$cn$n = $9168155af81732ad$var$ClassName('tbp');
class $9168155af81732ad$var$TabPageView {
    constructor(doc, config){
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$n());
        config.viewProps.bindClassModifiers(this.element);
        const containerElem = doc.createElement('div');
        containerElem.classList.add($9168155af81732ad$var$cn$n('c'));
        this.element.appendChild(containerElem);
        this.containerElement = containerElem;
    }
}
const $9168155af81732ad$var$cn$m = $9168155af81732ad$var$ClassName('tbi');
class $9168155af81732ad$var$TabItemView {
    constructor(doc, config){
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$m());
        config.viewProps.bindClassModifiers(this.element);
        $9168155af81732ad$var$bindValueMap(config.props, 'selected', (selected)=>{
            if (selected) this.element.classList.add($9168155af81732ad$var$cn$m(undefined, 'sel'));
            else this.element.classList.remove($9168155af81732ad$var$cn$m(undefined, 'sel'));
        });
        const buttonElem = doc.createElement('button');
        buttonElem.classList.add($9168155af81732ad$var$cn$m('b'));
        config.viewProps.bindDisabled(buttonElem);
        this.element.appendChild(buttonElem);
        this.buttonElement = buttonElem;
        const titleElem = doc.createElement('div');
        titleElem.classList.add($9168155af81732ad$var$cn$m('t'));
        $9168155af81732ad$var$bindValueToTextContent(config.props.value('title'), titleElem);
        this.buttonElement.appendChild(titleElem);
        this.titleElement = titleElem;
    }
}
class $9168155af81732ad$var$TabItemController {
    constructor(doc, config){
        this.emitter = new $9168155af81732ad$var$Emitter();
        this.onClick_ = this.onClick_.bind(this);
        this.props = config.props;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$TabItemView(doc, {
            props: config.props,
            viewProps: config.viewProps
        });
        this.view.buttonElement.addEventListener('click', this.onClick_);
    }
    onClick_() {
        this.emitter.emit('click', {
            sender: this
        });
    }
}
class $9168155af81732ad$var$TabPageController extends $9168155af81732ad$var$ContainerBladeController {
    constructor(doc, config){
        const view = new $9168155af81732ad$var$TabPageView(doc, {
            viewProps: config.viewProps
        });
        super(Object.assign(Object.assign({}, config), {
            rackController: new $9168155af81732ad$var$RackController({
                blade: config.blade,
                element: view.containerElement,
                viewProps: config.viewProps
            }),
            view: view
        }));
        this.onItemClick_ = this.onItemClick_.bind(this);
        this.ic_ = new $9168155af81732ad$var$TabItemController(doc, {
            props: config.itemProps,
            viewProps: $9168155af81732ad$var$ViewProps.create()
        });
        this.ic_.emitter.on('click', this.onItemClick_);
        this.props = config.props;
        $9168155af81732ad$var$bindValueMap(this.props, 'selected', (selected)=>{
            this.itemController.props.set('selected', selected);
            this.viewProps.set('hidden', !selected);
        });
    }
    get itemController() {
        return this.ic_;
    }
    importState(state) {
        return $9168155af81732ad$var$importBladeState(state, (s)=>super.importState(s), (p)=>({
                selected: p.required.boolean,
                title: p.required.string
            }), (result)=>{
            this.ic_.props.set('selected', result.selected);
            this.ic_.props.set('title', result.title);
            return true;
        });
    }
    exportState() {
        return $9168155af81732ad$var$exportBladeState(()=>super.exportState(), {
            selected: this.ic_.props.get('selected'),
            title: this.ic_.props.get('title')
        });
    }
    onItemClick_() {
        this.props.set('selected', true);
    }
}
class $9168155af81732ad$export$34b4d752825097c extends $9168155af81732ad$var$ContainerBladeApi {
    constructor(controller, pool){
        super(controller, pool);
        this.emitter_ = new $9168155af81732ad$var$Emitter();
        this.onSelect_ = this.onSelect_.bind(this);
        this.pool_ = pool;
        this.rackApi_.on('change', (ev)=>{
            this.emitter_.emit('change', ev);
        });
        this.controller.tab.selectedIndex.emitter.on('change', this.onSelect_);
    }
    get pages() {
        return this.rackApi_.children;
    }
    addPage(params) {
        const doc = this.controller.view.element.ownerDocument;
        const pc = new $9168155af81732ad$var$TabPageController(doc, {
            blade: $9168155af81732ad$var$createBlade(),
            itemProps: $9168155af81732ad$var$ValueMap.fromObject({
                selected: false,
                title: params.title
            }),
            props: $9168155af81732ad$var$ValueMap.fromObject({
                selected: false
            }),
            viewProps: $9168155af81732ad$var$ViewProps.create()
        });
        const papi = this.pool_.createApi(pc);
        return this.rackApi_.add(papi, params.index);
    }
    removePage(index) {
        this.rackApi_.remove(this.rackApi_.children[index]);
    }
    on(eventName, handler) {
        const bh = handler.bind(this);
        this.emitter_.on(eventName, (ev)=>{
            bh(ev);
        }, {
            key: handler
        });
        return this;
    }
    off(eventName, handler) {
        this.emitter_.off(eventName, handler);
        return this;
    }
    onSelect_(ev) {
        this.emitter_.emit('select', new $9168155af81732ad$var$TpTabSelectEvent(this, ev.rawValue));
    }
}
class $9168155af81732ad$export$cf85417e6b917352 extends $9168155af81732ad$var$ContainerBladeApi {
    get title() {
        var _a;
        return (_a = this.controller.itemController.props.get('title')) !== null && _a !== void 0 ? _a : '';
    }
    set title(title) {
        this.controller.itemController.props.set('title', title);
    }
    get selected() {
        return this.controller.props.get('selected');
    }
    set selected(selected) {
        this.controller.props.set('selected', selected);
    }
    get children() {
        return this.rackApi_.children;
    }
    addButton(params) {
        return this.rackApi_.addButton(params);
    }
    addFolder(params) {
        return this.rackApi_.addFolder(params);
    }
    addTab(params) {
        return this.rackApi_.addTab(params);
    }
    add(api, opt_index) {
        this.rackApi_.add(api, opt_index);
    }
    remove(api) {
        this.rackApi_.remove(api);
    }
    addBinding(object, key, opt_params) {
        return this.rackApi_.addBinding(object, key, opt_params);
    }
    addBlade(params) {
        return this.rackApi_.addBlade(params);
    }
}
const $9168155af81732ad$var$INDEX_NOT_SELECTED = -1;
class $9168155af81732ad$var$Tab {
    constructor(){
        this.onItemSelectedChange_ = this.onItemSelectedChange_.bind(this);
        this.empty = $9168155af81732ad$var$createValue(true);
        this.selectedIndex = $9168155af81732ad$var$createValue($9168155af81732ad$var$INDEX_NOT_SELECTED);
        this.items_ = [];
    }
    add(item, opt_index) {
        const index = opt_index !== null && opt_index !== void 0 ? opt_index : this.items_.length;
        this.items_.splice(index, 0, item);
        item.emitter.on('change', this.onItemSelectedChange_);
        this.keepSelection_();
    }
    remove(item) {
        const index = this.items_.indexOf(item);
        if (index < 0) return;
        this.items_.splice(index, 1);
        item.emitter.off('change', this.onItemSelectedChange_);
        this.keepSelection_();
    }
    keepSelection_() {
        if (this.items_.length === 0) {
            this.selectedIndex.rawValue = $9168155af81732ad$var$INDEX_NOT_SELECTED;
            this.empty.rawValue = true;
            return;
        }
        const firstSelIndex = this.items_.findIndex((s)=>s.rawValue);
        if (firstSelIndex < 0) {
            this.items_.forEach((s, i)=>{
                s.rawValue = i === 0;
            });
            this.selectedIndex.rawValue = 0;
        } else {
            this.items_.forEach((s, i)=>{
                s.rawValue = i === firstSelIndex;
            });
            this.selectedIndex.rawValue = firstSelIndex;
        }
        this.empty.rawValue = false;
    }
    onItemSelectedChange_(ev) {
        if (ev.rawValue) {
            const index = this.items_.findIndex((s)=>s === ev.sender);
            this.items_.forEach((s, i)=>{
                s.rawValue = i === index;
            });
            this.selectedIndex.rawValue = index;
        } else this.keepSelection_();
    }
}
const $9168155af81732ad$var$cn$l = $9168155af81732ad$var$ClassName('tab');
class $9168155af81732ad$var$TabView {
    constructor(doc, config){
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$l(), $9168155af81732ad$var$bladeContainerClassName());
        config.viewProps.bindClassModifiers(this.element);
        $9168155af81732ad$var$bindValue(config.empty, $9168155af81732ad$var$valueToClassName(this.element, $9168155af81732ad$var$cn$l(undefined, 'nop')));
        const titleElem = doc.createElement('div');
        titleElem.classList.add($9168155af81732ad$var$cn$l('t'));
        this.element.appendChild(titleElem);
        this.itemsElement = titleElem;
        const indentElem = doc.createElement('div');
        indentElem.classList.add($9168155af81732ad$var$cn$l('i'));
        this.element.appendChild(indentElem);
        const contentsElem = doc.createElement('div');
        contentsElem.classList.add($9168155af81732ad$var$cn$l('c'));
        this.element.appendChild(contentsElem);
        this.contentsElement = contentsElem;
    }
}
class $9168155af81732ad$var$TabController extends $9168155af81732ad$var$ContainerBladeController {
    constructor(doc, config){
        const tab = new $9168155af81732ad$var$Tab();
        const view = new $9168155af81732ad$var$TabView(doc, {
            empty: tab.empty,
            viewProps: config.viewProps
        });
        super({
            blade: config.blade,
            rackController: new $9168155af81732ad$var$RackController({
                blade: config.blade,
                element: view.contentsElement,
                viewProps: config.viewProps
            }),
            view: view
        });
        this.onRackAdd_ = this.onRackAdd_.bind(this);
        this.onRackRemove_ = this.onRackRemove_.bind(this);
        const rack = this.rackController.rack;
        rack.emitter.on('add', this.onRackAdd_);
        rack.emitter.on('remove', this.onRackRemove_);
        this.tab = tab;
    }
    add(pc, opt_index) {
        this.rackController.rack.add(pc, opt_index);
    }
    remove(index) {
        this.rackController.rack.remove(this.rackController.rack.children[index]);
    }
    onRackAdd_(ev) {
        if (!ev.root) return;
        const pc = ev.bladeController;
        $9168155af81732ad$var$insertElementAt(this.view.itemsElement, pc.itemController.view.element, ev.index);
        pc.itemController.viewProps.set('parent', this.viewProps);
        this.tab.add(pc.props.value('selected'));
    }
    onRackRemove_(ev) {
        if (!ev.root) return;
        const pc = ev.bladeController;
        $9168155af81732ad$var$removeElement(pc.itemController.view.element);
        pc.itemController.viewProps.set('parent', null);
        this.tab.remove(pc.props.value('selected'));
    }
}
const $9168155af81732ad$var$TabBladePlugin = $9168155af81732ad$var$createPlugin({
    id: 'tab',
    type: 'blade',
    accept (params) {
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                pages: p.required.array(p.required.object({
                    title: p.required.string
                })),
                view: p.required.constant('tab')
            }));
        if (!result || result.pages.length === 0) return null;
        return {
            params: result
        };
    },
    controller (args) {
        const c = new $9168155af81732ad$var$TabController(args.document, {
            blade: args.blade,
            viewProps: args.viewProps
        });
        args.params.pages.forEach((p)=>{
            const pc = new $9168155af81732ad$var$TabPageController(args.document, {
                blade: $9168155af81732ad$var$createBlade(),
                itemProps: $9168155af81732ad$var$ValueMap.fromObject({
                    selected: false,
                    title: p.title
                }),
                props: $9168155af81732ad$var$ValueMap.fromObject({
                    selected: false
                }),
                viewProps: $9168155af81732ad$var$ViewProps.create()
            });
            c.add(pc);
        });
        return c;
    },
    api (args) {
        if (args.controller instanceof $9168155af81732ad$var$TabController) return new $9168155af81732ad$export$34b4d752825097c(args.controller, args.pool);
        if (args.controller instanceof $9168155af81732ad$var$TabPageController) return new $9168155af81732ad$export$cf85417e6b917352(args.controller, args.pool);
        return null;
    }
});
function $9168155af81732ad$var$createBladeController(plugin, args) {
    const ac = plugin.accept(args.params);
    if (!ac) return null;
    const params = $9168155af81732ad$var$parseRecord(args.params, (p)=>({
            disabled: p.optional.boolean,
            hidden: p.optional.boolean
        }));
    return plugin.controller({
        blade: $9168155af81732ad$var$createBlade(),
        document: args.document,
        params: $9168155af81732ad$var$forceCast(Object.assign(Object.assign({}, ac.params), {
            disabled: params === null || params === void 0 ? void 0 : params.disabled,
            hidden: params === null || params === void 0 ? void 0 : params.hidden
        })),
        viewProps: $9168155af81732ad$var$ViewProps.create({
            disabled: params === null || params === void 0 ? void 0 : params.disabled,
            hidden: params === null || params === void 0 ? void 0 : params.hidden
        })
    });
}
class $9168155af81732ad$export$fa8cb86ba0150173 extends $9168155af81732ad$var$BindingApi {
    get options() {
        return this.controller.valueController.props.get('options');
    }
    set options(options) {
        this.controller.valueController.props.set('options', options);
    }
}
class $9168155af81732ad$var$ManualTicker {
    constructor(){
        this.disabled = false;
        this.emitter = new $9168155af81732ad$var$Emitter();
    }
    dispose() {}
    tick() {
        if (this.disabled) return;
        this.emitter.emit('tick', {
            sender: this
        });
    }
}
class $9168155af81732ad$var$IntervalTicker {
    constructor(doc, interval){
        this.disabled_ = false;
        this.timerId_ = null;
        this.onTick_ = this.onTick_.bind(this);
        this.doc_ = doc;
        this.emitter = new $9168155af81732ad$var$Emitter();
        this.interval_ = interval;
        this.setTimer_();
    }
    get disabled() {
        return this.disabled_;
    }
    set disabled(inactive) {
        this.disabled_ = inactive;
        if (this.disabled_) this.clearTimer_();
        else this.setTimer_();
    }
    dispose() {
        this.clearTimer_();
    }
    clearTimer_() {
        if (this.timerId_ === null) return;
        const win = this.doc_.defaultView;
        if (win) win.clearInterval(this.timerId_);
        this.timerId_ = null;
    }
    setTimer_() {
        this.clearTimer_();
        if (this.interval_ <= 0) return;
        const win = this.doc_.defaultView;
        if (win) this.timerId_ = win.setInterval(this.onTick_, this.interval_);
    }
    onTick_() {
        if (this.disabled_) return;
        this.emitter.emit('tick', {
            sender: this
        });
    }
}
class $9168155af81732ad$var$CompositeConstraint {
    constructor(constraints){
        this.constraints = constraints;
    }
    constrain(value) {
        return this.constraints.reduce((result, c)=>{
            return c.constrain(result);
        }, value);
    }
}
function $9168155af81732ad$var$findConstraint(c, constraintClass) {
    if (c instanceof constraintClass) return c;
    if (c instanceof $9168155af81732ad$var$CompositeConstraint) {
        const result = c.constraints.reduce((tmpResult, sc)=>{
            if (tmpResult) return tmpResult;
            return sc instanceof constraintClass ? sc : null;
        }, null);
        if (result) return result;
    }
    return null;
}
class $9168155af81732ad$var$ListConstraint {
    constructor(options){
        this.values = $9168155af81732ad$var$ValueMap.fromObject({
            options: options
        });
    }
    constrain(value) {
        const opts = this.values.get('options');
        if (opts.length === 0) return value;
        const matched = opts.filter((item)=>{
            return item.value === value;
        }).length > 0;
        return matched ? value : opts[0].value;
    }
}
function $9168155af81732ad$var$parseListOptions(value) {
    var _a;
    const p = $9168155af81732ad$var$MicroParsers;
    if (Array.isArray(value)) return (_a = $9168155af81732ad$var$parseRecord({
        items: value
    }, (p)=>({
            items: p.required.array(p.required.object({
                text: p.required.string,
                value: p.required.raw
            }))
        }))) === null || _a === void 0 ? void 0 : _a.items;
    if (typeof value === 'object') return p.required.raw(value).value;
    return undefined;
}
function $9168155af81732ad$var$normalizeListOptions(options) {
    if (Array.isArray(options)) return options;
    const items = [];
    Object.keys(options).forEach((text)=>{
        items.push({
            text: text,
            value: options[text]
        });
    });
    return items;
}
function $9168155af81732ad$var$createListConstraint(options) {
    return !$9168155af81732ad$var$isEmpty(options) ? new $9168155af81732ad$var$ListConstraint($9168155af81732ad$var$normalizeListOptions($9168155af81732ad$var$forceCast(options))) : null;
}
const $9168155af81732ad$var$cn$k = $9168155af81732ad$var$ClassName('lst');
class $9168155af81732ad$var$ListView {
    constructor(doc, config){
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.props_ = config.props;
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$k());
        config.viewProps.bindClassModifiers(this.element);
        const selectElem = doc.createElement('select');
        selectElem.classList.add($9168155af81732ad$var$cn$k('s'));
        config.viewProps.bindDisabled(selectElem);
        this.element.appendChild(selectElem);
        this.selectElement = selectElem;
        const markElem = doc.createElement('div');
        markElem.classList.add($9168155af81732ad$var$cn$k('m'));
        markElem.appendChild($9168155af81732ad$var$createSvgIconElement(doc, 'dropdown'));
        this.element.appendChild(markElem);
        config.value.emitter.on('change', this.onValueChange_);
        this.value_ = config.value;
        $9168155af81732ad$var$bindValueMap(this.props_, 'options', (opts)=>{
            $9168155af81732ad$var$removeChildElements(this.selectElement);
            opts.forEach((item)=>{
                const optionElem = doc.createElement('option');
                optionElem.textContent = item.text;
                this.selectElement.appendChild(optionElem);
            });
            this.update_();
        });
    }
    update_() {
        const values = this.props_.get('options').map((o)=>o.value);
        this.selectElement.selectedIndex = values.indexOf(this.value_.rawValue);
    }
    onValueChange_() {
        this.update_();
    }
}
class $9168155af81732ad$var$ListController {
    constructor(doc, config){
        this.onSelectChange_ = this.onSelectChange_.bind(this);
        this.props = config.props;
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$ListView(doc, {
            props: this.props,
            value: this.value,
            viewProps: this.viewProps
        });
        this.view.selectElement.addEventListener('change', this.onSelectChange_);
    }
    onSelectChange_(e) {
        const selectElem = $9168155af81732ad$var$forceCast(e.currentTarget);
        this.value.rawValue = this.props.get('options')[selectElem.selectedIndex].value;
    }
    importProps(state) {
        return $9168155af81732ad$var$importBladeState(state, null, (p)=>({
                options: p.required.custom($9168155af81732ad$var$parseListOptions)
            }), (result)=>{
            this.props.set('options', $9168155af81732ad$var$normalizeListOptions(result.options));
            return true;
        });
    }
    exportProps() {
        return $9168155af81732ad$var$exportBladeState(null, {
            options: this.props.get('options')
        });
    }
}
const $9168155af81732ad$var$cn$j = $9168155af81732ad$var$ClassName('pop');
class $9168155af81732ad$var$PopupView {
    constructor(doc, config){
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$j());
        config.viewProps.bindClassModifiers(this.element);
        $9168155af81732ad$var$bindValue(config.shows, $9168155af81732ad$var$valueToClassName(this.element, $9168155af81732ad$var$cn$j(undefined, 'v')));
    }
}
class $9168155af81732ad$var$PopupController {
    constructor(doc, config){
        this.shows = $9168155af81732ad$var$createValue(false);
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$PopupView(doc, {
            shows: this.shows,
            viewProps: this.viewProps
        });
    }
}
const $9168155af81732ad$var$cn$i = $9168155af81732ad$var$ClassName('txt');
class $9168155af81732ad$var$TextView {
    constructor(doc, config){
        this.onChange_ = this.onChange_.bind(this);
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$i());
        config.viewProps.bindClassModifiers(this.element);
        this.props_ = config.props;
        this.props_.emitter.on('change', this.onChange_);
        const inputElem = doc.createElement('input');
        inputElem.classList.add($9168155af81732ad$var$cn$i('i'));
        inputElem.type = 'text';
        config.viewProps.bindDisabled(inputElem);
        this.element.appendChild(inputElem);
        this.inputElement = inputElem;
        config.value.emitter.on('change', this.onChange_);
        this.value_ = config.value;
        this.refresh();
    }
    refresh() {
        const formatter = this.props_.get('formatter');
        this.inputElement.value = formatter(this.value_.rawValue);
    }
    onChange_() {
        this.refresh();
    }
}
class $9168155af81732ad$var$TextController {
    constructor(doc, config){
        this.onInputChange_ = this.onInputChange_.bind(this);
        this.parser_ = config.parser;
        this.props = config.props;
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$TextView(doc, {
            props: config.props,
            value: this.value,
            viewProps: this.viewProps
        });
        this.view.inputElement.addEventListener('change', this.onInputChange_);
    }
    onInputChange_(e) {
        const inputElem = $9168155af81732ad$var$forceCast(e.currentTarget);
        const value = inputElem.value;
        const parsedValue = this.parser_(value);
        if (!$9168155af81732ad$var$isEmpty(parsedValue)) this.value.rawValue = parsedValue;
        this.view.refresh();
    }
}
function $9168155af81732ad$var$boolToString(value) {
    return String(value);
}
function $9168155af81732ad$var$boolFromUnknown(value) {
    if (value === 'false') return false;
    return !!value;
}
function $9168155af81732ad$var$BooleanFormatter(value) {
    return $9168155af81732ad$var$boolToString(value);
}
function $9168155af81732ad$var$composeParsers(parsers) {
    return (text)=>{
        return parsers.reduce((result, parser)=>{
            if (result !== null) return result;
            return parser(text);
        }, null);
    };
}
const $9168155af81732ad$var$innerFormatter = $9168155af81732ad$var$createNumberFormatter(0);
function $9168155af81732ad$var$formatPercentage(value) {
    return $9168155af81732ad$var$innerFormatter(value) + '%';
}
function $9168155af81732ad$var$stringFromUnknown(value) {
    return String(value);
}
function $9168155af81732ad$var$formatString(value) {
    return value;
}
function $9168155af81732ad$var$connectValues({ primary: primary, secondary: secondary, forward: forward, backward: backward }) {
    let changing = false;
    function preventFeedback(callback) {
        if (changing) return;
        changing = true;
        callback();
        changing = false;
    }
    primary.emitter.on('change', (ev)=>{
        preventFeedback(()=>{
            secondary.setRawValue(forward(primary.rawValue, secondary.rawValue), ev.options);
        });
    });
    secondary.emitter.on('change', (ev)=>{
        preventFeedback(()=>{
            primary.setRawValue(backward(primary.rawValue, secondary.rawValue), ev.options);
        });
        preventFeedback(()=>{
            secondary.setRawValue(forward(primary.rawValue, secondary.rawValue), ev.options);
        });
    });
    preventFeedback(()=>{
        secondary.setRawValue(forward(primary.rawValue, secondary.rawValue), {
            forceEmit: false,
            last: true
        });
    });
}
function $9168155af81732ad$var$getStepForKey(keyScale, keys) {
    const step = keyScale * (keys.altKey ? 0.1 : 1) * (keys.shiftKey ? 10 : 1);
    if (keys.upKey) return +step;
    else if (keys.downKey) return -step;
    return 0;
}
function $9168155af81732ad$var$getVerticalStepKeys(ev) {
    return {
        altKey: ev.altKey,
        downKey: ev.key === 'ArrowDown',
        shiftKey: ev.shiftKey,
        upKey: ev.key === 'ArrowUp'
    };
}
function $9168155af81732ad$var$getHorizontalStepKeys(ev) {
    return {
        altKey: ev.altKey,
        downKey: ev.key === 'ArrowLeft',
        shiftKey: ev.shiftKey,
        upKey: ev.key === 'ArrowRight'
    };
}
function $9168155af81732ad$var$isVerticalArrowKey(key) {
    return key === 'ArrowUp' || key === 'ArrowDown';
}
function $9168155af81732ad$var$isArrowKey(key) {
    return $9168155af81732ad$var$isVerticalArrowKey(key) || key === 'ArrowLeft' || key === 'ArrowRight';
}
function $9168155af81732ad$var$computeOffset$1(ev, elem) {
    var _a, _b;
    const win = elem.ownerDocument.defaultView;
    const rect = elem.getBoundingClientRect();
    return {
        x: ev.pageX - (((_a = win && win.scrollX) !== null && _a !== void 0 ? _a : 0) + rect.left),
        y: ev.pageY - (((_b = win && win.scrollY) !== null && _b !== void 0 ? _b : 0) + rect.top)
    };
}
class $9168155af81732ad$var$PointerHandler {
    constructor(element){
        this.lastTouch_ = null;
        this.onDocumentMouseMove_ = this.onDocumentMouseMove_.bind(this);
        this.onDocumentMouseUp_ = this.onDocumentMouseUp_.bind(this);
        this.onMouseDown_ = this.onMouseDown_.bind(this);
        this.onTouchEnd_ = this.onTouchEnd_.bind(this);
        this.onTouchMove_ = this.onTouchMove_.bind(this);
        this.onTouchStart_ = this.onTouchStart_.bind(this);
        this.elem_ = element;
        this.emitter = new $9168155af81732ad$var$Emitter();
        element.addEventListener('touchstart', this.onTouchStart_, {
            passive: false
        });
        element.addEventListener('touchmove', this.onTouchMove_, {
            passive: true
        });
        element.addEventListener('touchend', this.onTouchEnd_);
        element.addEventListener('mousedown', this.onMouseDown_);
    }
    computePosition_(offset) {
        const rect = this.elem_.getBoundingClientRect();
        return {
            bounds: {
                width: rect.width,
                height: rect.height
            },
            point: offset ? {
                x: offset.x,
                y: offset.y
            } : null
        };
    }
    onMouseDown_(ev) {
        var _a;
        ev.preventDefault();
        (_a = ev.currentTarget) === null || _a === void 0 || _a.focus();
        const doc = this.elem_.ownerDocument;
        doc.addEventListener('mousemove', this.onDocumentMouseMove_);
        doc.addEventListener('mouseup', this.onDocumentMouseUp_);
        this.emitter.emit('down', {
            altKey: ev.altKey,
            data: this.computePosition_($9168155af81732ad$var$computeOffset$1(ev, this.elem_)),
            sender: this,
            shiftKey: ev.shiftKey
        });
    }
    onDocumentMouseMove_(ev) {
        this.emitter.emit('move', {
            altKey: ev.altKey,
            data: this.computePosition_($9168155af81732ad$var$computeOffset$1(ev, this.elem_)),
            sender: this,
            shiftKey: ev.shiftKey
        });
    }
    onDocumentMouseUp_(ev) {
        const doc = this.elem_.ownerDocument;
        doc.removeEventListener('mousemove', this.onDocumentMouseMove_);
        doc.removeEventListener('mouseup', this.onDocumentMouseUp_);
        this.emitter.emit('up', {
            altKey: ev.altKey,
            data: this.computePosition_($9168155af81732ad$var$computeOffset$1(ev, this.elem_)),
            sender: this,
            shiftKey: ev.shiftKey
        });
    }
    onTouchStart_(ev) {
        ev.preventDefault();
        const touch = ev.targetTouches.item(0);
        const rect = this.elem_.getBoundingClientRect();
        this.emitter.emit('down', {
            altKey: ev.altKey,
            data: this.computePosition_(touch ? {
                x: touch.clientX - rect.left,
                y: touch.clientY - rect.top
            } : undefined),
            sender: this,
            shiftKey: ev.shiftKey
        });
        this.lastTouch_ = touch;
    }
    onTouchMove_(ev) {
        const touch = ev.targetTouches.item(0);
        const rect = this.elem_.getBoundingClientRect();
        this.emitter.emit('move', {
            altKey: ev.altKey,
            data: this.computePosition_(touch ? {
                x: touch.clientX - rect.left,
                y: touch.clientY - rect.top
            } : undefined),
            sender: this,
            shiftKey: ev.shiftKey
        });
        this.lastTouch_ = touch;
    }
    onTouchEnd_(ev) {
        var _a;
        const touch = (_a = ev.targetTouches.item(0)) !== null && _a !== void 0 ? _a : this.lastTouch_;
        const rect = this.elem_.getBoundingClientRect();
        this.emitter.emit('up', {
            altKey: ev.altKey,
            data: this.computePosition_(touch ? {
                x: touch.clientX - rect.left,
                y: touch.clientY - rect.top
            } : undefined),
            sender: this,
            shiftKey: ev.shiftKey
        });
    }
}
const $9168155af81732ad$var$cn$h = $9168155af81732ad$var$ClassName('txt');
class $9168155af81732ad$var$NumberTextView {
    constructor(doc, config){
        this.onChange_ = this.onChange_.bind(this);
        this.props_ = config.props;
        this.props_.emitter.on('change', this.onChange_);
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$h(), $9168155af81732ad$var$cn$h(undefined, 'num'));
        if (config.arrayPosition) this.element.classList.add($9168155af81732ad$var$cn$h(undefined, config.arrayPosition));
        config.viewProps.bindClassModifiers(this.element);
        const inputElem = doc.createElement('input');
        inputElem.classList.add($9168155af81732ad$var$cn$h('i'));
        inputElem.type = 'text';
        config.viewProps.bindDisabled(inputElem);
        this.element.appendChild(inputElem);
        this.inputElement = inputElem;
        this.onDraggingChange_ = this.onDraggingChange_.bind(this);
        this.dragging_ = config.dragging;
        this.dragging_.emitter.on('change', this.onDraggingChange_);
        this.element.classList.add($9168155af81732ad$var$cn$h());
        this.inputElement.classList.add($9168155af81732ad$var$cn$h('i'));
        const knobElem = doc.createElement('div');
        knobElem.classList.add($9168155af81732ad$var$cn$h('k'));
        this.element.appendChild(knobElem);
        this.knobElement = knobElem;
        const guideElem = doc.createElementNS($9168155af81732ad$var$SVG_NS, 'svg');
        guideElem.classList.add($9168155af81732ad$var$cn$h('g'));
        this.knobElement.appendChild(guideElem);
        const bodyElem = doc.createElementNS($9168155af81732ad$var$SVG_NS, 'path');
        bodyElem.classList.add($9168155af81732ad$var$cn$h('gb'));
        guideElem.appendChild(bodyElem);
        this.guideBodyElem_ = bodyElem;
        const headElem = doc.createElementNS($9168155af81732ad$var$SVG_NS, 'path');
        headElem.classList.add($9168155af81732ad$var$cn$h('gh'));
        guideElem.appendChild(headElem);
        this.guideHeadElem_ = headElem;
        const tooltipElem = doc.createElement('div');
        tooltipElem.classList.add($9168155af81732ad$var$ClassName('tt')());
        this.knobElement.appendChild(tooltipElem);
        this.tooltipElem_ = tooltipElem;
        config.value.emitter.on('change', this.onChange_);
        this.value = config.value;
        this.refresh();
    }
    onDraggingChange_(ev) {
        if (ev.rawValue === null) {
            this.element.classList.remove($9168155af81732ad$var$cn$h(undefined, 'drg'));
            return;
        }
        this.element.classList.add($9168155af81732ad$var$cn$h(undefined, 'drg'));
        const x = ev.rawValue / this.props_.get('pointerScale');
        const aox = x + (x > 0 ? -1 : x < 0 ? 1 : 0);
        const adx = $9168155af81732ad$var$constrainRange(-aox, -4, 4);
        this.guideHeadElem_.setAttributeNS(null, 'd', [
            `M ${aox + adx},0 L${aox},4 L${aox + adx},8`,
            `M ${x},-1 L${x},9`
        ].join(' '));
        this.guideBodyElem_.setAttributeNS(null, 'd', `M 0,4 L${x},4`);
        const formatter = this.props_.get('formatter');
        this.tooltipElem_.textContent = formatter(this.value.rawValue);
        this.tooltipElem_.style.left = `${x}px`;
    }
    refresh() {
        const formatter = this.props_.get('formatter');
        this.inputElement.value = formatter(this.value.rawValue);
    }
    onChange_() {
        this.refresh();
    }
}
class $9168155af81732ad$var$NumberTextController {
    constructor(doc, config){
        var _a;
        this.originRawValue_ = 0;
        this.onInputChange_ = this.onInputChange_.bind(this);
        this.onInputKeyDown_ = this.onInputKeyDown_.bind(this);
        this.onInputKeyUp_ = this.onInputKeyUp_.bind(this);
        this.onPointerDown_ = this.onPointerDown_.bind(this);
        this.onPointerMove_ = this.onPointerMove_.bind(this);
        this.onPointerUp_ = this.onPointerUp_.bind(this);
        this.parser_ = config.parser;
        this.props = config.props;
        this.sliderProps_ = (_a = config.sliderProps) !== null && _a !== void 0 ? _a : null;
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.dragging_ = $9168155af81732ad$var$createValue(null);
        this.view = new $9168155af81732ad$var$NumberTextView(doc, {
            arrayPosition: config.arrayPosition,
            dragging: this.dragging_,
            props: this.props,
            value: this.value,
            viewProps: this.viewProps
        });
        this.view.inputElement.addEventListener('change', this.onInputChange_);
        this.view.inputElement.addEventListener('keydown', this.onInputKeyDown_);
        this.view.inputElement.addEventListener('keyup', this.onInputKeyUp_);
        const ph = new $9168155af81732ad$var$PointerHandler(this.view.knobElement);
        ph.emitter.on('down', this.onPointerDown_);
        ph.emitter.on('move', this.onPointerMove_);
        ph.emitter.on('up', this.onPointerUp_);
    }
    constrainValue_(value) {
        var _a, _b;
        const min = (_a = this.sliderProps_) === null || _a === void 0 ? void 0 : _a.get('min');
        const max = (_b = this.sliderProps_) === null || _b === void 0 ? void 0 : _b.get('max');
        let v = value;
        if (min !== undefined) v = Math.max(v, min);
        if (max !== undefined) v = Math.min(v, max);
        return v;
    }
    onInputChange_(e) {
        const inputElem = $9168155af81732ad$var$forceCast(e.currentTarget);
        const value = inputElem.value;
        const parsedValue = this.parser_(value);
        if (!$9168155af81732ad$var$isEmpty(parsedValue)) this.value.rawValue = this.constrainValue_(parsedValue);
        this.view.refresh();
    }
    onInputKeyDown_(ev) {
        const step = $9168155af81732ad$var$getStepForKey(this.props.get('keyScale'), $9168155af81732ad$var$getVerticalStepKeys(ev));
        if (step === 0) return;
        this.value.setRawValue(this.constrainValue_(this.value.rawValue + step), {
            forceEmit: false,
            last: false
        });
    }
    onInputKeyUp_(ev) {
        const step = $9168155af81732ad$var$getStepForKey(this.props.get('keyScale'), $9168155af81732ad$var$getVerticalStepKeys(ev));
        if (step === 0) return;
        this.value.setRawValue(this.value.rawValue, {
            forceEmit: true,
            last: true
        });
    }
    onPointerDown_() {
        this.originRawValue_ = this.value.rawValue;
        this.dragging_.rawValue = 0;
    }
    computeDraggingValue_(data) {
        if (!data.point) return null;
        const dx = data.point.x - data.bounds.width / 2;
        return this.constrainValue_(this.originRawValue_ + dx * this.props.get('pointerScale'));
    }
    onPointerMove_(ev) {
        const v = this.computeDraggingValue_(ev.data);
        if (v === null) return;
        this.value.setRawValue(v, {
            forceEmit: false,
            last: false
        });
        this.dragging_.rawValue = this.value.rawValue - this.originRawValue_;
    }
    onPointerUp_(ev) {
        const v = this.computeDraggingValue_(ev.data);
        if (v === null) return;
        this.value.setRawValue(v, {
            forceEmit: true,
            last: true
        });
        this.dragging_.rawValue = null;
    }
}
const $9168155af81732ad$var$cn$g = $9168155af81732ad$var$ClassName('sld');
class $9168155af81732ad$var$SliderView {
    constructor(doc, config){
        this.onChange_ = this.onChange_.bind(this);
        this.props_ = config.props;
        this.props_.emitter.on('change', this.onChange_);
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$g());
        config.viewProps.bindClassModifiers(this.element);
        const trackElem = doc.createElement('div');
        trackElem.classList.add($9168155af81732ad$var$cn$g('t'));
        config.viewProps.bindTabIndex(trackElem);
        this.element.appendChild(trackElem);
        this.trackElement = trackElem;
        const knobElem = doc.createElement('div');
        knobElem.classList.add($9168155af81732ad$var$cn$g('k'));
        this.trackElement.appendChild(knobElem);
        this.knobElement = knobElem;
        config.value.emitter.on('change', this.onChange_);
        this.value = config.value;
        this.update_();
    }
    update_() {
        const p = $9168155af81732ad$var$constrainRange($9168155af81732ad$var$mapRange(this.value.rawValue, this.props_.get('min'), this.props_.get('max'), 0, 100), 0, 100);
        this.knobElement.style.width = `${p}%`;
    }
    onChange_() {
        this.update_();
    }
}
class $9168155af81732ad$var$SliderController {
    constructor(doc, config){
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.onKeyUp_ = this.onKeyUp_.bind(this);
        this.onPointerDownOrMove_ = this.onPointerDownOrMove_.bind(this);
        this.onPointerUp_ = this.onPointerUp_.bind(this);
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.props = config.props;
        this.view = new $9168155af81732ad$var$SliderView(doc, {
            props: this.props,
            value: this.value,
            viewProps: this.viewProps
        });
        this.ptHandler_ = new $9168155af81732ad$var$PointerHandler(this.view.trackElement);
        this.ptHandler_.emitter.on('down', this.onPointerDownOrMove_);
        this.ptHandler_.emitter.on('move', this.onPointerDownOrMove_);
        this.ptHandler_.emitter.on('up', this.onPointerUp_);
        this.view.trackElement.addEventListener('keydown', this.onKeyDown_);
        this.view.trackElement.addEventListener('keyup', this.onKeyUp_);
    }
    handlePointerEvent_(d, opts) {
        if (!d.point) return;
        this.value.setRawValue($9168155af81732ad$var$mapRange($9168155af81732ad$var$constrainRange(d.point.x, 0, d.bounds.width), 0, d.bounds.width, this.props.get('min'), this.props.get('max')), opts);
    }
    onPointerDownOrMove_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: false,
            last: false
        });
    }
    onPointerUp_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: true,
            last: true
        });
    }
    onKeyDown_(ev) {
        const step = $9168155af81732ad$var$getStepForKey(this.props.get('keyScale'), $9168155af81732ad$var$getHorizontalStepKeys(ev));
        if (step === 0) return;
        this.value.setRawValue(this.value.rawValue + step, {
            forceEmit: false,
            last: false
        });
    }
    onKeyUp_(ev) {
        const step = $9168155af81732ad$var$getStepForKey(this.props.get('keyScale'), $9168155af81732ad$var$getHorizontalStepKeys(ev));
        if (step === 0) return;
        this.value.setRawValue(this.value.rawValue, {
            forceEmit: true,
            last: true
        });
    }
}
const $9168155af81732ad$var$cn$f = $9168155af81732ad$var$ClassName('sldtxt');
class $9168155af81732ad$var$SliderTextView {
    constructor(doc, config){
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$f());
        const sliderElem = doc.createElement('div');
        sliderElem.classList.add($9168155af81732ad$var$cn$f('s'));
        this.sliderView_ = config.sliderView;
        sliderElem.appendChild(this.sliderView_.element);
        this.element.appendChild(sliderElem);
        const textElem = doc.createElement('div');
        textElem.classList.add($9168155af81732ad$var$cn$f('t'));
        this.textView_ = config.textView;
        textElem.appendChild(this.textView_.element);
        this.element.appendChild(textElem);
    }
}
class $9168155af81732ad$var$SliderTextController {
    constructor(doc, config){
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.sliderC_ = new $9168155af81732ad$var$SliderController(doc, {
            props: config.sliderProps,
            value: config.value,
            viewProps: this.viewProps
        });
        this.textC_ = new $9168155af81732ad$var$NumberTextController(doc, {
            parser: config.parser,
            props: config.textProps,
            sliderProps: config.sliderProps,
            value: config.value,
            viewProps: config.viewProps
        });
        this.view = new $9168155af81732ad$var$SliderTextView(doc, {
            sliderView: this.sliderC_.view,
            textView: this.textC_.view
        });
    }
    get sliderController() {
        return this.sliderC_;
    }
    get textController() {
        return this.textC_;
    }
    importProps(state) {
        return $9168155af81732ad$var$importBladeState(state, null, (p)=>({
                max: p.required.number,
                min: p.required.number
            }), (result)=>{
            const sliderProps = this.sliderC_.props;
            sliderProps.set('max', result.max);
            sliderProps.set('min', result.min);
            return true;
        });
    }
    exportProps() {
        const sliderProps = this.sliderC_.props;
        return $9168155af81732ad$var$exportBladeState(null, {
            max: sliderProps.get('max'),
            min: sliderProps.get('min')
        });
    }
}
function $9168155af81732ad$var$createSliderTextProps(config) {
    return {
        sliderProps: new $9168155af81732ad$var$ValueMap({
            keyScale: config.keyScale,
            max: config.max,
            min: config.min
        }),
        textProps: new $9168155af81732ad$var$ValueMap({
            formatter: $9168155af81732ad$var$createValue(config.formatter),
            keyScale: config.keyScale,
            pointerScale: $9168155af81732ad$var$createValue(config.pointerScale)
        })
    };
}
const $9168155af81732ad$var$CSS_VAR_MAP = {
    containerUnitSize: 'cnt-usz'
};
function $9168155af81732ad$var$getCssVar(key) {
    return `--${$9168155af81732ad$var$CSS_VAR_MAP[key]}`;
}
function $9168155af81732ad$var$createPointDimensionParser(p) {
    return $9168155af81732ad$var$createNumberTextInputParamsParser(p);
}
function $9168155af81732ad$var$parsePointDimensionParams(value) {
    if (!$9168155af81732ad$var$isRecord(value)) return undefined;
    return $9168155af81732ad$var$parseRecord(value, $9168155af81732ad$var$createPointDimensionParser);
}
function $9168155af81732ad$var$createDimensionConstraint(params, initialValue) {
    if (!params) return undefined;
    const constraints = [];
    const cs = $9168155af81732ad$var$createStepConstraint(params, initialValue);
    if (cs) constraints.push(cs);
    const rs = $9168155af81732ad$var$createRangeConstraint(params);
    if (rs) constraints.push(rs);
    return new $9168155af81732ad$var$CompositeConstraint(constraints);
}
function $9168155af81732ad$var$isCompatible(ver) {
    if (!ver) return false;
    return ver.major === $9168155af81732ad$var$VERSION$1.major;
}
function $9168155af81732ad$var$parsePickerLayout(value) {
    if (value === 'inline' || value === 'popup') return value;
    return undefined;
}
function $9168155af81732ad$var$writePrimitive(target, value) {
    target.write(value);
}
const $9168155af81732ad$var$cn$e = $9168155af81732ad$var$ClassName('ckb');
class $9168155af81732ad$var$CheckboxView {
    constructor(doc, config){
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$e());
        config.viewProps.bindClassModifiers(this.element);
        const labelElem = doc.createElement('label');
        labelElem.classList.add($9168155af81732ad$var$cn$e('l'));
        this.element.appendChild(labelElem);
        this.labelElement = labelElem;
        const inputElem = doc.createElement('input');
        inputElem.classList.add($9168155af81732ad$var$cn$e('i'));
        inputElem.type = 'checkbox';
        this.labelElement.appendChild(inputElem);
        this.inputElement = inputElem;
        config.viewProps.bindDisabled(this.inputElement);
        const wrapperElem = doc.createElement('div');
        wrapperElem.classList.add($9168155af81732ad$var$cn$e('w'));
        this.labelElement.appendChild(wrapperElem);
        const markElem = $9168155af81732ad$var$createSvgIconElement(doc, 'check');
        wrapperElem.appendChild(markElem);
        config.value.emitter.on('change', this.onValueChange_);
        this.value = config.value;
        this.update_();
    }
    update_() {
        this.inputElement.checked = this.value.rawValue;
    }
    onValueChange_() {
        this.update_();
    }
}
class $9168155af81732ad$var$CheckboxController {
    constructor(doc, config){
        this.onInputChange_ = this.onInputChange_.bind(this);
        this.onLabelMouseDown_ = this.onLabelMouseDown_.bind(this);
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$CheckboxView(doc, {
            value: this.value,
            viewProps: this.viewProps
        });
        this.view.inputElement.addEventListener('change', this.onInputChange_);
        this.view.labelElement.addEventListener('mousedown', this.onLabelMouseDown_);
    }
    onInputChange_(ev) {
        const inputElem = $9168155af81732ad$var$forceCast(ev.currentTarget);
        this.value.rawValue = inputElem.checked;
        ev.preventDefault();
        ev.stopPropagation();
    }
    onLabelMouseDown_(ev) {
        ev.preventDefault();
    }
}
function $9168155af81732ad$var$createConstraint$6(params) {
    const constraints = [];
    const lc = $9168155af81732ad$var$createListConstraint(params.options);
    if (lc) constraints.push(lc);
    return new $9168155af81732ad$var$CompositeConstraint(constraints);
}
const $9168155af81732ad$var$BooleanInputPlugin = $9168155af81732ad$var$createPlugin({
    id: 'input-bool',
    type: 'input',
    accept: (value, params)=>{
        if (typeof value !== 'boolean') return null;
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                options: p.optional.custom($9168155af81732ad$var$parseListOptions),
                readonly: p.optional.constant(false)
            }));
        return result ? {
            initialValue: value,
            params: result
        } : null;
    },
    binding: {
        reader: (_args)=>$9168155af81732ad$var$boolFromUnknown,
        constraint: (args)=>$9168155af81732ad$var$createConstraint$6(args.params),
        writer: (_args)=>$9168155af81732ad$var$writePrimitive
    },
    controller: (args)=>{
        const doc = args.document;
        const value = args.value;
        const c = args.constraint;
        const lc = c && $9168155af81732ad$var$findConstraint(c, $9168155af81732ad$var$ListConstraint);
        if (lc) return new $9168155af81732ad$var$ListController(doc, {
            props: new $9168155af81732ad$var$ValueMap({
                options: lc.values.value('options')
            }),
            value: value,
            viewProps: args.viewProps
        });
        return new $9168155af81732ad$var$CheckboxController(doc, {
            value: value,
            viewProps: args.viewProps
        });
    },
    api (args) {
        if (typeof args.controller.value.rawValue !== 'boolean') return null;
        if (args.controller.valueController instanceof $9168155af81732ad$var$ListController) return new $9168155af81732ad$export$fa8cb86ba0150173(args.controller);
        return null;
    }
});
const $9168155af81732ad$var$cn$d = $9168155af81732ad$var$ClassName('col');
class $9168155af81732ad$var$ColorView {
    constructor(doc, config){
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$d());
        config.foldable.bindExpandedClass(this.element, $9168155af81732ad$var$cn$d(undefined, 'expanded'));
        $9168155af81732ad$var$bindValueMap(config.foldable, 'completed', $9168155af81732ad$var$valueToClassName(this.element, $9168155af81732ad$var$cn$d(undefined, 'cpl')));
        const headElem = doc.createElement('div');
        headElem.classList.add($9168155af81732ad$var$cn$d('h'));
        this.element.appendChild(headElem);
        const swatchElem = doc.createElement('div');
        swatchElem.classList.add($9168155af81732ad$var$cn$d('s'));
        headElem.appendChild(swatchElem);
        this.swatchElement = swatchElem;
        const textElem = doc.createElement('div');
        textElem.classList.add($9168155af81732ad$var$cn$d('t'));
        headElem.appendChild(textElem);
        this.textElement = textElem;
        if (config.pickerLayout === 'inline') {
            const pickerElem = doc.createElement('div');
            pickerElem.classList.add($9168155af81732ad$var$cn$d('p'));
            this.element.appendChild(pickerElem);
            this.pickerElement = pickerElem;
        } else this.pickerElement = null;
    }
}
function $9168155af81732ad$var$rgbToHslInt(r, g, b) {
    const rp = $9168155af81732ad$var$constrainRange(r / 255, 0, 1);
    const gp = $9168155af81732ad$var$constrainRange(g / 255, 0, 1);
    const bp = $9168155af81732ad$var$constrainRange(b / 255, 0, 1);
    const cmax = Math.max(rp, gp, bp);
    const cmin = Math.min(rp, gp, bp);
    const c = cmax - cmin;
    let h = 0;
    let s = 0;
    const l = (cmin + cmax) / 2;
    if (c !== 0) {
        s = c / (1 - Math.abs(cmax + cmin - 1));
        if (rp === cmax) h = (gp - bp) / c;
        else if (gp === cmax) h = 2 + (bp - rp) / c;
        else h = 4 + (rp - gp) / c;
        h = h / 6 + (h < 0 ? 1 : 0);
    }
    return [
        h * 360,
        s * 100,
        l * 100
    ];
}
function $9168155af81732ad$var$hslToRgbInt(h, s, l) {
    const hp = (h % 360 + 360) % 360;
    const sp = $9168155af81732ad$var$constrainRange(s / 100, 0, 1);
    const lp = $9168155af81732ad$var$constrainRange(l / 100, 0, 1);
    const c = (1 - Math.abs(2 * lp - 1)) * sp;
    const x = c * (1 - Math.abs(hp / 60 % 2 - 1));
    const m = lp - c / 2;
    let rp, gp, bp;
    if (hp >= 0 && hp < 60) [rp, gp, bp] = [
        c,
        x,
        0
    ];
    else if (hp >= 60 && hp < 120) [rp, gp, bp] = [
        x,
        c,
        0
    ];
    else if (hp >= 120 && hp < 180) [rp, gp, bp] = [
        0,
        c,
        x
    ];
    else if (hp >= 180 && hp < 240) [rp, gp, bp] = [
        0,
        x,
        c
    ];
    else if (hp >= 240 && hp < 300) [rp, gp, bp] = [
        x,
        0,
        c
    ];
    else [rp, gp, bp] = [
        c,
        0,
        x
    ];
    return [
        (rp + m) * 255,
        (gp + m) * 255,
        (bp + m) * 255
    ];
}
function $9168155af81732ad$var$rgbToHsvInt(r, g, b) {
    const rp = $9168155af81732ad$var$constrainRange(r / 255, 0, 1);
    const gp = $9168155af81732ad$var$constrainRange(g / 255, 0, 1);
    const bp = $9168155af81732ad$var$constrainRange(b / 255, 0, 1);
    const cmax = Math.max(rp, gp, bp);
    const cmin = Math.min(rp, gp, bp);
    const d = cmax - cmin;
    let h;
    if (d === 0) h = 0;
    else if (cmax === rp) h = 60 * (((gp - bp) / d % 6 + 6) % 6);
    else if (cmax === gp) h = 60 * ((bp - rp) / d + 2);
    else h = 60 * ((rp - gp) / d + 4);
    const s = cmax === 0 ? 0 : d / cmax;
    const v = cmax;
    return [
        h,
        s * 100,
        v * 100
    ];
}
function $9168155af81732ad$var$hsvToRgbInt(h, s, v) {
    const hp = $9168155af81732ad$var$loopRange(h, 360);
    const sp = $9168155af81732ad$var$constrainRange(s / 100, 0, 1);
    const vp = $9168155af81732ad$var$constrainRange(v / 100, 0, 1);
    const c = vp * sp;
    const x = c * (1 - Math.abs(hp / 60 % 2 - 1));
    const m = vp - c;
    let rp, gp, bp;
    if (hp >= 0 && hp < 60) [rp, gp, bp] = [
        c,
        x,
        0
    ];
    else if (hp >= 60 && hp < 120) [rp, gp, bp] = [
        x,
        c,
        0
    ];
    else if (hp >= 120 && hp < 180) [rp, gp, bp] = [
        0,
        c,
        x
    ];
    else if (hp >= 180 && hp < 240) [rp, gp, bp] = [
        0,
        x,
        c
    ];
    else if (hp >= 240 && hp < 300) [rp, gp, bp] = [
        x,
        0,
        c
    ];
    else [rp, gp, bp] = [
        c,
        0,
        x
    ];
    return [
        (rp + m) * 255,
        (gp + m) * 255,
        (bp + m) * 255
    ];
}
function $9168155af81732ad$var$hslToHsvInt(h, s, l) {
    const sd = l + s * (100 - Math.abs(2 * l - 100)) / 200;
    return [
        h,
        sd !== 0 ? s * (100 - Math.abs(2 * l - 100)) / sd : 0,
        l + s * (100 - Math.abs(2 * l - 100)) / 200
    ];
}
function $9168155af81732ad$var$hsvToHslInt(h, s, v) {
    const sd = 100 - Math.abs(v * (200 - s) / 100 - 100);
    return [
        h,
        sd !== 0 ? s * v / sd : 0,
        v * (200 - s) / 200
    ];
}
function $9168155af81732ad$var$removeAlphaComponent(comps) {
    return [
        comps[0],
        comps[1],
        comps[2]
    ];
}
function $9168155af81732ad$var$appendAlphaComponent(comps, alpha) {
    return [
        comps[0],
        comps[1],
        comps[2],
        alpha
    ];
}
const $9168155af81732ad$var$MODE_CONVERTER_MAP = {
    hsl: {
        hsl: (h, s, l)=>[
                h,
                s,
                l
            ],
        hsv: $9168155af81732ad$var$hslToHsvInt,
        rgb: $9168155af81732ad$var$hslToRgbInt
    },
    hsv: {
        hsl: $9168155af81732ad$var$hsvToHslInt,
        hsv: (h, s, v)=>[
                h,
                s,
                v
            ],
        rgb: $9168155af81732ad$var$hsvToRgbInt
    },
    rgb: {
        hsl: $9168155af81732ad$var$rgbToHslInt,
        hsv: $9168155af81732ad$var$rgbToHsvInt,
        rgb: (r, g, b)=>[
                r,
                g,
                b
            ]
    }
};
function $9168155af81732ad$var$getColorMaxComponents(mode, type) {
    return [
        type === 'float' ? 1 : mode === 'rgb' ? 255 : 360,
        type === 'float' ? 1 : mode === 'rgb' ? 255 : 100,
        type === 'float' ? 1 : mode === 'rgb' ? 255 : 100
    ];
}
function $9168155af81732ad$var$loopHueRange(hue, max) {
    return hue === max ? max : $9168155af81732ad$var$loopRange(hue, max);
}
function $9168155af81732ad$var$constrainColorComponents(components, mode, type) {
    var _a;
    const ms = $9168155af81732ad$var$getColorMaxComponents(mode, type);
    return [
        mode === 'rgb' ? $9168155af81732ad$var$constrainRange(components[0], 0, ms[0]) : $9168155af81732ad$var$loopHueRange(components[0], ms[0]),
        $9168155af81732ad$var$constrainRange(components[1], 0, ms[1]),
        $9168155af81732ad$var$constrainRange(components[2], 0, ms[2]),
        $9168155af81732ad$var$constrainRange((_a = components[3]) !== null && _a !== void 0 ? _a : 1, 0, 1)
    ];
}
function $9168155af81732ad$var$convertColorType(comps, mode, from, to) {
    const fms = $9168155af81732ad$var$getColorMaxComponents(mode, from);
    const tms = $9168155af81732ad$var$getColorMaxComponents(mode, to);
    return comps.map((c, index)=>c / fms[index] * tms[index]);
}
function $9168155af81732ad$var$convertColor(components, from, to) {
    const intComps = $9168155af81732ad$var$convertColorType(components, from.mode, from.type, 'int');
    const result = $9168155af81732ad$var$MODE_CONVERTER_MAP[from.mode][to.mode](...intComps);
    return $9168155af81732ad$var$convertColorType(result, to.mode, 'int', to.type);
}
class $9168155af81732ad$var$IntColor {
    static black() {
        return new $9168155af81732ad$var$IntColor([
            0,
            0,
            0
        ], 'rgb');
    }
    constructor(comps, mode){
        this.type = 'int';
        this.mode = mode;
        this.comps_ = $9168155af81732ad$var$constrainColorComponents(comps, mode, this.type);
    }
    getComponents(opt_mode) {
        return $9168155af81732ad$var$appendAlphaComponent($9168155af81732ad$var$convertColor($9168155af81732ad$var$removeAlphaComponent(this.comps_), {
            mode: this.mode,
            type: this.type
        }, {
            mode: opt_mode !== null && opt_mode !== void 0 ? opt_mode : this.mode,
            type: this.type
        }), this.comps_[3]);
    }
    toRgbaObject() {
        const rgbComps = this.getComponents('rgb');
        return {
            r: rgbComps[0],
            g: rgbComps[1],
            b: rgbComps[2],
            a: rgbComps[3]
        };
    }
}
const $9168155af81732ad$var$cn$c = $9168155af81732ad$var$ClassName('colp');
class $9168155af81732ad$var$ColorPickerView {
    constructor(doc, config){
        this.alphaViews_ = null;
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$c());
        config.viewProps.bindClassModifiers(this.element);
        const hsvElem = doc.createElement('div');
        hsvElem.classList.add($9168155af81732ad$var$cn$c('hsv'));
        const svElem = doc.createElement('div');
        svElem.classList.add($9168155af81732ad$var$cn$c('sv'));
        this.svPaletteView_ = config.svPaletteView;
        svElem.appendChild(this.svPaletteView_.element);
        hsvElem.appendChild(svElem);
        const hElem = doc.createElement('div');
        hElem.classList.add($9168155af81732ad$var$cn$c('h'));
        this.hPaletteView_ = config.hPaletteView;
        hElem.appendChild(this.hPaletteView_.element);
        hsvElem.appendChild(hElem);
        this.element.appendChild(hsvElem);
        const rgbElem = doc.createElement('div');
        rgbElem.classList.add($9168155af81732ad$var$cn$c('rgb'));
        this.textsView_ = config.textsView;
        rgbElem.appendChild(this.textsView_.element);
        this.element.appendChild(rgbElem);
        if (config.alphaViews) {
            this.alphaViews_ = {
                palette: config.alphaViews.palette,
                text: config.alphaViews.text
            };
            const aElem = doc.createElement('div');
            aElem.classList.add($9168155af81732ad$var$cn$c('a'));
            const apElem = doc.createElement('div');
            apElem.classList.add($9168155af81732ad$var$cn$c('ap'));
            apElem.appendChild(this.alphaViews_.palette.element);
            aElem.appendChild(apElem);
            const atElem = doc.createElement('div');
            atElem.classList.add($9168155af81732ad$var$cn$c('at'));
            atElem.appendChild(this.alphaViews_.text.element);
            aElem.appendChild(atElem);
            this.element.appendChild(aElem);
        }
    }
    get allFocusableElements() {
        const elems = [
            this.svPaletteView_.element,
            this.hPaletteView_.element,
            this.textsView_.modeSelectElement,
            ...this.textsView_.inputViews.map((v)=>v.inputElement)
        ];
        if (this.alphaViews_) elems.push(this.alphaViews_.palette.element, this.alphaViews_.text.inputElement);
        return elems;
    }
}
function $9168155af81732ad$var$parseColorType(value) {
    return value === 'int' ? 'int' : value === 'float' ? 'float' : undefined;
}
function $9168155af81732ad$var$parseColorInputParams(params) {
    return $9168155af81732ad$var$parseRecord(params, (p)=>({
            color: p.optional.object({
                alpha: p.optional.boolean,
                type: p.optional.custom($9168155af81732ad$var$parseColorType)
            }),
            expanded: p.optional.boolean,
            picker: p.optional.custom($9168155af81732ad$var$parsePickerLayout),
            readonly: p.optional.constant(false)
        }));
}
function $9168155af81732ad$var$getKeyScaleForColor(forAlpha) {
    return forAlpha ? 0.1 : 1;
}
function $9168155af81732ad$var$extractColorType(params) {
    var _a;
    return (_a = params.color) === null || _a === void 0 ? void 0 : _a.type;
}
class $9168155af81732ad$var$FloatColor {
    constructor(comps, mode){
        this.type = 'float';
        this.mode = mode;
        this.comps_ = $9168155af81732ad$var$constrainColorComponents(comps, mode, this.type);
    }
    getComponents(opt_mode) {
        return $9168155af81732ad$var$appendAlphaComponent($9168155af81732ad$var$convertColor($9168155af81732ad$var$removeAlphaComponent(this.comps_), {
            mode: this.mode,
            type: this.type
        }, {
            mode: opt_mode !== null && opt_mode !== void 0 ? opt_mode : this.mode,
            type: this.type
        }), this.comps_[3]);
    }
    toRgbaObject() {
        const rgbComps = this.getComponents('rgb');
        return {
            r: rgbComps[0],
            g: rgbComps[1],
            b: rgbComps[2],
            a: rgbComps[3]
        };
    }
}
const $9168155af81732ad$var$TYPE_TO_CONSTRUCTOR_MAP = {
    int: (comps, mode)=>new $9168155af81732ad$var$IntColor(comps, mode),
    float: (comps, mode)=>new $9168155af81732ad$var$FloatColor(comps, mode)
};
function $9168155af81732ad$var$createColor(comps, mode, type) {
    return $9168155af81732ad$var$TYPE_TO_CONSTRUCTOR_MAP[type](comps, mode);
}
function $9168155af81732ad$var$isFloatColor(c) {
    return c.type === 'float';
}
function $9168155af81732ad$var$isIntColor(c) {
    return c.type === 'int';
}
function $9168155af81732ad$var$convertFloatToInt(cf) {
    const comps = cf.getComponents();
    const ms = $9168155af81732ad$var$getColorMaxComponents(cf.mode, 'int');
    return new $9168155af81732ad$var$IntColor([
        Math.round($9168155af81732ad$var$mapRange(comps[0], 0, 1, 0, ms[0])),
        Math.round($9168155af81732ad$var$mapRange(comps[1], 0, 1, 0, ms[1])),
        Math.round($9168155af81732ad$var$mapRange(comps[2], 0, 1, 0, ms[2])),
        comps[3]
    ], cf.mode);
}
function $9168155af81732ad$var$convertIntToFloat(ci) {
    const comps = ci.getComponents();
    const ms = $9168155af81732ad$var$getColorMaxComponents(ci.mode, 'int');
    return new $9168155af81732ad$var$FloatColor([
        $9168155af81732ad$var$mapRange(comps[0], 0, ms[0], 0, 1),
        $9168155af81732ad$var$mapRange(comps[1], 0, ms[1], 0, 1),
        $9168155af81732ad$var$mapRange(comps[2], 0, ms[2], 0, 1),
        comps[3]
    ], ci.mode);
}
function $9168155af81732ad$var$mapColorType(c, type) {
    if (c.type === type) return c;
    if ($9168155af81732ad$var$isIntColor(c) && type === 'float') return $9168155af81732ad$var$convertIntToFloat(c);
    if ($9168155af81732ad$var$isFloatColor(c) && type === 'int') return $9168155af81732ad$var$convertFloatToInt(c);
    throw $9168155af81732ad$var$TpError.shouldNeverHappen();
}
function $9168155af81732ad$var$equalsStringColorFormat(f1, f2) {
    return f1.alpha === f2.alpha && f1.mode === f2.mode && f1.notation === f2.notation && f1.type === f2.type;
}
function $9168155af81732ad$var$parseCssNumberOrPercentage(text, max) {
    const m = text.match(/^(.+)%$/);
    if (!m) return Math.min(parseFloat(text), max);
    return Math.min(parseFloat(m[1]) * 0.01 * max, max);
}
const $9168155af81732ad$var$ANGLE_TO_DEG_MAP = {
    deg: (angle)=>angle,
    grad: (angle)=>angle * 360 / 400,
    rad: (angle)=>angle * 360 / (2 * Math.PI),
    turn: (angle)=>angle * 360
};
function $9168155af81732ad$var$parseCssNumberOrAngle(text) {
    const m = text.match(/^([0-9.]+?)(deg|grad|rad|turn)$/);
    if (!m) return parseFloat(text);
    const angle = parseFloat(m[1]);
    const unit = m[2];
    return $9168155af81732ad$var$ANGLE_TO_DEG_MAP[unit](angle);
}
function $9168155af81732ad$var$parseFunctionalRgbColorComponents(text) {
    const m = text.match(/^rgb\(\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
    if (!m) return null;
    const comps = [
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[1], 255),
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[2], 255),
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[3], 255)
    ];
    if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2])) return null;
    return comps;
}
function $9168155af81732ad$var$parseFunctionalRgbColor(text) {
    const comps = $9168155af81732ad$var$parseFunctionalRgbColorComponents(text);
    return comps ? new $9168155af81732ad$var$IntColor(comps, 'rgb') : null;
}
function $9168155af81732ad$var$parseFunctionalRgbaColorComponents(text) {
    const m = text.match(/^rgba\(\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
    if (!m) return null;
    const comps = [
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[1], 255),
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[2], 255),
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[3], 255),
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[4], 1)
    ];
    if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2]) || isNaN(comps[3])) return null;
    return comps;
}
function $9168155af81732ad$var$parseFunctionalRgbaColor(text) {
    const comps = $9168155af81732ad$var$parseFunctionalRgbaColorComponents(text);
    return comps ? new $9168155af81732ad$var$IntColor(comps, 'rgb') : null;
}
function $9168155af81732ad$var$parseFunctionalHslColorComponents(text) {
    const m = text.match(/^hsl\(\s*([0-9A-Fa-f.]+(?:deg|grad|rad|turn)?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
    if (!m) return null;
    const comps = [
        $9168155af81732ad$var$parseCssNumberOrAngle(m[1]),
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[2], 100),
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[3], 100)
    ];
    if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2])) return null;
    return comps;
}
function $9168155af81732ad$var$parseFunctionalHslColor(text) {
    const comps = $9168155af81732ad$var$parseFunctionalHslColorComponents(text);
    return comps ? new $9168155af81732ad$var$IntColor(comps, 'hsl') : null;
}
function $9168155af81732ad$var$parseHslaColorComponents(text) {
    const m = text.match(/^hsla\(\s*([0-9A-Fa-f.]+(?:deg|grad|rad|turn)?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
    if (!m) return null;
    const comps = [
        $9168155af81732ad$var$parseCssNumberOrAngle(m[1]),
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[2], 100),
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[3], 100),
        $9168155af81732ad$var$parseCssNumberOrPercentage(m[4], 1)
    ];
    if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2]) || isNaN(comps[3])) return null;
    return comps;
}
function $9168155af81732ad$var$parseFunctionalHslaColor(text) {
    const comps = $9168155af81732ad$var$parseHslaColorComponents(text);
    return comps ? new $9168155af81732ad$var$IntColor(comps, 'hsl') : null;
}
function $9168155af81732ad$var$parseHexRgbColorComponents(text) {
    const mRgb = text.match(/^#([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])$/);
    if (mRgb) return [
        parseInt(mRgb[1] + mRgb[1], 16),
        parseInt(mRgb[2] + mRgb[2], 16),
        parseInt(mRgb[3] + mRgb[3], 16)
    ];
    const mRrggbb = text.match(/^(?:#|0x)([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/);
    if (mRrggbb) return [
        parseInt(mRrggbb[1], 16),
        parseInt(mRrggbb[2], 16),
        parseInt(mRrggbb[3], 16)
    ];
    return null;
}
function $9168155af81732ad$var$parseHexRgbColor(text) {
    const comps = $9168155af81732ad$var$parseHexRgbColorComponents(text);
    return comps ? new $9168155af81732ad$var$IntColor(comps, 'rgb') : null;
}
function $9168155af81732ad$var$parseHexRgbaColorComponents(text) {
    const mRgb = text.match(/^#([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])$/);
    if (mRgb) return [
        parseInt(mRgb[1] + mRgb[1], 16),
        parseInt(mRgb[2] + mRgb[2], 16),
        parseInt(mRgb[3] + mRgb[3], 16),
        $9168155af81732ad$var$mapRange(parseInt(mRgb[4] + mRgb[4], 16), 0, 255, 0, 1)
    ];
    const mRrggbb = text.match(/^(?:#|0x)?([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/);
    if (mRrggbb) return [
        parseInt(mRrggbb[1], 16),
        parseInt(mRrggbb[2], 16),
        parseInt(mRrggbb[3], 16),
        $9168155af81732ad$var$mapRange(parseInt(mRrggbb[4], 16), 0, 255, 0, 1)
    ];
    return null;
}
function $9168155af81732ad$var$parseHexRgbaColor(text) {
    const comps = $9168155af81732ad$var$parseHexRgbaColorComponents(text);
    return comps ? new $9168155af81732ad$var$IntColor(comps, 'rgb') : null;
}
function $9168155af81732ad$var$parseObjectRgbColorComponents(text) {
    const m = text.match(/^\{\s*r\s*:\s*([0-9A-Fa-f.]+%?)\s*,\s*g\s*:\s*([0-9A-Fa-f.]+%?)\s*,\s*b\s*:\s*([0-9A-Fa-f.]+%?)\s*\}$/);
    if (!m) return null;
    const comps = [
        parseFloat(m[1]),
        parseFloat(m[2]),
        parseFloat(m[3])
    ];
    if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2])) return null;
    return comps;
}
function $9168155af81732ad$var$createObjectRgbColorParser(type) {
    return (text)=>{
        const comps = $9168155af81732ad$var$parseObjectRgbColorComponents(text);
        return comps ? $9168155af81732ad$var$createColor(comps, 'rgb', type) : null;
    };
}
function $9168155af81732ad$var$parseObjectRgbaColorComponents(text) {
    const m = text.match(/^\{\s*r\s*:\s*([0-9A-Fa-f.]+%?)\s*,\s*g\s*:\s*([0-9A-Fa-f.]+%?)\s*,\s*b\s*:\s*([0-9A-Fa-f.]+%?)\s*,\s*a\s*:\s*([0-9A-Fa-f.]+%?)\s*\}$/);
    if (!m) return null;
    const comps = [
        parseFloat(m[1]),
        parseFloat(m[2]),
        parseFloat(m[3]),
        parseFloat(m[4])
    ];
    if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2]) || isNaN(comps[3])) return null;
    return comps;
}
function $9168155af81732ad$var$createObjectRgbaColorParser(type) {
    return (text)=>{
        const comps = $9168155af81732ad$var$parseObjectRgbaColorComponents(text);
        return comps ? $9168155af81732ad$var$createColor(comps, 'rgb', type) : null;
    };
}
const $9168155af81732ad$var$PARSER_AND_RESULT = [
    {
        parser: $9168155af81732ad$var$parseHexRgbColorComponents,
        result: {
            alpha: false,
            mode: 'rgb',
            notation: 'hex'
        }
    },
    {
        parser: $9168155af81732ad$var$parseHexRgbaColorComponents,
        result: {
            alpha: true,
            mode: 'rgb',
            notation: 'hex'
        }
    },
    {
        parser: $9168155af81732ad$var$parseFunctionalRgbColorComponents,
        result: {
            alpha: false,
            mode: 'rgb',
            notation: 'func'
        }
    },
    {
        parser: $9168155af81732ad$var$parseFunctionalRgbaColorComponents,
        result: {
            alpha: true,
            mode: 'rgb',
            notation: 'func'
        }
    },
    {
        parser: $9168155af81732ad$var$parseFunctionalHslColorComponents,
        result: {
            alpha: false,
            mode: 'hsl',
            notation: 'func'
        }
    },
    {
        parser: $9168155af81732ad$var$parseHslaColorComponents,
        result: {
            alpha: true,
            mode: 'hsl',
            notation: 'func'
        }
    },
    {
        parser: $9168155af81732ad$var$parseObjectRgbColorComponents,
        result: {
            alpha: false,
            mode: 'rgb',
            notation: 'object'
        }
    },
    {
        parser: $9168155af81732ad$var$parseObjectRgbaColorComponents,
        result: {
            alpha: true,
            mode: 'rgb',
            notation: 'object'
        }
    }
];
function $9168155af81732ad$var$detectStringColor(text) {
    return $9168155af81732ad$var$PARSER_AND_RESULT.reduce((prev, { parser: parser, result: detection })=>{
        if (prev) return prev;
        return parser(text) ? detection : null;
    }, null);
}
function $9168155af81732ad$var$detectStringColorFormat(text, type = 'int') {
    const r = $9168155af81732ad$var$detectStringColor(text);
    if (!r) return null;
    if (r.notation === 'hex' && type !== 'float') return Object.assign(Object.assign({}, r), {
        type: 'int'
    });
    if (r.notation === 'func') return Object.assign(Object.assign({}, r), {
        type: type
    });
    return null;
}
function $9168155af81732ad$var$createColorStringParser(type) {
    const parsers = [
        $9168155af81732ad$var$parseHexRgbColor,
        $9168155af81732ad$var$parseHexRgbaColor,
        $9168155af81732ad$var$parseFunctionalRgbColor,
        $9168155af81732ad$var$parseFunctionalRgbaColor,
        $9168155af81732ad$var$parseFunctionalHslColor,
        $9168155af81732ad$var$parseFunctionalHslaColor
    ];
    if (type === 'int') parsers.push($9168155af81732ad$var$createObjectRgbColorParser('int'), $9168155af81732ad$var$createObjectRgbaColorParser('int'));
    if (type === 'float') parsers.push($9168155af81732ad$var$createObjectRgbColorParser('float'), $9168155af81732ad$var$createObjectRgbaColorParser('float'));
    const parser = $9168155af81732ad$var$composeParsers(parsers);
    return (text)=>{
        const result = parser(text);
        return result ? $9168155af81732ad$var$mapColorType(result, type) : null;
    };
}
function $9168155af81732ad$var$readIntColorString(value) {
    const parser = $9168155af81732ad$var$createColorStringParser('int');
    if (typeof value !== 'string') return $9168155af81732ad$var$IntColor.black();
    const result = parser(value);
    return result !== null && result !== void 0 ? result : $9168155af81732ad$var$IntColor.black();
}
function $9168155af81732ad$var$zerofill(comp) {
    const hex = $9168155af81732ad$var$constrainRange(Math.floor(comp), 0, 255).toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $9168155af81732ad$var$colorToHexRgbString(value, prefix = '#') {
    const hexes = $9168155af81732ad$var$removeAlphaComponent(value.getComponents('rgb')).map($9168155af81732ad$var$zerofill).join('');
    return `${prefix}${hexes}`;
}
function $9168155af81732ad$var$colorToHexRgbaString(value, prefix = '#') {
    const rgbaComps = value.getComponents('rgb');
    const hexes = [
        rgbaComps[0],
        rgbaComps[1],
        rgbaComps[2],
        rgbaComps[3] * 255
    ].map($9168155af81732ad$var$zerofill).join('');
    return `${prefix}${hexes}`;
}
function $9168155af81732ad$var$colorToFunctionalRgbString(value) {
    const formatter = $9168155af81732ad$var$createNumberFormatter(0);
    const ci = $9168155af81732ad$var$mapColorType(value, 'int');
    const comps = $9168155af81732ad$var$removeAlphaComponent(ci.getComponents('rgb')).map((comp)=>formatter(comp));
    return `rgb(${comps.join(', ')})`;
}
function $9168155af81732ad$var$colorToFunctionalRgbaString(value) {
    const aFormatter = $9168155af81732ad$var$createNumberFormatter(2);
    const rgbFormatter = $9168155af81732ad$var$createNumberFormatter(0);
    const ci = $9168155af81732ad$var$mapColorType(value, 'int');
    const comps = ci.getComponents('rgb').map((comp, index)=>{
        const formatter = index === 3 ? aFormatter : rgbFormatter;
        return formatter(comp);
    });
    return `rgba(${comps.join(', ')})`;
}
function $9168155af81732ad$var$colorToFunctionalHslString(value) {
    const formatters = [
        $9168155af81732ad$var$createNumberFormatter(0),
        $9168155af81732ad$var$formatPercentage,
        $9168155af81732ad$var$formatPercentage
    ];
    const ci = $9168155af81732ad$var$mapColorType(value, 'int');
    const comps = $9168155af81732ad$var$removeAlphaComponent(ci.getComponents('hsl')).map((comp, index)=>formatters[index](comp));
    return `hsl(${comps.join(', ')})`;
}
function $9168155af81732ad$var$colorToFunctionalHslaString(value) {
    const formatters = [
        $9168155af81732ad$var$createNumberFormatter(0),
        $9168155af81732ad$var$formatPercentage,
        $9168155af81732ad$var$formatPercentage,
        $9168155af81732ad$var$createNumberFormatter(2)
    ];
    const ci = $9168155af81732ad$var$mapColorType(value, 'int');
    const comps = ci.getComponents('hsl').map((comp, index)=>formatters[index](comp));
    return `hsla(${comps.join(', ')})`;
}
function $9168155af81732ad$var$colorToObjectRgbString(value, type) {
    const formatter = $9168155af81732ad$var$createNumberFormatter(type === 'float' ? 2 : 0);
    const names = [
        'r',
        'g',
        'b'
    ];
    const cc = $9168155af81732ad$var$mapColorType(value, type);
    const comps = $9168155af81732ad$var$removeAlphaComponent(cc.getComponents('rgb')).map((comp, index)=>`${names[index]}: ${formatter(comp)}`);
    return `{${comps.join(', ')}}`;
}
function $9168155af81732ad$var$createObjectRgbColorFormatter(type) {
    return (value)=>$9168155af81732ad$var$colorToObjectRgbString(value, type);
}
function $9168155af81732ad$var$colorToObjectRgbaString(value, type) {
    const aFormatter = $9168155af81732ad$var$createNumberFormatter(2);
    const rgbFormatter = $9168155af81732ad$var$createNumberFormatter(type === 'float' ? 2 : 0);
    const names = [
        'r',
        'g',
        'b',
        'a'
    ];
    const cc = $9168155af81732ad$var$mapColorType(value, type);
    const comps = cc.getComponents('rgb').map((comp, index)=>{
        const formatter = index === 3 ? aFormatter : rgbFormatter;
        return `${names[index]}: ${formatter(comp)}`;
    });
    return `{${comps.join(', ')}}`;
}
function $9168155af81732ad$var$createObjectRgbaColorFormatter(type) {
    return (value)=>$9168155af81732ad$var$colorToObjectRgbaString(value, type);
}
const $9168155af81732ad$var$FORMAT_AND_STRINGIFIERS = [
    {
        format: {
            alpha: false,
            mode: 'rgb',
            notation: 'hex',
            type: 'int'
        },
        stringifier: $9168155af81732ad$var$colorToHexRgbString
    },
    {
        format: {
            alpha: true,
            mode: 'rgb',
            notation: 'hex',
            type: 'int'
        },
        stringifier: $9168155af81732ad$var$colorToHexRgbaString
    },
    {
        format: {
            alpha: false,
            mode: 'rgb',
            notation: 'func',
            type: 'int'
        },
        stringifier: $9168155af81732ad$var$colorToFunctionalRgbString
    },
    {
        format: {
            alpha: true,
            mode: 'rgb',
            notation: 'func',
            type: 'int'
        },
        stringifier: $9168155af81732ad$var$colorToFunctionalRgbaString
    },
    {
        format: {
            alpha: false,
            mode: 'hsl',
            notation: 'func',
            type: 'int'
        },
        stringifier: $9168155af81732ad$var$colorToFunctionalHslString
    },
    {
        format: {
            alpha: true,
            mode: 'hsl',
            notation: 'func',
            type: 'int'
        },
        stringifier: $9168155af81732ad$var$colorToFunctionalHslaString
    },
    ...[
        'int',
        'float'
    ].reduce((prev, type)=>{
        return [
            ...prev,
            {
                format: {
                    alpha: false,
                    mode: 'rgb',
                    notation: 'object',
                    type: type
                },
                stringifier: $9168155af81732ad$var$createObjectRgbColorFormatter(type)
            },
            {
                format: {
                    alpha: true,
                    mode: 'rgb',
                    notation: 'object',
                    type: type
                },
                stringifier: $9168155af81732ad$var$createObjectRgbaColorFormatter(type)
            }
        ];
    }, [])
];
function $9168155af81732ad$var$findColorStringifier(format) {
    return $9168155af81732ad$var$FORMAT_AND_STRINGIFIERS.reduce((prev, fas)=>{
        if (prev) return prev;
        return $9168155af81732ad$var$equalsStringColorFormat(fas.format, format) ? fas.stringifier : null;
    }, null);
}
const $9168155af81732ad$var$cn$b = $9168155af81732ad$var$ClassName('apl');
class $9168155af81732ad$var$APaletteView {
    constructor(doc, config){
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.value = config.value;
        this.value.emitter.on('change', this.onValueChange_);
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$b());
        config.viewProps.bindClassModifiers(this.element);
        config.viewProps.bindTabIndex(this.element);
        const barElem = doc.createElement('div');
        barElem.classList.add($9168155af81732ad$var$cn$b('b'));
        this.element.appendChild(barElem);
        const colorElem = doc.createElement('div');
        colorElem.classList.add($9168155af81732ad$var$cn$b('c'));
        barElem.appendChild(colorElem);
        this.colorElem_ = colorElem;
        const markerElem = doc.createElement('div');
        markerElem.classList.add($9168155af81732ad$var$cn$b('m'));
        this.element.appendChild(markerElem);
        this.markerElem_ = markerElem;
        const previewElem = doc.createElement('div');
        previewElem.classList.add($9168155af81732ad$var$cn$b('p'));
        this.markerElem_.appendChild(previewElem);
        this.previewElem_ = previewElem;
        this.update_();
    }
    update_() {
        const c = this.value.rawValue;
        const rgbaComps = c.getComponents('rgb');
        const leftColor = new $9168155af81732ad$var$IntColor([
            rgbaComps[0],
            rgbaComps[1],
            rgbaComps[2],
            0
        ], 'rgb');
        const rightColor = new $9168155af81732ad$var$IntColor([
            rgbaComps[0],
            rgbaComps[1],
            rgbaComps[2],
            255
        ], 'rgb');
        const gradientComps = [
            'to right',
            $9168155af81732ad$var$colorToFunctionalRgbaString(leftColor),
            $9168155af81732ad$var$colorToFunctionalRgbaString(rightColor)
        ];
        this.colorElem_.style.background = `linear-gradient(${gradientComps.join(',')})`;
        this.previewElem_.style.backgroundColor = $9168155af81732ad$var$colorToFunctionalRgbaString(c);
        const left = $9168155af81732ad$var$mapRange(rgbaComps[3], 0, 1, 0, 100);
        this.markerElem_.style.left = `${left}%`;
    }
    onValueChange_() {
        this.update_();
    }
}
class $9168155af81732ad$var$APaletteController {
    constructor(doc, config){
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.onKeyUp_ = this.onKeyUp_.bind(this);
        this.onPointerDown_ = this.onPointerDown_.bind(this);
        this.onPointerMove_ = this.onPointerMove_.bind(this);
        this.onPointerUp_ = this.onPointerUp_.bind(this);
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$APaletteView(doc, {
            value: this.value,
            viewProps: this.viewProps
        });
        this.ptHandler_ = new $9168155af81732ad$var$PointerHandler(this.view.element);
        this.ptHandler_.emitter.on('down', this.onPointerDown_);
        this.ptHandler_.emitter.on('move', this.onPointerMove_);
        this.ptHandler_.emitter.on('up', this.onPointerUp_);
        this.view.element.addEventListener('keydown', this.onKeyDown_);
        this.view.element.addEventListener('keyup', this.onKeyUp_);
    }
    handlePointerEvent_(d, opts) {
        if (!d.point) return;
        const alpha = d.point.x / d.bounds.width;
        const c = this.value.rawValue;
        const [h, s, v] = c.getComponents('hsv');
        this.value.setRawValue(new $9168155af81732ad$var$IntColor([
            h,
            s,
            v,
            alpha
        ], 'hsv'), opts);
    }
    onPointerDown_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: false,
            last: false
        });
    }
    onPointerMove_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: false,
            last: false
        });
    }
    onPointerUp_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: true,
            last: true
        });
    }
    onKeyDown_(ev) {
        const step = $9168155af81732ad$var$getStepForKey($9168155af81732ad$var$getKeyScaleForColor(true), $9168155af81732ad$var$getHorizontalStepKeys(ev));
        if (step === 0) return;
        const c = this.value.rawValue;
        const [h, s, v, a] = c.getComponents('hsv');
        this.value.setRawValue(new $9168155af81732ad$var$IntColor([
            h,
            s,
            v,
            a + step
        ], 'hsv'), {
            forceEmit: false,
            last: false
        });
    }
    onKeyUp_(ev) {
        const step = $9168155af81732ad$var$getStepForKey($9168155af81732ad$var$getKeyScaleForColor(true), $9168155af81732ad$var$getHorizontalStepKeys(ev));
        if (step === 0) return;
        this.value.setRawValue(this.value.rawValue, {
            forceEmit: true,
            last: true
        });
    }
}
const $9168155af81732ad$var$cn$a = $9168155af81732ad$var$ClassName('coltxt');
function $9168155af81732ad$var$createModeSelectElement(doc) {
    const selectElem = doc.createElement('select');
    const items = [
        {
            text: 'RGB',
            value: 'rgb'
        },
        {
            text: 'HSL',
            value: 'hsl'
        },
        {
            text: 'HSV',
            value: 'hsv'
        },
        {
            text: 'HEX',
            value: 'hex'
        }
    ];
    selectElem.appendChild(items.reduce((frag, item)=>{
        const optElem = doc.createElement('option');
        optElem.textContent = item.text;
        optElem.value = item.value;
        frag.appendChild(optElem);
        return frag;
    }, doc.createDocumentFragment()));
    return selectElem;
}
class $9168155af81732ad$var$ColorTextsView {
    constructor(doc, config){
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$a());
        config.viewProps.bindClassModifiers(this.element);
        const modeElem = doc.createElement('div');
        modeElem.classList.add($9168155af81732ad$var$cn$a('m'));
        this.modeElem_ = $9168155af81732ad$var$createModeSelectElement(doc);
        this.modeElem_.classList.add($9168155af81732ad$var$cn$a('ms'));
        modeElem.appendChild(this.modeSelectElement);
        config.viewProps.bindDisabled(this.modeElem_);
        const modeMarkerElem = doc.createElement('div');
        modeMarkerElem.classList.add($9168155af81732ad$var$cn$a('mm'));
        modeMarkerElem.appendChild($9168155af81732ad$var$createSvgIconElement(doc, 'dropdown'));
        modeElem.appendChild(modeMarkerElem);
        this.element.appendChild(modeElem);
        const inputsElem = doc.createElement('div');
        inputsElem.classList.add($9168155af81732ad$var$cn$a('w'));
        this.element.appendChild(inputsElem);
        this.inputsElem_ = inputsElem;
        this.inputViews_ = config.inputViews;
        this.applyInputViews_();
        $9168155af81732ad$var$bindValue(config.mode, (mode)=>{
            this.modeElem_.value = mode;
        });
    }
    get modeSelectElement() {
        return this.modeElem_;
    }
    get inputViews() {
        return this.inputViews_;
    }
    set inputViews(inputViews) {
        this.inputViews_ = inputViews;
        this.applyInputViews_();
    }
    applyInputViews_() {
        $9168155af81732ad$var$removeChildElements(this.inputsElem_);
        const doc = this.element.ownerDocument;
        this.inputViews_.forEach((v)=>{
            const compElem = doc.createElement('div');
            compElem.classList.add($9168155af81732ad$var$cn$a('c'));
            compElem.appendChild(v.element);
            this.inputsElem_.appendChild(compElem);
        });
    }
}
function $9168155af81732ad$var$createFormatter$2(type) {
    return $9168155af81732ad$var$createNumberFormatter(type === 'float' ? 2 : 0);
}
function $9168155af81732ad$var$createConstraint$5(mode, type, index) {
    const max = $9168155af81732ad$var$getColorMaxComponents(mode, type)[index];
    return new $9168155af81732ad$var$DefiniteRangeConstraint({
        min: 0,
        max: max
    });
}
function $9168155af81732ad$var$createComponentController(doc, config, index) {
    return new $9168155af81732ad$var$NumberTextController(doc, {
        arrayPosition: index === 0 ? 'fst' : index === 2 ? 'lst' : 'mid',
        parser: config.parser,
        props: $9168155af81732ad$var$ValueMap.fromObject({
            formatter: $9168155af81732ad$var$createFormatter$2(config.colorType),
            keyScale: $9168155af81732ad$var$getKeyScaleForColor(false),
            pointerScale: config.colorType === 'float' ? 0.01 : 1
        }),
        value: $9168155af81732ad$var$createValue(0, {
            constraint: $9168155af81732ad$var$createConstraint$5(config.colorMode, config.colorType, index)
        }),
        viewProps: config.viewProps
    });
}
function $9168155af81732ad$var$createComponentControllers(doc, config) {
    const cc = {
        colorMode: config.colorMode,
        colorType: config.colorType,
        parser: $9168155af81732ad$var$parseNumber,
        viewProps: config.viewProps
    };
    return [
        0,
        1,
        2
    ].map((i)=>{
        const c = $9168155af81732ad$var$createComponentController(doc, cc, i);
        $9168155af81732ad$var$connectValues({
            primary: config.value,
            secondary: c.value,
            forward (p) {
                const mc = $9168155af81732ad$var$mapColorType(p, config.colorType);
                return mc.getComponents(config.colorMode)[i];
            },
            backward (p, s) {
                const pickedMode = config.colorMode;
                const mc = $9168155af81732ad$var$mapColorType(p, config.colorType);
                const comps = mc.getComponents(pickedMode);
                comps[i] = s;
                const c = $9168155af81732ad$var$createColor($9168155af81732ad$var$appendAlphaComponent($9168155af81732ad$var$removeAlphaComponent(comps), comps[3]), pickedMode, config.colorType);
                return $9168155af81732ad$var$mapColorType(c, 'int');
            }
        });
        return c;
    });
}
function $9168155af81732ad$var$createHexController(doc, config) {
    const c = new $9168155af81732ad$var$TextController(doc, {
        parser: $9168155af81732ad$var$createColorStringParser('int'),
        props: $9168155af81732ad$var$ValueMap.fromObject({
            formatter: $9168155af81732ad$var$colorToHexRgbString
        }),
        value: $9168155af81732ad$var$createValue($9168155af81732ad$var$IntColor.black()),
        viewProps: config.viewProps
    });
    $9168155af81732ad$var$connectValues({
        primary: config.value,
        secondary: c.value,
        forward: (p)=>new $9168155af81732ad$var$IntColor($9168155af81732ad$var$removeAlphaComponent(p.getComponents()), p.mode),
        backward: (p, s)=>new $9168155af81732ad$var$IntColor($9168155af81732ad$var$appendAlphaComponent($9168155af81732ad$var$removeAlphaComponent(s.getComponents(p.mode)), p.getComponents()[3]), p.mode)
    });
    return [
        c
    ];
}
function $9168155af81732ad$var$isColorMode(mode) {
    return mode !== 'hex';
}
class $9168155af81732ad$var$ColorTextsController {
    constructor(doc, config){
        this.onModeSelectChange_ = this.onModeSelectChange_.bind(this);
        this.colorType_ = config.colorType;
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.colorMode = $9168155af81732ad$var$createValue(this.value.rawValue.mode);
        this.ccs_ = this.createComponentControllers_(doc);
        this.view = new $9168155af81732ad$var$ColorTextsView(doc, {
            mode: this.colorMode,
            inputViews: [
                this.ccs_[0].view,
                this.ccs_[1].view,
                this.ccs_[2].view
            ],
            viewProps: this.viewProps
        });
        this.view.modeSelectElement.addEventListener('change', this.onModeSelectChange_);
    }
    createComponentControllers_(doc) {
        const mode = this.colorMode.rawValue;
        if ($9168155af81732ad$var$isColorMode(mode)) return $9168155af81732ad$var$createComponentControllers(doc, {
            colorMode: mode,
            colorType: this.colorType_,
            value: this.value,
            viewProps: this.viewProps
        });
        return $9168155af81732ad$var$createHexController(doc, {
            value: this.value,
            viewProps: this.viewProps
        });
    }
    onModeSelectChange_(ev) {
        const selectElem = ev.currentTarget;
        this.colorMode.rawValue = selectElem.value;
        this.ccs_ = this.createComponentControllers_(this.view.element.ownerDocument);
        this.view.inputViews = this.ccs_.map((cc)=>cc.view);
    }
}
const $9168155af81732ad$var$cn$9 = $9168155af81732ad$var$ClassName('hpl');
class $9168155af81732ad$var$HPaletteView {
    constructor(doc, config){
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.value = config.value;
        this.value.emitter.on('change', this.onValueChange_);
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$9());
        config.viewProps.bindClassModifiers(this.element);
        config.viewProps.bindTabIndex(this.element);
        const colorElem = doc.createElement('div');
        colorElem.classList.add($9168155af81732ad$var$cn$9('c'));
        this.element.appendChild(colorElem);
        const markerElem = doc.createElement('div');
        markerElem.classList.add($9168155af81732ad$var$cn$9('m'));
        this.element.appendChild(markerElem);
        this.markerElem_ = markerElem;
        this.update_();
    }
    update_() {
        const c = this.value.rawValue;
        const [h] = c.getComponents('hsv');
        this.markerElem_.style.backgroundColor = $9168155af81732ad$var$colorToFunctionalRgbString(new $9168155af81732ad$var$IntColor([
            h,
            100,
            100
        ], 'hsv'));
        const left = $9168155af81732ad$var$mapRange(h, 0, 360, 0, 100);
        this.markerElem_.style.left = `${left}%`;
    }
    onValueChange_() {
        this.update_();
    }
}
class $9168155af81732ad$var$HPaletteController {
    constructor(doc, config){
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.onKeyUp_ = this.onKeyUp_.bind(this);
        this.onPointerDown_ = this.onPointerDown_.bind(this);
        this.onPointerMove_ = this.onPointerMove_.bind(this);
        this.onPointerUp_ = this.onPointerUp_.bind(this);
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$HPaletteView(doc, {
            value: this.value,
            viewProps: this.viewProps
        });
        this.ptHandler_ = new $9168155af81732ad$var$PointerHandler(this.view.element);
        this.ptHandler_.emitter.on('down', this.onPointerDown_);
        this.ptHandler_.emitter.on('move', this.onPointerMove_);
        this.ptHandler_.emitter.on('up', this.onPointerUp_);
        this.view.element.addEventListener('keydown', this.onKeyDown_);
        this.view.element.addEventListener('keyup', this.onKeyUp_);
    }
    handlePointerEvent_(d, opts) {
        if (!d.point) return;
        const hue = $9168155af81732ad$var$mapRange($9168155af81732ad$var$constrainRange(d.point.x, 0, d.bounds.width), 0, d.bounds.width, 0, 360);
        const c = this.value.rawValue;
        const [, s, v, a] = c.getComponents('hsv');
        this.value.setRawValue(new $9168155af81732ad$var$IntColor([
            hue,
            s,
            v,
            a
        ], 'hsv'), opts);
    }
    onPointerDown_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: false,
            last: false
        });
    }
    onPointerMove_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: false,
            last: false
        });
    }
    onPointerUp_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: true,
            last: true
        });
    }
    onKeyDown_(ev) {
        const step = $9168155af81732ad$var$getStepForKey($9168155af81732ad$var$getKeyScaleForColor(false), $9168155af81732ad$var$getHorizontalStepKeys(ev));
        if (step === 0) return;
        const c = this.value.rawValue;
        const [h, s, v, a] = c.getComponents('hsv');
        this.value.setRawValue(new $9168155af81732ad$var$IntColor([
            h + step,
            s,
            v,
            a
        ], 'hsv'), {
            forceEmit: false,
            last: false
        });
    }
    onKeyUp_(ev) {
        const step = $9168155af81732ad$var$getStepForKey($9168155af81732ad$var$getKeyScaleForColor(false), $9168155af81732ad$var$getHorizontalStepKeys(ev));
        if (step === 0) return;
        this.value.setRawValue(this.value.rawValue, {
            forceEmit: true,
            last: true
        });
    }
}
const $9168155af81732ad$var$cn$8 = $9168155af81732ad$var$ClassName('svp');
const $9168155af81732ad$var$CANVAS_RESOL = 64;
class $9168155af81732ad$var$SvPaletteView {
    constructor(doc, config){
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.value = config.value;
        this.value.emitter.on('change', this.onValueChange_);
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$8());
        config.viewProps.bindClassModifiers(this.element);
        config.viewProps.bindTabIndex(this.element);
        const canvasElem = doc.createElement('canvas');
        canvasElem.height = $9168155af81732ad$var$CANVAS_RESOL;
        canvasElem.width = $9168155af81732ad$var$CANVAS_RESOL;
        canvasElem.classList.add($9168155af81732ad$var$cn$8('c'));
        this.element.appendChild(canvasElem);
        this.canvasElement = canvasElem;
        const markerElem = doc.createElement('div');
        markerElem.classList.add($9168155af81732ad$var$cn$8('m'));
        this.element.appendChild(markerElem);
        this.markerElem_ = markerElem;
        this.update_();
    }
    update_() {
        const ctx = $9168155af81732ad$var$getCanvasContext(this.canvasElement);
        if (!ctx) return;
        const c = this.value.rawValue;
        const hsvComps = c.getComponents('hsv');
        const width = this.canvasElement.width;
        const height = this.canvasElement.height;
        const imgData = ctx.getImageData(0, 0, width, height);
        const data = imgData.data;
        for(let iy = 0; iy < height; iy++)for(let ix = 0; ix < width; ix++){
            const s = $9168155af81732ad$var$mapRange(ix, 0, width, 0, 100);
            const v = $9168155af81732ad$var$mapRange(iy, 0, height, 100, 0);
            const rgbComps = $9168155af81732ad$var$hsvToRgbInt(hsvComps[0], s, v);
            const i = (iy * width + ix) * 4;
            data[i] = rgbComps[0];
            data[i + 1] = rgbComps[1];
            data[i + 2] = rgbComps[2];
            data[i + 3] = 255;
        }
        ctx.putImageData(imgData, 0, 0);
        const left = $9168155af81732ad$var$mapRange(hsvComps[1], 0, 100, 0, 100);
        this.markerElem_.style.left = `${left}%`;
        const top = $9168155af81732ad$var$mapRange(hsvComps[2], 0, 100, 100, 0);
        this.markerElem_.style.top = `${top}%`;
    }
    onValueChange_() {
        this.update_();
    }
}
class $9168155af81732ad$var$SvPaletteController {
    constructor(doc, config){
        this.onKeyDown_ = this.onKeyDown_.bind(this);
        this.onKeyUp_ = this.onKeyUp_.bind(this);
        this.onPointerDown_ = this.onPointerDown_.bind(this);
        this.onPointerMove_ = this.onPointerMove_.bind(this);
        this.onPointerUp_ = this.onPointerUp_.bind(this);
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$SvPaletteView(doc, {
            value: this.value,
            viewProps: this.viewProps
        });
        this.ptHandler_ = new $9168155af81732ad$var$PointerHandler(this.view.element);
        this.ptHandler_.emitter.on('down', this.onPointerDown_);
        this.ptHandler_.emitter.on('move', this.onPointerMove_);
        this.ptHandler_.emitter.on('up', this.onPointerUp_);
        this.view.element.addEventListener('keydown', this.onKeyDown_);
        this.view.element.addEventListener('keyup', this.onKeyUp_);
    }
    handlePointerEvent_(d, opts) {
        if (!d.point) return;
        const saturation = $9168155af81732ad$var$mapRange(d.point.x, 0, d.bounds.width, 0, 100);
        const value = $9168155af81732ad$var$mapRange(d.point.y, 0, d.bounds.height, 100, 0);
        const [h, , , a] = this.value.rawValue.getComponents('hsv');
        this.value.setRawValue(new $9168155af81732ad$var$IntColor([
            h,
            saturation,
            value,
            a
        ], 'hsv'), opts);
    }
    onPointerDown_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: false,
            last: false
        });
    }
    onPointerMove_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: false,
            last: false
        });
    }
    onPointerUp_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: true,
            last: true
        });
    }
    onKeyDown_(ev) {
        if ($9168155af81732ad$var$isArrowKey(ev.key)) ev.preventDefault();
        const [h, s, v, a] = this.value.rawValue.getComponents('hsv');
        const keyScale = $9168155af81732ad$var$getKeyScaleForColor(false);
        const ds = $9168155af81732ad$var$getStepForKey(keyScale, $9168155af81732ad$var$getHorizontalStepKeys(ev));
        const dv = $9168155af81732ad$var$getStepForKey(keyScale, $9168155af81732ad$var$getVerticalStepKeys(ev));
        if (ds === 0 && dv === 0) return;
        this.value.setRawValue(new $9168155af81732ad$var$IntColor([
            h,
            s + ds,
            v + dv,
            a
        ], 'hsv'), {
            forceEmit: false,
            last: false
        });
    }
    onKeyUp_(ev) {
        const keyScale = $9168155af81732ad$var$getKeyScaleForColor(false);
        const ds = $9168155af81732ad$var$getStepForKey(keyScale, $9168155af81732ad$var$getHorizontalStepKeys(ev));
        const dv = $9168155af81732ad$var$getStepForKey(keyScale, $9168155af81732ad$var$getVerticalStepKeys(ev));
        if (ds === 0 && dv === 0) return;
        this.value.setRawValue(this.value.rawValue, {
            forceEmit: true,
            last: true
        });
    }
}
class $9168155af81732ad$var$ColorPickerController {
    constructor(doc, config){
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.hPaletteC_ = new $9168155af81732ad$var$HPaletteController(doc, {
            value: this.value,
            viewProps: this.viewProps
        });
        this.svPaletteC_ = new $9168155af81732ad$var$SvPaletteController(doc, {
            value: this.value,
            viewProps: this.viewProps
        });
        this.alphaIcs_ = config.supportsAlpha ? {
            palette: new $9168155af81732ad$var$APaletteController(doc, {
                value: this.value,
                viewProps: this.viewProps
            }),
            text: new $9168155af81732ad$var$NumberTextController(doc, {
                parser: $9168155af81732ad$var$parseNumber,
                props: $9168155af81732ad$var$ValueMap.fromObject({
                    pointerScale: 0.01,
                    keyScale: 0.1,
                    formatter: $9168155af81732ad$var$createNumberFormatter(2)
                }),
                value: $9168155af81732ad$var$createValue(0, {
                    constraint: new $9168155af81732ad$var$DefiniteRangeConstraint({
                        min: 0,
                        max: 1
                    })
                }),
                viewProps: this.viewProps
            })
        } : null;
        if (this.alphaIcs_) $9168155af81732ad$var$connectValues({
            primary: this.value,
            secondary: this.alphaIcs_.text.value,
            forward: (p)=>p.getComponents()[3],
            backward: (p, s)=>{
                const comps = p.getComponents();
                comps[3] = s;
                return new $9168155af81732ad$var$IntColor(comps, p.mode);
            }
        });
        this.textsC_ = new $9168155af81732ad$var$ColorTextsController(doc, {
            colorType: config.colorType,
            value: this.value,
            viewProps: this.viewProps
        });
        this.view = new $9168155af81732ad$var$ColorPickerView(doc, {
            alphaViews: this.alphaIcs_ ? {
                palette: this.alphaIcs_.palette.view,
                text: this.alphaIcs_.text.view
            } : null,
            hPaletteView: this.hPaletteC_.view,
            supportsAlpha: config.supportsAlpha,
            svPaletteView: this.svPaletteC_.view,
            textsView: this.textsC_.view,
            viewProps: this.viewProps
        });
    }
    get textsController() {
        return this.textsC_;
    }
}
const $9168155af81732ad$var$cn$7 = $9168155af81732ad$var$ClassName('colsw');
class $9168155af81732ad$var$ColorSwatchView {
    constructor(doc, config){
        this.onValueChange_ = this.onValueChange_.bind(this);
        config.value.emitter.on('change', this.onValueChange_);
        this.value = config.value;
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$7());
        config.viewProps.bindClassModifiers(this.element);
        const swatchElem = doc.createElement('div');
        swatchElem.classList.add($9168155af81732ad$var$cn$7('sw'));
        this.element.appendChild(swatchElem);
        this.swatchElem_ = swatchElem;
        const buttonElem = doc.createElement('button');
        buttonElem.classList.add($9168155af81732ad$var$cn$7('b'));
        config.viewProps.bindDisabled(buttonElem);
        this.element.appendChild(buttonElem);
        this.buttonElement = buttonElem;
        this.update_();
    }
    update_() {
        const value = this.value.rawValue;
        this.swatchElem_.style.backgroundColor = $9168155af81732ad$var$colorToHexRgbaString(value);
    }
    onValueChange_() {
        this.update_();
    }
}
class $9168155af81732ad$var$ColorSwatchController {
    constructor(doc, config){
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$ColorSwatchView(doc, {
            value: this.value,
            viewProps: this.viewProps
        });
    }
}
class $9168155af81732ad$var$ColorController {
    constructor(doc, config){
        this.onButtonBlur_ = this.onButtonBlur_.bind(this);
        this.onButtonClick_ = this.onButtonClick_.bind(this);
        this.onPopupChildBlur_ = this.onPopupChildBlur_.bind(this);
        this.onPopupChildKeydown_ = this.onPopupChildKeydown_.bind(this);
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.foldable_ = $9168155af81732ad$var$Foldable.create(config.expanded);
        this.swatchC_ = new $9168155af81732ad$var$ColorSwatchController(doc, {
            value: this.value,
            viewProps: this.viewProps
        });
        const buttonElem = this.swatchC_.view.buttonElement;
        buttonElem.addEventListener('blur', this.onButtonBlur_);
        buttonElem.addEventListener('click', this.onButtonClick_);
        this.textC_ = new $9168155af81732ad$var$TextController(doc, {
            parser: config.parser,
            props: $9168155af81732ad$var$ValueMap.fromObject({
                formatter: config.formatter
            }),
            value: this.value,
            viewProps: this.viewProps
        });
        this.view = new $9168155af81732ad$var$ColorView(doc, {
            foldable: this.foldable_,
            pickerLayout: config.pickerLayout
        });
        this.view.swatchElement.appendChild(this.swatchC_.view.element);
        this.view.textElement.appendChild(this.textC_.view.element);
        this.popC_ = config.pickerLayout === 'popup' ? new $9168155af81732ad$var$PopupController(doc, {
            viewProps: this.viewProps
        }) : null;
        const pickerC = new $9168155af81732ad$var$ColorPickerController(doc, {
            colorType: config.colorType,
            supportsAlpha: config.supportsAlpha,
            value: this.value,
            viewProps: this.viewProps
        });
        pickerC.view.allFocusableElements.forEach((elem)=>{
            elem.addEventListener('blur', this.onPopupChildBlur_);
            elem.addEventListener('keydown', this.onPopupChildKeydown_);
        });
        this.pickerC_ = pickerC;
        if (this.popC_) {
            this.view.element.appendChild(this.popC_.view.element);
            this.popC_.view.element.appendChild(pickerC.view.element);
            $9168155af81732ad$var$connectValues({
                primary: this.foldable_.value('expanded'),
                secondary: this.popC_.shows,
                forward: (p)=>p,
                backward: (_, s)=>s
            });
        } else if (this.view.pickerElement) {
            this.view.pickerElement.appendChild(this.pickerC_.view.element);
            $9168155af81732ad$var$bindFoldable(this.foldable_, this.view.pickerElement);
        }
    }
    get textController() {
        return this.textC_;
    }
    onButtonBlur_(e) {
        if (!this.popC_) return;
        const elem = this.view.element;
        const nextTarget = $9168155af81732ad$var$forceCast(e.relatedTarget);
        if (!nextTarget || !elem.contains(nextTarget)) this.popC_.shows.rawValue = false;
    }
    onButtonClick_() {
        this.foldable_.set('expanded', !this.foldable_.get('expanded'));
        if (this.foldable_.get('expanded')) this.pickerC_.view.allFocusableElements[0].focus();
    }
    onPopupChildBlur_(ev) {
        if (!this.popC_) return;
        const elem = this.popC_.view.element;
        const nextTarget = $9168155af81732ad$var$findNextTarget(ev);
        if (nextTarget && elem.contains(nextTarget)) return;
        if (nextTarget && nextTarget === this.swatchC_.view.buttonElement && !$9168155af81732ad$var$supportsTouch(elem.ownerDocument)) return;
        this.popC_.shows.rawValue = false;
    }
    onPopupChildKeydown_(ev) {
        if (this.popC_) {
            if (ev.key === 'Escape') this.popC_.shows.rawValue = false;
        } else if (this.view.pickerElement) {
            if (ev.key === 'Escape') this.swatchC_.view.buttonElement.focus();
        }
    }
}
function $9168155af81732ad$var$colorToRgbNumber(value) {
    return $9168155af81732ad$var$removeAlphaComponent(value.getComponents('rgb')).reduce((result, comp)=>{
        return result << 8 | Math.floor(comp) & 0xff;
    }, 0);
}
function $9168155af81732ad$var$colorToRgbaNumber(value) {
    return value.getComponents('rgb').reduce((result, comp, index)=>{
        const hex = Math.floor(index === 3 ? comp * 255 : comp) & 0xff;
        return result << 8 | hex;
    }, 0) >>> 0;
}
function $9168155af81732ad$var$numberToRgbColor(num) {
    return new $9168155af81732ad$var$IntColor([
        num >> 16 & 0xff,
        num >> 8 & 0xff,
        num & 0xff
    ], 'rgb');
}
function $9168155af81732ad$var$numberToRgbaColor(num) {
    return new $9168155af81732ad$var$IntColor([
        num >> 24 & 0xff,
        num >> 16 & 0xff,
        num >> 8 & 0xff,
        $9168155af81732ad$var$mapRange(num & 0xff, 0, 255, 0, 1)
    ], 'rgb');
}
function $9168155af81732ad$var$colorFromRgbNumber(value) {
    if (typeof value !== 'number') return $9168155af81732ad$var$IntColor.black();
    return $9168155af81732ad$var$numberToRgbColor(value);
}
function $9168155af81732ad$var$colorFromRgbaNumber(value) {
    if (typeof value !== 'number') return $9168155af81732ad$var$IntColor.black();
    return $9168155af81732ad$var$numberToRgbaColor(value);
}
function $9168155af81732ad$var$isRgbColorComponent(obj, key) {
    if (typeof obj !== 'object' || $9168155af81732ad$var$isEmpty(obj)) return false;
    return key in obj && typeof obj[key] === 'number';
}
function $9168155af81732ad$var$isRgbColorObject(obj) {
    return $9168155af81732ad$var$isRgbColorComponent(obj, 'r') && $9168155af81732ad$var$isRgbColorComponent(obj, 'g') && $9168155af81732ad$var$isRgbColorComponent(obj, 'b');
}
function $9168155af81732ad$var$isRgbaColorObject(obj) {
    return $9168155af81732ad$var$isRgbColorObject(obj) && $9168155af81732ad$var$isRgbColorComponent(obj, 'a');
}
function $9168155af81732ad$var$isColorObject(obj) {
    return $9168155af81732ad$var$isRgbColorObject(obj);
}
function $9168155af81732ad$var$equalsColor(v1, v2) {
    if (v1.mode !== v2.mode) return false;
    if (v1.type !== v2.type) return false;
    const comps1 = v1.getComponents();
    const comps2 = v2.getComponents();
    for(let i = 0; i < comps1.length; i++){
        if (comps1[i] !== comps2[i]) return false;
    }
    return true;
}
function $9168155af81732ad$var$createColorComponentsFromRgbObject(obj) {
    return 'a' in obj ? [
        obj.r,
        obj.g,
        obj.b,
        obj.a
    ] : [
        obj.r,
        obj.g,
        obj.b
    ];
}
function $9168155af81732ad$var$createColorStringWriter(format) {
    const stringify = $9168155af81732ad$var$findColorStringifier(format);
    return stringify ? (target, value)=>{
        $9168155af81732ad$var$writePrimitive(target, stringify(value));
    } : null;
}
function $9168155af81732ad$var$createColorNumberWriter(supportsAlpha) {
    const colorToNumber = supportsAlpha ? $9168155af81732ad$var$colorToRgbaNumber : $9168155af81732ad$var$colorToRgbNumber;
    return (target, value)=>{
        $9168155af81732ad$var$writePrimitive(target, colorToNumber(value));
    };
}
function $9168155af81732ad$var$writeRgbaColorObject(target, value, type) {
    const cc = $9168155af81732ad$var$mapColorType(value, type);
    const obj = cc.toRgbaObject();
    target.writeProperty('r', obj.r);
    target.writeProperty('g', obj.g);
    target.writeProperty('b', obj.b);
    target.writeProperty('a', obj.a);
}
function $9168155af81732ad$var$writeRgbColorObject(target, value, type) {
    const cc = $9168155af81732ad$var$mapColorType(value, type);
    const obj = cc.toRgbaObject();
    target.writeProperty('r', obj.r);
    target.writeProperty('g', obj.g);
    target.writeProperty('b', obj.b);
}
function $9168155af81732ad$var$createColorObjectWriter(supportsAlpha, type) {
    return (target, inValue)=>{
        if (supportsAlpha) $9168155af81732ad$var$writeRgbaColorObject(target, inValue, type);
        else $9168155af81732ad$var$writeRgbColorObject(target, inValue, type);
    };
}
function $9168155af81732ad$var$shouldSupportAlpha$1(inputParams) {
    var _a;
    if ((_a = inputParams === null || inputParams === void 0 ? void 0 : inputParams.color) === null || _a === void 0 ? void 0 : _a.alpha) return true;
    return false;
}
function $9168155af81732ad$var$createFormatter$1(supportsAlpha) {
    return supportsAlpha ? (v)=>$9168155af81732ad$var$colorToHexRgbaString(v, '0x') : (v)=>$9168155af81732ad$var$colorToHexRgbString(v, '0x');
}
function $9168155af81732ad$var$isForColor(params) {
    if ('color' in params) return true;
    if (params.view === 'color') return true;
    return false;
}
const $9168155af81732ad$var$NumberColorInputPlugin = $9168155af81732ad$var$createPlugin({
    id: 'input-color-number',
    type: 'input',
    accept: (value, params)=>{
        if (typeof value !== 'number') return null;
        if (!$9168155af81732ad$var$isForColor(params)) return null;
        const result = $9168155af81732ad$var$parseColorInputParams(params);
        return result ? {
            initialValue: value,
            params: Object.assign(Object.assign({}, result), {
                supportsAlpha: $9168155af81732ad$var$shouldSupportAlpha$1(params)
            })
        } : null;
    },
    binding: {
        reader: (args)=>{
            return args.params.supportsAlpha ? $9168155af81732ad$var$colorFromRgbaNumber : $9168155af81732ad$var$colorFromRgbNumber;
        },
        equals: $9168155af81732ad$var$equalsColor,
        writer: (args)=>{
            return $9168155af81732ad$var$createColorNumberWriter(args.params.supportsAlpha);
        }
    },
    controller: (args)=>{
        var _a, _b;
        return new $9168155af81732ad$var$ColorController(args.document, {
            colorType: 'int',
            expanded: (_a = args.params.expanded) !== null && _a !== void 0 ? _a : false,
            formatter: $9168155af81732ad$var$createFormatter$1(args.params.supportsAlpha),
            parser: $9168155af81732ad$var$createColorStringParser('int'),
            pickerLayout: (_b = args.params.picker) !== null && _b !== void 0 ? _b : 'popup',
            supportsAlpha: args.params.supportsAlpha,
            value: args.value,
            viewProps: args.viewProps
        });
    }
});
function $9168155af81732ad$var$colorFromObject(value, type) {
    if (!$9168155af81732ad$var$isColorObject(value)) return $9168155af81732ad$var$mapColorType($9168155af81732ad$var$IntColor.black(), type);
    if (type === 'int') {
        const comps = $9168155af81732ad$var$createColorComponentsFromRgbObject(value);
        return new $9168155af81732ad$var$IntColor(comps, 'rgb');
    }
    if (type === 'float') {
        const comps = $9168155af81732ad$var$createColorComponentsFromRgbObject(value);
        return new $9168155af81732ad$var$FloatColor(comps, 'rgb');
    }
    return $9168155af81732ad$var$mapColorType($9168155af81732ad$var$IntColor.black(), 'int');
}
function $9168155af81732ad$var$shouldSupportAlpha(initialValue) {
    return $9168155af81732ad$var$isRgbaColorObject(initialValue);
}
function $9168155af81732ad$var$createColorObjectBindingReader(type) {
    return (value)=>{
        const c = $9168155af81732ad$var$colorFromObject(value, type);
        return $9168155af81732ad$var$mapColorType(c, 'int');
    };
}
function $9168155af81732ad$var$createColorObjectFormatter(supportsAlpha, type) {
    return (value)=>{
        if (supportsAlpha) return $9168155af81732ad$var$colorToObjectRgbaString(value, type);
        return $9168155af81732ad$var$colorToObjectRgbString(value, type);
    };
}
const $9168155af81732ad$var$ObjectColorInputPlugin = $9168155af81732ad$var$createPlugin({
    id: 'input-color-object',
    type: 'input',
    accept: (value, params)=>{
        var _a;
        if (!$9168155af81732ad$var$isColorObject(value)) return null;
        const result = $9168155af81732ad$var$parseColorInputParams(params);
        return result ? {
            initialValue: value,
            params: Object.assign(Object.assign({}, result), {
                colorType: (_a = $9168155af81732ad$var$extractColorType(params)) !== null && _a !== void 0 ? _a : 'int'
            })
        } : null;
    },
    binding: {
        reader: (args)=>$9168155af81732ad$var$createColorObjectBindingReader(args.params.colorType),
        equals: $9168155af81732ad$var$equalsColor,
        writer: (args)=>$9168155af81732ad$var$createColorObjectWriter($9168155af81732ad$var$shouldSupportAlpha(args.initialValue), args.params.colorType)
    },
    controller: (args)=>{
        var _a, _b;
        const supportsAlpha = $9168155af81732ad$var$isRgbaColorObject(args.initialValue);
        return new $9168155af81732ad$var$ColorController(args.document, {
            colorType: args.params.colorType,
            expanded: (_a = args.params.expanded) !== null && _a !== void 0 ? _a : false,
            formatter: $9168155af81732ad$var$createColorObjectFormatter(supportsAlpha, args.params.colorType),
            parser: $9168155af81732ad$var$createColorStringParser('int'),
            pickerLayout: (_b = args.params.picker) !== null && _b !== void 0 ? _b : 'popup',
            supportsAlpha: supportsAlpha,
            value: args.value,
            viewProps: args.viewProps
        });
    }
});
const $9168155af81732ad$var$StringColorInputPlugin = $9168155af81732ad$var$createPlugin({
    id: 'input-color-string',
    type: 'input',
    accept: (value, params)=>{
        if (typeof value !== 'string') return null;
        if (params.view === 'text') return null;
        const format = $9168155af81732ad$var$detectStringColorFormat(value, $9168155af81732ad$var$extractColorType(params));
        if (!format) return null;
        const stringifier = $9168155af81732ad$var$findColorStringifier(format);
        if (!stringifier) return null;
        const result = $9168155af81732ad$var$parseColorInputParams(params);
        return result ? {
            initialValue: value,
            params: Object.assign(Object.assign({}, result), {
                format: format,
                stringifier: stringifier
            })
        } : null;
    },
    binding: {
        reader: ()=>$9168155af81732ad$var$readIntColorString,
        equals: $9168155af81732ad$var$equalsColor,
        writer: (args)=>{
            const writer = $9168155af81732ad$var$createColorStringWriter(args.params.format);
            if (!writer) throw $9168155af81732ad$var$TpError.notBindable();
            return writer;
        }
    },
    controller: (args)=>{
        var _a, _b;
        return new $9168155af81732ad$var$ColorController(args.document, {
            colorType: args.params.format.type,
            expanded: (_a = args.params.expanded) !== null && _a !== void 0 ? _a : false,
            formatter: args.params.stringifier,
            parser: $9168155af81732ad$var$createColorStringParser('int'),
            pickerLayout: (_b = args.params.picker) !== null && _b !== void 0 ? _b : 'popup',
            supportsAlpha: args.params.format.alpha,
            value: args.value,
            viewProps: args.viewProps
        });
    }
});
class $9168155af81732ad$var$PointNdConstraint {
    constructor(config){
        this.components = config.components;
        this.asm_ = config.assembly;
    }
    constrain(value) {
        const comps = this.asm_.toComponents(value).map((comp, index)=>{
            var _a, _b;
            return (_b = (_a = this.components[index]) === null || _a === void 0 ? void 0 : _a.constrain(comp)) !== null && _b !== void 0 ? _b : comp;
        });
        return this.asm_.fromComponents(comps);
    }
}
const $9168155af81732ad$var$cn$6 = $9168155af81732ad$var$ClassName('pndtxt');
class $9168155af81732ad$var$PointNdTextView {
    constructor(doc, config){
        this.textViews = config.textViews;
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$6());
        this.textViews.forEach((v)=>{
            const axisElem = doc.createElement('div');
            axisElem.classList.add($9168155af81732ad$var$cn$6('a'));
            axisElem.appendChild(v.element);
            this.element.appendChild(axisElem);
        });
    }
}
function $9168155af81732ad$var$createAxisController(doc, config, index) {
    return new $9168155af81732ad$var$NumberTextController(doc, {
        arrayPosition: index === 0 ? 'fst' : index === config.axes.length - 1 ? 'lst' : 'mid',
        parser: config.parser,
        props: config.axes[index].textProps,
        value: $9168155af81732ad$var$createValue(0, {
            constraint: config.axes[index].constraint
        }),
        viewProps: config.viewProps
    });
}
class $9168155af81732ad$var$PointNdTextController {
    constructor(doc, config){
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.acs_ = config.axes.map((_, index)=>$9168155af81732ad$var$createAxisController(doc, config, index));
        this.acs_.forEach((c, index)=>{
            $9168155af81732ad$var$connectValues({
                primary: this.value,
                secondary: c.value,
                forward: (p)=>config.assembly.toComponents(p)[index],
                backward: (p, s)=>{
                    const comps = config.assembly.toComponents(p);
                    comps[index] = s;
                    return config.assembly.fromComponents(comps);
                }
            });
        });
        this.view = new $9168155af81732ad$var$PointNdTextView(doc, {
            textViews: this.acs_.map((ac)=>ac.view)
        });
    }
    get textControllers() {
        return this.acs_;
    }
}
class $9168155af81732ad$export$3625dc7394defb1 extends $9168155af81732ad$var$BindingApi {
    get max() {
        return this.controller.valueController.sliderController.props.get('max');
    }
    set max(max) {
        this.controller.valueController.sliderController.props.set('max', max);
    }
    get min() {
        return this.controller.valueController.sliderController.props.get('min');
    }
    set min(max) {
        this.controller.valueController.sliderController.props.set('min', max);
    }
}
function $9168155af81732ad$var$createConstraint$4(params, initialValue) {
    const constraints = [];
    const sc = $9168155af81732ad$var$createStepConstraint(params, initialValue);
    if (sc) constraints.push(sc);
    const rc = $9168155af81732ad$var$createRangeConstraint(params);
    if (rc) constraints.push(rc);
    const lc = $9168155af81732ad$var$createListConstraint(params.options);
    if (lc) constraints.push(lc);
    return new $9168155af81732ad$var$CompositeConstraint(constraints);
}
const $9168155af81732ad$var$NumberInputPlugin = $9168155af81732ad$var$createPlugin({
    id: 'input-number',
    type: 'input',
    accept: (value, params)=>{
        if (typeof value !== 'number') return null;
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>Object.assign(Object.assign({}, $9168155af81732ad$var$createNumberTextInputParamsParser(p)), {
                options: p.optional.custom($9168155af81732ad$var$parseListOptions),
                readonly: p.optional.constant(false)
            }));
        return result ? {
            initialValue: value,
            params: result
        } : null;
    },
    binding: {
        reader: (_args)=>$9168155af81732ad$var$numberFromUnknown,
        constraint: (args)=>$9168155af81732ad$var$createConstraint$4(args.params, args.initialValue),
        writer: (_args)=>$9168155af81732ad$var$writePrimitive
    },
    controller: (args)=>{
        const value = args.value;
        const c = args.constraint;
        const lc = c && $9168155af81732ad$var$findConstraint(c, $9168155af81732ad$var$ListConstraint);
        if (lc) return new $9168155af81732ad$var$ListController(args.document, {
            props: new $9168155af81732ad$var$ValueMap({
                options: lc.values.value('options')
            }),
            value: value,
            viewProps: args.viewProps
        });
        const textPropsObj = $9168155af81732ad$var$createNumberTextPropsObject(args.params, value.rawValue);
        const drc = c && $9168155af81732ad$var$findConstraint(c, $9168155af81732ad$var$DefiniteRangeConstraint);
        if (drc) return new $9168155af81732ad$var$SliderTextController(args.document, Object.assign(Object.assign({}, $9168155af81732ad$var$createSliderTextProps(Object.assign(Object.assign({}, textPropsObj), {
            keyScale: $9168155af81732ad$var$createValue(textPropsObj.keyScale),
            max: drc.values.value('max'),
            min: drc.values.value('min')
        }))), {
            parser: $9168155af81732ad$var$parseNumber,
            value: value,
            viewProps: args.viewProps
        }));
        return new $9168155af81732ad$var$NumberTextController(args.document, {
            parser: $9168155af81732ad$var$parseNumber,
            props: $9168155af81732ad$var$ValueMap.fromObject(textPropsObj),
            value: value,
            viewProps: args.viewProps
        });
    },
    api (args) {
        if (typeof args.controller.value.rawValue !== 'number') return null;
        if (args.controller.valueController instanceof $9168155af81732ad$var$SliderTextController) return new $9168155af81732ad$export$3625dc7394defb1(args.controller);
        if (args.controller.valueController instanceof $9168155af81732ad$var$ListController) return new $9168155af81732ad$export$fa8cb86ba0150173(args.controller);
        return null;
    }
});
class $9168155af81732ad$var$Point2d {
    constructor(x = 0, y = 0){
        this.x = x;
        this.y = y;
    }
    getComponents() {
        return [
            this.x,
            this.y
        ];
    }
    static isObject(obj) {
        if ($9168155af81732ad$var$isEmpty(obj)) return false;
        const x = obj.x;
        const y = obj.y;
        if (typeof x !== 'number' || typeof y !== 'number') return false;
        return true;
    }
    static equals(v1, v2) {
        return v1.x === v2.x && v1.y === v2.y;
    }
    toObject() {
        return {
            x: this.x,
            y: this.y
        };
    }
}
const $9168155af81732ad$var$Point2dAssembly = {
    toComponents: (p)=>p.getComponents(),
    fromComponents: (comps)=>new $9168155af81732ad$var$Point2d(...comps)
};
const $9168155af81732ad$var$cn$5 = $9168155af81732ad$var$ClassName('p2d');
class $9168155af81732ad$var$Point2dView {
    constructor(doc, config){
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$5());
        config.viewProps.bindClassModifiers(this.element);
        $9168155af81732ad$var$bindValue(config.expanded, $9168155af81732ad$var$valueToClassName(this.element, $9168155af81732ad$var$cn$5(undefined, 'expanded')));
        const headElem = doc.createElement('div');
        headElem.classList.add($9168155af81732ad$var$cn$5('h'));
        this.element.appendChild(headElem);
        const buttonElem = doc.createElement('button');
        buttonElem.classList.add($9168155af81732ad$var$cn$5('b'));
        buttonElem.appendChild($9168155af81732ad$var$createSvgIconElement(doc, 'p2dpad'));
        config.viewProps.bindDisabled(buttonElem);
        headElem.appendChild(buttonElem);
        this.buttonElement = buttonElem;
        const textElem = doc.createElement('div');
        textElem.classList.add($9168155af81732ad$var$cn$5('t'));
        headElem.appendChild(textElem);
        this.textElement = textElem;
        if (config.pickerLayout === 'inline') {
            const pickerElem = doc.createElement('div');
            pickerElem.classList.add($9168155af81732ad$var$cn$5('p'));
            this.element.appendChild(pickerElem);
            this.pickerElement = pickerElem;
        } else this.pickerElement = null;
    }
}
const $9168155af81732ad$var$cn$4 = $9168155af81732ad$var$ClassName('p2dp');
class $9168155af81732ad$var$Point2dPickerView {
    constructor(doc, config){
        this.onFoldableChange_ = this.onFoldableChange_.bind(this);
        this.onPropsChange_ = this.onPropsChange_.bind(this);
        this.onValueChange_ = this.onValueChange_.bind(this);
        this.props_ = config.props;
        this.props_.emitter.on('change', this.onPropsChange_);
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$4());
        if (config.layout === 'popup') this.element.classList.add($9168155af81732ad$var$cn$4(undefined, 'p'));
        config.viewProps.bindClassModifiers(this.element);
        const padElem = doc.createElement('div');
        padElem.classList.add($9168155af81732ad$var$cn$4('p'));
        config.viewProps.bindTabIndex(padElem);
        this.element.appendChild(padElem);
        this.padElement = padElem;
        const svgElem = doc.createElementNS($9168155af81732ad$var$SVG_NS, 'svg');
        svgElem.classList.add($9168155af81732ad$var$cn$4('g'));
        this.padElement.appendChild(svgElem);
        this.svgElem_ = svgElem;
        const xAxisElem = doc.createElementNS($9168155af81732ad$var$SVG_NS, 'line');
        xAxisElem.classList.add($9168155af81732ad$var$cn$4('ax'));
        xAxisElem.setAttributeNS(null, 'x1', '0');
        xAxisElem.setAttributeNS(null, 'y1', '50%');
        xAxisElem.setAttributeNS(null, 'x2', '100%');
        xAxisElem.setAttributeNS(null, 'y2', '50%');
        this.svgElem_.appendChild(xAxisElem);
        const yAxisElem = doc.createElementNS($9168155af81732ad$var$SVG_NS, 'line');
        yAxisElem.classList.add($9168155af81732ad$var$cn$4('ax'));
        yAxisElem.setAttributeNS(null, 'x1', '50%');
        yAxisElem.setAttributeNS(null, 'y1', '0');
        yAxisElem.setAttributeNS(null, 'x2', '50%');
        yAxisElem.setAttributeNS(null, 'y2', '100%');
        this.svgElem_.appendChild(yAxisElem);
        const lineElem = doc.createElementNS($9168155af81732ad$var$SVG_NS, 'line');
        lineElem.classList.add($9168155af81732ad$var$cn$4('l'));
        lineElem.setAttributeNS(null, 'x1', '50%');
        lineElem.setAttributeNS(null, 'y1', '50%');
        this.svgElem_.appendChild(lineElem);
        this.lineElem_ = lineElem;
        const markerElem = doc.createElement('div');
        markerElem.classList.add($9168155af81732ad$var$cn$4('m'));
        this.padElement.appendChild(markerElem);
        this.markerElem_ = markerElem;
        config.value.emitter.on('change', this.onValueChange_);
        this.value = config.value;
        this.update_();
    }
    get allFocusableElements() {
        return [
            this.padElement
        ];
    }
    update_() {
        const [x, y] = this.value.rawValue.getComponents();
        const max = this.props_.get('max');
        const px = $9168155af81732ad$var$mapRange(x, -max, +max, 0, 100);
        const py = $9168155af81732ad$var$mapRange(y, -max, +max, 0, 100);
        const ipy = this.props_.get('invertsY') ? 100 - py : py;
        this.lineElem_.setAttributeNS(null, 'x2', `${px}%`);
        this.lineElem_.setAttributeNS(null, 'y2', `${ipy}%`);
        this.markerElem_.style.left = `${px}%`;
        this.markerElem_.style.top = `${ipy}%`;
    }
    onValueChange_() {
        this.update_();
    }
    onPropsChange_() {
        this.update_();
    }
    onFoldableChange_() {
        this.update_();
    }
}
function $9168155af81732ad$var$computeOffset(ev, keyScales, invertsY) {
    return [
        $9168155af81732ad$var$getStepForKey(keyScales[0], $9168155af81732ad$var$getHorizontalStepKeys(ev)),
        $9168155af81732ad$var$getStepForKey(keyScales[1], $9168155af81732ad$var$getVerticalStepKeys(ev)) * (invertsY ? 1 : -1)
    ];
}
class $9168155af81732ad$var$Point2dPickerController {
    constructor(doc, config){
        this.onPadKeyDown_ = this.onPadKeyDown_.bind(this);
        this.onPadKeyUp_ = this.onPadKeyUp_.bind(this);
        this.onPointerDown_ = this.onPointerDown_.bind(this);
        this.onPointerMove_ = this.onPointerMove_.bind(this);
        this.onPointerUp_ = this.onPointerUp_.bind(this);
        this.props = config.props;
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$Point2dPickerView(doc, {
            layout: config.layout,
            props: this.props,
            value: this.value,
            viewProps: this.viewProps
        });
        this.ptHandler_ = new $9168155af81732ad$var$PointerHandler(this.view.padElement);
        this.ptHandler_.emitter.on('down', this.onPointerDown_);
        this.ptHandler_.emitter.on('move', this.onPointerMove_);
        this.ptHandler_.emitter.on('up', this.onPointerUp_);
        this.view.padElement.addEventListener('keydown', this.onPadKeyDown_);
        this.view.padElement.addEventListener('keyup', this.onPadKeyUp_);
    }
    handlePointerEvent_(d, opts) {
        if (!d.point) return;
        const max = this.props.get('max');
        const px = $9168155af81732ad$var$mapRange(d.point.x, 0, d.bounds.width, -max, +max);
        const py = $9168155af81732ad$var$mapRange(this.props.get('invertsY') ? d.bounds.height - d.point.y : d.point.y, 0, d.bounds.height, -max, +max);
        this.value.setRawValue(new $9168155af81732ad$var$Point2d(px, py), opts);
    }
    onPointerDown_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: false,
            last: false
        });
    }
    onPointerMove_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: false,
            last: false
        });
    }
    onPointerUp_(ev) {
        this.handlePointerEvent_(ev.data, {
            forceEmit: true,
            last: true
        });
    }
    onPadKeyDown_(ev) {
        if ($9168155af81732ad$var$isArrowKey(ev.key)) ev.preventDefault();
        const [dx, dy] = $9168155af81732ad$var$computeOffset(ev, [
            this.props.get('xKeyScale'),
            this.props.get('yKeyScale')
        ], this.props.get('invertsY'));
        if (dx === 0 && dy === 0) return;
        this.value.setRawValue(new $9168155af81732ad$var$Point2d(this.value.rawValue.x + dx, this.value.rawValue.y + dy), {
            forceEmit: false,
            last: false
        });
    }
    onPadKeyUp_(ev) {
        const [dx, dy] = $9168155af81732ad$var$computeOffset(ev, [
            this.props.get('xKeyScale'),
            this.props.get('yKeyScale')
        ], this.props.get('invertsY'));
        if (dx === 0 && dy === 0) return;
        this.value.setRawValue(this.value.rawValue, {
            forceEmit: true,
            last: true
        });
    }
}
class $9168155af81732ad$var$Point2dController {
    constructor(doc, config){
        var _a, _b;
        this.onPopupChildBlur_ = this.onPopupChildBlur_.bind(this);
        this.onPopupChildKeydown_ = this.onPopupChildKeydown_.bind(this);
        this.onPadButtonBlur_ = this.onPadButtonBlur_.bind(this);
        this.onPadButtonClick_ = this.onPadButtonClick_.bind(this);
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.foldable_ = $9168155af81732ad$var$Foldable.create(config.expanded);
        this.popC_ = config.pickerLayout === 'popup' ? new $9168155af81732ad$var$PopupController(doc, {
            viewProps: this.viewProps
        }) : null;
        const padC = new $9168155af81732ad$var$Point2dPickerController(doc, {
            layout: config.pickerLayout,
            props: new $9168155af81732ad$var$ValueMap({
                invertsY: $9168155af81732ad$var$createValue(config.invertsY),
                max: $9168155af81732ad$var$createValue(config.max),
                xKeyScale: config.axes[0].textProps.value('keyScale'),
                yKeyScale: config.axes[1].textProps.value('keyScale')
            }),
            value: this.value,
            viewProps: this.viewProps
        });
        padC.view.allFocusableElements.forEach((elem)=>{
            elem.addEventListener('blur', this.onPopupChildBlur_);
            elem.addEventListener('keydown', this.onPopupChildKeydown_);
        });
        this.pickerC_ = padC;
        this.textC_ = new $9168155af81732ad$var$PointNdTextController(doc, {
            assembly: $9168155af81732ad$var$Point2dAssembly,
            axes: config.axes,
            parser: config.parser,
            value: this.value,
            viewProps: this.viewProps
        });
        this.view = new $9168155af81732ad$var$Point2dView(doc, {
            expanded: this.foldable_.value('expanded'),
            pickerLayout: config.pickerLayout,
            viewProps: this.viewProps
        });
        this.view.textElement.appendChild(this.textC_.view.element);
        (_a = this.view.buttonElement) === null || _a === void 0 || _a.addEventListener('blur', this.onPadButtonBlur_);
        (_b = this.view.buttonElement) === null || _b === void 0 || _b.addEventListener('click', this.onPadButtonClick_);
        if (this.popC_) {
            this.view.element.appendChild(this.popC_.view.element);
            this.popC_.view.element.appendChild(this.pickerC_.view.element);
            $9168155af81732ad$var$connectValues({
                primary: this.foldable_.value('expanded'),
                secondary: this.popC_.shows,
                forward: (p)=>p,
                backward: (_, s)=>s
            });
        } else if (this.view.pickerElement) {
            this.view.pickerElement.appendChild(this.pickerC_.view.element);
            $9168155af81732ad$var$bindFoldable(this.foldable_, this.view.pickerElement);
        }
    }
    get textController() {
        return this.textC_;
    }
    onPadButtonBlur_(e) {
        if (!this.popC_) return;
        const elem = this.view.element;
        const nextTarget = $9168155af81732ad$var$forceCast(e.relatedTarget);
        if (!nextTarget || !elem.contains(nextTarget)) this.popC_.shows.rawValue = false;
    }
    onPadButtonClick_() {
        this.foldable_.set('expanded', !this.foldable_.get('expanded'));
        if (this.foldable_.get('expanded')) this.pickerC_.view.allFocusableElements[0].focus();
    }
    onPopupChildBlur_(ev) {
        if (!this.popC_) return;
        const elem = this.popC_.view.element;
        const nextTarget = $9168155af81732ad$var$findNextTarget(ev);
        if (nextTarget && elem.contains(nextTarget)) return;
        if (nextTarget && nextTarget === this.view.buttonElement && !$9168155af81732ad$var$supportsTouch(elem.ownerDocument)) return;
        this.popC_.shows.rawValue = false;
    }
    onPopupChildKeydown_(ev) {
        if (this.popC_) {
            if (ev.key === 'Escape') this.popC_.shows.rawValue = false;
        } else if (this.view.pickerElement) {
            if (ev.key === 'Escape') this.view.buttonElement.focus();
        }
    }
}
function $9168155af81732ad$var$point2dFromUnknown(value) {
    return $9168155af81732ad$var$Point2d.isObject(value) ? new $9168155af81732ad$var$Point2d(value.x, value.y) : new $9168155af81732ad$var$Point2d();
}
function $9168155af81732ad$var$writePoint2d(target, value) {
    target.writeProperty('x', value.x);
    target.writeProperty('y', value.y);
}
function $9168155af81732ad$var$createConstraint$3(params, initialValue) {
    return new $9168155af81732ad$var$PointNdConstraint({
        assembly: $9168155af81732ad$var$Point2dAssembly,
        components: [
            $9168155af81732ad$var$createDimensionConstraint(Object.assign(Object.assign({}, params), params.x), initialValue.x),
            $9168155af81732ad$var$createDimensionConstraint(Object.assign(Object.assign({}, params), params.y), initialValue.y)
        ]
    });
}
function $9168155af81732ad$var$getSuitableMaxDimensionValue(params, rawValue) {
    var _a, _b;
    if (!$9168155af81732ad$var$isEmpty(params.min) || !$9168155af81732ad$var$isEmpty(params.max)) return Math.max(Math.abs((_a = params.min) !== null && _a !== void 0 ? _a : 0), Math.abs((_b = params.max) !== null && _b !== void 0 ? _b : 0));
    const step = $9168155af81732ad$var$getSuitableKeyScale(params);
    return Math.max(Math.abs(step) * 10, Math.abs(rawValue) * 10);
}
function $9168155af81732ad$var$getSuitableMax(params, initialValue) {
    var _a, _b;
    const xr = $9168155af81732ad$var$getSuitableMaxDimensionValue($9168155af81732ad$var$deepMerge(params, (_a = params.x) !== null && _a !== void 0 ? _a : {}), initialValue.x);
    const yr = $9168155af81732ad$var$getSuitableMaxDimensionValue($9168155af81732ad$var$deepMerge(params, (_b = params.y) !== null && _b !== void 0 ? _b : {}), initialValue.y);
    return Math.max(xr, yr);
}
function $9168155af81732ad$var$shouldInvertY(params) {
    if (!('y' in params)) return false;
    const yParams = params.y;
    if (!yParams) return false;
    return 'inverted' in yParams ? !!yParams.inverted : false;
}
const $9168155af81732ad$var$Point2dInputPlugin = $9168155af81732ad$var$createPlugin({
    id: 'input-point2d',
    type: 'input',
    accept: (value, params)=>{
        if (!$9168155af81732ad$var$Point2d.isObject(value)) return null;
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>Object.assign(Object.assign({}, $9168155af81732ad$var$createPointDimensionParser(p)), {
                expanded: p.optional.boolean,
                picker: p.optional.custom($9168155af81732ad$var$parsePickerLayout),
                readonly: p.optional.constant(false),
                x: p.optional.custom($9168155af81732ad$var$parsePointDimensionParams),
                y: p.optional.object(Object.assign(Object.assign({}, $9168155af81732ad$var$createPointDimensionParser(p)), {
                    inverted: p.optional.boolean
                }))
            }));
        return result ? {
            initialValue: value,
            params: result
        } : null;
    },
    binding: {
        reader: ()=>$9168155af81732ad$var$point2dFromUnknown,
        constraint: (args)=>$9168155af81732ad$var$createConstraint$3(args.params, args.initialValue),
        equals: $9168155af81732ad$var$Point2d.equals,
        writer: ()=>$9168155af81732ad$var$writePoint2d
    },
    controller: (args)=>{
        var _a, _b;
        const doc = args.document;
        const value = args.value;
        const c = args.constraint;
        const dParams = [
            args.params.x,
            args.params.y
        ];
        return new $9168155af81732ad$var$Point2dController(doc, {
            axes: value.rawValue.getComponents().map((comp, i)=>{
                var _a;
                return $9168155af81732ad$var$createPointAxis({
                    constraint: c.components[i],
                    initialValue: comp,
                    params: $9168155af81732ad$var$deepMerge(args.params, (_a = dParams[i]) !== null && _a !== void 0 ? _a : {})
                });
            }),
            expanded: (_a = args.params.expanded) !== null && _a !== void 0 ? _a : false,
            invertsY: $9168155af81732ad$var$shouldInvertY(args.params),
            max: $9168155af81732ad$var$getSuitableMax(args.params, value.rawValue),
            parser: $9168155af81732ad$var$parseNumber,
            pickerLayout: (_b = args.params.picker) !== null && _b !== void 0 ? _b : 'popup',
            value: value,
            viewProps: args.viewProps
        });
    }
});
class $9168155af81732ad$var$Point3d {
    constructor(x = 0, y = 0, z = 0){
        this.x = x;
        this.y = y;
        this.z = z;
    }
    getComponents() {
        return [
            this.x,
            this.y,
            this.z
        ];
    }
    static isObject(obj) {
        if ($9168155af81732ad$var$isEmpty(obj)) return false;
        const x = obj.x;
        const y = obj.y;
        const z = obj.z;
        if (typeof x !== 'number' || typeof y !== 'number' || typeof z !== 'number') return false;
        return true;
    }
    static equals(v1, v2) {
        return v1.x === v2.x && v1.y === v2.y && v1.z === v2.z;
    }
    toObject() {
        return {
            x: this.x,
            y: this.y,
            z: this.z
        };
    }
}
const $9168155af81732ad$var$Point3dAssembly = {
    toComponents: (p)=>p.getComponents(),
    fromComponents: (comps)=>new $9168155af81732ad$var$Point3d(...comps)
};
function $9168155af81732ad$var$point3dFromUnknown(value) {
    return $9168155af81732ad$var$Point3d.isObject(value) ? new $9168155af81732ad$var$Point3d(value.x, value.y, value.z) : new $9168155af81732ad$var$Point3d();
}
function $9168155af81732ad$var$writePoint3d(target, value) {
    target.writeProperty('x', value.x);
    target.writeProperty('y', value.y);
    target.writeProperty('z', value.z);
}
function $9168155af81732ad$var$createConstraint$2(params, initialValue) {
    return new $9168155af81732ad$var$PointNdConstraint({
        assembly: $9168155af81732ad$var$Point3dAssembly,
        components: [
            $9168155af81732ad$var$createDimensionConstraint(Object.assign(Object.assign({}, params), params.x), initialValue.x),
            $9168155af81732ad$var$createDimensionConstraint(Object.assign(Object.assign({}, params), params.y), initialValue.y),
            $9168155af81732ad$var$createDimensionConstraint(Object.assign(Object.assign({}, params), params.z), initialValue.z)
        ]
    });
}
const $9168155af81732ad$var$Point3dInputPlugin = $9168155af81732ad$var$createPlugin({
    id: 'input-point3d',
    type: 'input',
    accept: (value, params)=>{
        if (!$9168155af81732ad$var$Point3d.isObject(value)) return null;
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>Object.assign(Object.assign({}, $9168155af81732ad$var$createPointDimensionParser(p)), {
                readonly: p.optional.constant(false),
                x: p.optional.custom($9168155af81732ad$var$parsePointDimensionParams),
                y: p.optional.custom($9168155af81732ad$var$parsePointDimensionParams),
                z: p.optional.custom($9168155af81732ad$var$parsePointDimensionParams)
            }));
        return result ? {
            initialValue: value,
            params: result
        } : null;
    },
    binding: {
        reader: (_args)=>$9168155af81732ad$var$point3dFromUnknown,
        constraint: (args)=>$9168155af81732ad$var$createConstraint$2(args.params, args.initialValue),
        equals: $9168155af81732ad$var$Point3d.equals,
        writer: (_args)=>$9168155af81732ad$var$writePoint3d
    },
    controller: (args)=>{
        const value = args.value;
        const c = args.constraint;
        const dParams = [
            args.params.x,
            args.params.y,
            args.params.z
        ];
        return new $9168155af81732ad$var$PointNdTextController(args.document, {
            assembly: $9168155af81732ad$var$Point3dAssembly,
            axes: value.rawValue.getComponents().map((comp, i)=>{
                var _a;
                return $9168155af81732ad$var$createPointAxis({
                    constraint: c.components[i],
                    initialValue: comp,
                    params: $9168155af81732ad$var$deepMerge(args.params, (_a = dParams[i]) !== null && _a !== void 0 ? _a : {})
                });
            }),
            parser: $9168155af81732ad$var$parseNumber,
            value: value,
            viewProps: args.viewProps
        });
    }
});
class $9168155af81732ad$var$Point4d {
    constructor(x = 0, y = 0, z = 0, w = 0){
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    getComponents() {
        return [
            this.x,
            this.y,
            this.z,
            this.w
        ];
    }
    static isObject(obj) {
        if ($9168155af81732ad$var$isEmpty(obj)) return false;
        const x = obj.x;
        const y = obj.y;
        const z = obj.z;
        const w = obj.w;
        if (typeof x !== 'number' || typeof y !== 'number' || typeof z !== 'number' || typeof w !== 'number') return false;
        return true;
    }
    static equals(v1, v2) {
        return v1.x === v2.x && v1.y === v2.y && v1.z === v2.z && v1.w === v2.w;
    }
    toObject() {
        return {
            x: this.x,
            y: this.y,
            z: this.z,
            w: this.w
        };
    }
}
const $9168155af81732ad$var$Point4dAssembly = {
    toComponents: (p)=>p.getComponents(),
    fromComponents: (comps)=>new $9168155af81732ad$var$Point4d(...comps)
};
function $9168155af81732ad$var$point4dFromUnknown(value) {
    return $9168155af81732ad$var$Point4d.isObject(value) ? new $9168155af81732ad$var$Point4d(value.x, value.y, value.z, value.w) : new $9168155af81732ad$var$Point4d();
}
function $9168155af81732ad$var$writePoint4d(target, value) {
    target.writeProperty('x', value.x);
    target.writeProperty('y', value.y);
    target.writeProperty('z', value.z);
    target.writeProperty('w', value.w);
}
function $9168155af81732ad$var$createConstraint$1(params, initialValue) {
    return new $9168155af81732ad$var$PointNdConstraint({
        assembly: $9168155af81732ad$var$Point4dAssembly,
        components: [
            $9168155af81732ad$var$createDimensionConstraint(Object.assign(Object.assign({}, params), params.x), initialValue.x),
            $9168155af81732ad$var$createDimensionConstraint(Object.assign(Object.assign({}, params), params.y), initialValue.y),
            $9168155af81732ad$var$createDimensionConstraint(Object.assign(Object.assign({}, params), params.z), initialValue.z),
            $9168155af81732ad$var$createDimensionConstraint(Object.assign(Object.assign({}, params), params.w), initialValue.w)
        ]
    });
}
const $9168155af81732ad$var$Point4dInputPlugin = $9168155af81732ad$var$createPlugin({
    id: 'input-point4d',
    type: 'input',
    accept: (value, params)=>{
        if (!$9168155af81732ad$var$Point4d.isObject(value)) return null;
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>Object.assign(Object.assign({}, $9168155af81732ad$var$createPointDimensionParser(p)), {
                readonly: p.optional.constant(false),
                w: p.optional.custom($9168155af81732ad$var$parsePointDimensionParams),
                x: p.optional.custom($9168155af81732ad$var$parsePointDimensionParams),
                y: p.optional.custom($9168155af81732ad$var$parsePointDimensionParams),
                z: p.optional.custom($9168155af81732ad$var$parsePointDimensionParams)
            }));
        return result ? {
            initialValue: value,
            params: result
        } : null;
    },
    binding: {
        reader: (_args)=>$9168155af81732ad$var$point4dFromUnknown,
        constraint: (args)=>$9168155af81732ad$var$createConstraint$1(args.params, args.initialValue),
        equals: $9168155af81732ad$var$Point4d.equals,
        writer: (_args)=>$9168155af81732ad$var$writePoint4d
    },
    controller: (args)=>{
        const value = args.value;
        const c = args.constraint;
        const dParams = [
            args.params.x,
            args.params.y,
            args.params.z,
            args.params.w
        ];
        return new $9168155af81732ad$var$PointNdTextController(args.document, {
            assembly: $9168155af81732ad$var$Point4dAssembly,
            axes: value.rawValue.getComponents().map((comp, i)=>{
                var _a;
                return $9168155af81732ad$var$createPointAxis({
                    constraint: c.components[i],
                    initialValue: comp,
                    params: $9168155af81732ad$var$deepMerge(args.params, (_a = dParams[i]) !== null && _a !== void 0 ? _a : {})
                });
            }),
            parser: $9168155af81732ad$var$parseNumber,
            value: value,
            viewProps: args.viewProps
        });
    }
});
function $9168155af81732ad$var$createConstraint(params) {
    const constraints = [];
    const lc = $9168155af81732ad$var$createListConstraint(params.options);
    if (lc) constraints.push(lc);
    return new $9168155af81732ad$var$CompositeConstraint(constraints);
}
const $9168155af81732ad$var$StringInputPlugin = $9168155af81732ad$var$createPlugin({
    id: 'input-string',
    type: 'input',
    accept: (value, params)=>{
        if (typeof value !== 'string') return null;
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                readonly: p.optional.constant(false),
                options: p.optional.custom($9168155af81732ad$var$parseListOptions)
            }));
        return result ? {
            initialValue: value,
            params: result
        } : null;
    },
    binding: {
        reader: (_args)=>$9168155af81732ad$var$stringFromUnknown,
        constraint: (args)=>$9168155af81732ad$var$createConstraint(args.params),
        writer: (_args)=>$9168155af81732ad$var$writePrimitive
    },
    controller: (args)=>{
        const doc = args.document;
        const value = args.value;
        const c = args.constraint;
        const lc = c && $9168155af81732ad$var$findConstraint(c, $9168155af81732ad$var$ListConstraint);
        if (lc) return new $9168155af81732ad$var$ListController(doc, {
            props: new $9168155af81732ad$var$ValueMap({
                options: lc.values.value('options')
            }),
            value: value,
            viewProps: args.viewProps
        });
        return new $9168155af81732ad$var$TextController(doc, {
            parser: (v)=>v,
            props: $9168155af81732ad$var$ValueMap.fromObject({
                formatter: $9168155af81732ad$var$formatString
            }),
            value: value,
            viewProps: args.viewProps
        });
    },
    api (args) {
        if (typeof args.controller.value.rawValue !== 'string') return null;
        if (args.controller.valueController instanceof $9168155af81732ad$var$ListController) return new $9168155af81732ad$export$fa8cb86ba0150173(args.controller);
        return null;
    }
});
const $9168155af81732ad$var$Constants = {
    monitor: {
        defaultInterval: 200,
        defaultRows: 3
    }
};
const $9168155af81732ad$var$cn$3 = $9168155af81732ad$var$ClassName('mll');
class $9168155af81732ad$var$MultiLogView {
    constructor(doc, config){
        this.onValueUpdate_ = this.onValueUpdate_.bind(this);
        this.formatter_ = config.formatter;
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$3());
        config.viewProps.bindClassModifiers(this.element);
        const textareaElem = doc.createElement('textarea');
        textareaElem.classList.add($9168155af81732ad$var$cn$3('i'));
        textareaElem.style.height = `calc(var(${$9168155af81732ad$var$getCssVar('containerUnitSize')}) * ${config.rows})`;
        textareaElem.readOnly = true;
        config.viewProps.bindDisabled(textareaElem);
        this.element.appendChild(textareaElem);
        this.textareaElem_ = textareaElem;
        config.value.emitter.on('change', this.onValueUpdate_);
        this.value = config.value;
        this.update_();
    }
    update_() {
        const elem = this.textareaElem_;
        const shouldScroll = elem.scrollTop === elem.scrollHeight - elem.clientHeight;
        const lines = [];
        this.value.rawValue.forEach((value)=>{
            if (value !== undefined) lines.push(this.formatter_(value));
        });
        elem.textContent = lines.join('\n');
        if (shouldScroll) elem.scrollTop = elem.scrollHeight;
    }
    onValueUpdate_() {
        this.update_();
    }
}
class $9168155af81732ad$var$MultiLogController {
    constructor(doc, config){
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$MultiLogView(doc, {
            formatter: config.formatter,
            rows: config.rows,
            value: this.value,
            viewProps: this.viewProps
        });
    }
}
const $9168155af81732ad$var$cn$2 = $9168155af81732ad$var$ClassName('sgl');
class $9168155af81732ad$var$SingleLogView {
    constructor(doc, config){
        this.onValueUpdate_ = this.onValueUpdate_.bind(this);
        this.formatter_ = config.formatter;
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$2());
        config.viewProps.bindClassModifiers(this.element);
        const inputElem = doc.createElement('input');
        inputElem.classList.add($9168155af81732ad$var$cn$2('i'));
        inputElem.readOnly = true;
        inputElem.type = 'text';
        config.viewProps.bindDisabled(inputElem);
        this.element.appendChild(inputElem);
        this.inputElement = inputElem;
        config.value.emitter.on('change', this.onValueUpdate_);
        this.value = config.value;
        this.update_();
    }
    update_() {
        const values = this.value.rawValue;
        const lastValue = values[values.length - 1];
        this.inputElement.value = lastValue !== undefined ? this.formatter_(lastValue) : '';
    }
    onValueUpdate_() {
        this.update_();
    }
}
class $9168155af81732ad$var$SingleLogController {
    constructor(doc, config){
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new $9168155af81732ad$var$SingleLogView(doc, {
            formatter: config.formatter,
            value: this.value,
            viewProps: this.viewProps
        });
    }
}
const $9168155af81732ad$var$BooleanMonitorPlugin = $9168155af81732ad$var$createPlugin({
    id: 'monitor-bool',
    type: 'monitor',
    accept: (value, params)=>{
        if (typeof value !== 'boolean') return null;
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                readonly: p.required.constant(true),
                rows: p.optional.number
            }));
        return result ? {
            initialValue: value,
            params: result
        } : null;
    },
    binding: {
        reader: (_args)=>$9168155af81732ad$var$boolFromUnknown
    },
    controller: (args)=>{
        var _a;
        if (args.value.rawValue.length === 1) return new $9168155af81732ad$var$SingleLogController(args.document, {
            formatter: $9168155af81732ad$var$BooleanFormatter,
            value: args.value,
            viewProps: args.viewProps
        });
        return new $9168155af81732ad$var$MultiLogController(args.document, {
            formatter: $9168155af81732ad$var$BooleanFormatter,
            rows: (_a = args.params.rows) !== null && _a !== void 0 ? _a : $9168155af81732ad$var$Constants.monitor.defaultRows,
            value: args.value,
            viewProps: args.viewProps
        });
    }
});
class $9168155af81732ad$var$GraphLogMonitorBindingApi extends $9168155af81732ad$var$BindingApi {
    get max() {
        return this.controller.valueController.props.get('max');
    }
    set max(max) {
        this.controller.valueController.props.set('max', max);
    }
    get min() {
        return this.controller.valueController.props.get('min');
    }
    set min(min) {
        this.controller.valueController.props.set('min', min);
    }
}
const $9168155af81732ad$var$cn$1 = $9168155af81732ad$var$ClassName('grl');
class $9168155af81732ad$var$GraphLogView {
    constructor(doc, config){
        this.onCursorChange_ = this.onCursorChange_.bind(this);
        this.onValueUpdate_ = this.onValueUpdate_.bind(this);
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn$1());
        config.viewProps.bindClassModifiers(this.element);
        this.formatter_ = config.formatter;
        this.props_ = config.props;
        this.cursor_ = config.cursor;
        this.cursor_.emitter.on('change', this.onCursorChange_);
        const svgElem = doc.createElementNS($9168155af81732ad$var$SVG_NS, 'svg');
        svgElem.classList.add($9168155af81732ad$var$cn$1('g'));
        svgElem.style.height = `calc(var(${$9168155af81732ad$var$getCssVar('containerUnitSize')}) * ${config.rows})`;
        this.element.appendChild(svgElem);
        this.svgElem_ = svgElem;
        const lineElem = doc.createElementNS($9168155af81732ad$var$SVG_NS, 'polyline');
        this.svgElem_.appendChild(lineElem);
        this.lineElem_ = lineElem;
        const tooltipElem = doc.createElement('div');
        tooltipElem.classList.add($9168155af81732ad$var$cn$1('t'), $9168155af81732ad$var$ClassName('tt')());
        this.element.appendChild(tooltipElem);
        this.tooltipElem_ = tooltipElem;
        config.value.emitter.on('change', this.onValueUpdate_);
        this.value = config.value;
        this.update_();
    }
    get graphElement() {
        return this.svgElem_;
    }
    update_() {
        const { clientWidth: w, clientHeight: h } = this.element;
        const maxIndex = this.value.rawValue.length - 1;
        const min = this.props_.get('min');
        const max = this.props_.get('max');
        const points = [];
        this.value.rawValue.forEach((v, index)=>{
            if (v === undefined) return;
            const x = $9168155af81732ad$var$mapRange(index, 0, maxIndex, 0, w);
            const y = $9168155af81732ad$var$mapRange(v, min, max, h, 0);
            points.push([
                x,
                y
            ].join(','));
        });
        this.lineElem_.setAttributeNS(null, 'points', points.join(' '));
        const tooltipElem = this.tooltipElem_;
        const value = this.value.rawValue[this.cursor_.rawValue];
        if (value === undefined) {
            tooltipElem.classList.remove($9168155af81732ad$var$cn$1('t', 'a'));
            return;
        }
        const tx = $9168155af81732ad$var$mapRange(this.cursor_.rawValue, 0, maxIndex, 0, w);
        const ty = $9168155af81732ad$var$mapRange(value, min, max, h, 0);
        tooltipElem.style.left = `${tx}px`;
        tooltipElem.style.top = `${ty}px`;
        tooltipElem.textContent = `${this.formatter_(value)}`;
        if (!tooltipElem.classList.contains($9168155af81732ad$var$cn$1('t', 'a'))) {
            tooltipElem.classList.add($9168155af81732ad$var$cn$1('t', 'a'), $9168155af81732ad$var$cn$1('t', 'in'));
            $9168155af81732ad$var$forceReflow(tooltipElem);
            tooltipElem.classList.remove($9168155af81732ad$var$cn$1('t', 'in'));
        }
    }
    onValueUpdate_() {
        this.update_();
    }
    onCursorChange_() {
        this.update_();
    }
}
class $9168155af81732ad$var$GraphLogController {
    constructor(doc, config){
        this.onGraphMouseMove_ = this.onGraphMouseMove_.bind(this);
        this.onGraphMouseLeave_ = this.onGraphMouseLeave_.bind(this);
        this.onGraphPointerDown_ = this.onGraphPointerDown_.bind(this);
        this.onGraphPointerMove_ = this.onGraphPointerMove_.bind(this);
        this.onGraphPointerUp_ = this.onGraphPointerUp_.bind(this);
        this.props = config.props;
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.cursor_ = $9168155af81732ad$var$createValue(-1);
        this.view = new $9168155af81732ad$var$GraphLogView(doc, {
            cursor: this.cursor_,
            formatter: config.formatter,
            rows: config.rows,
            props: this.props,
            value: this.value,
            viewProps: this.viewProps
        });
        if (!$9168155af81732ad$var$supportsTouch(doc)) {
            this.view.element.addEventListener('mousemove', this.onGraphMouseMove_);
            this.view.element.addEventListener('mouseleave', this.onGraphMouseLeave_);
        } else {
            const ph = new $9168155af81732ad$var$PointerHandler(this.view.element);
            ph.emitter.on('down', this.onGraphPointerDown_);
            ph.emitter.on('move', this.onGraphPointerMove_);
            ph.emitter.on('up', this.onGraphPointerUp_);
        }
    }
    importProps(state) {
        return $9168155af81732ad$var$importBladeState(state, null, (p)=>({
                max: p.required.number,
                min: p.required.number
            }), (result)=>{
            this.props.set('max', result.max);
            this.props.set('min', result.min);
            return true;
        });
    }
    exportProps() {
        return $9168155af81732ad$var$exportBladeState(null, {
            max: this.props.get('max'),
            min: this.props.get('min')
        });
    }
    onGraphMouseLeave_() {
        this.cursor_.rawValue = -1;
    }
    onGraphMouseMove_(ev) {
        const { clientWidth: w } = this.view.element;
        this.cursor_.rawValue = Math.floor($9168155af81732ad$var$mapRange(ev.offsetX, 0, w, 0, this.value.rawValue.length));
    }
    onGraphPointerDown_(ev) {
        this.onGraphPointerMove_(ev);
    }
    onGraphPointerMove_(ev) {
        if (!ev.data.point) {
            this.cursor_.rawValue = -1;
            return;
        }
        this.cursor_.rawValue = Math.floor($9168155af81732ad$var$mapRange(ev.data.point.x, 0, ev.data.bounds.width, 0, this.value.rawValue.length));
    }
    onGraphPointerUp_() {
        this.cursor_.rawValue = -1;
    }
}
function $9168155af81732ad$var$createFormatter(params) {
    return !$9168155af81732ad$var$isEmpty(params.format) ? params.format : $9168155af81732ad$var$createNumberFormatter(2);
}
function $9168155af81732ad$var$createTextMonitor(args) {
    var _a;
    if (args.value.rawValue.length === 1) return new $9168155af81732ad$var$SingleLogController(args.document, {
        formatter: $9168155af81732ad$var$createFormatter(args.params),
        value: args.value,
        viewProps: args.viewProps
    });
    return new $9168155af81732ad$var$MultiLogController(args.document, {
        formatter: $9168155af81732ad$var$createFormatter(args.params),
        rows: (_a = args.params.rows) !== null && _a !== void 0 ? _a : $9168155af81732ad$var$Constants.monitor.defaultRows,
        value: args.value,
        viewProps: args.viewProps
    });
}
function $9168155af81732ad$var$createGraphMonitor(args) {
    var _a, _b, _c;
    return new $9168155af81732ad$var$GraphLogController(args.document, {
        formatter: $9168155af81732ad$var$createFormatter(args.params),
        rows: (_a = args.params.rows) !== null && _a !== void 0 ? _a : $9168155af81732ad$var$Constants.monitor.defaultRows,
        props: $9168155af81732ad$var$ValueMap.fromObject({
            max: (_b = args.params.max) !== null && _b !== void 0 ? _b : 100,
            min: (_c = args.params.min) !== null && _c !== void 0 ? _c : 0
        }),
        value: args.value,
        viewProps: args.viewProps
    });
}
function $9168155af81732ad$var$shouldShowGraph(params) {
    return params.view === 'graph';
}
const $9168155af81732ad$var$NumberMonitorPlugin = $9168155af81732ad$var$createPlugin({
    id: 'monitor-number',
    type: 'monitor',
    accept: (value, params)=>{
        if (typeof value !== 'number') return null;
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                format: p.optional.function,
                max: p.optional.number,
                min: p.optional.number,
                readonly: p.required.constant(true),
                rows: p.optional.number,
                view: p.optional.string
            }));
        return result ? {
            initialValue: value,
            params: result
        } : null;
    },
    binding: {
        defaultBufferSize: (params)=>$9168155af81732ad$var$shouldShowGraph(params) ? 64 : 1,
        reader: (_args)=>$9168155af81732ad$var$numberFromUnknown
    },
    controller: (args)=>{
        if ($9168155af81732ad$var$shouldShowGraph(args.params)) return $9168155af81732ad$var$createGraphMonitor(args);
        return $9168155af81732ad$var$createTextMonitor(args);
    },
    api: (args)=>{
        if (args.controller.valueController instanceof $9168155af81732ad$var$GraphLogController) return new $9168155af81732ad$var$GraphLogMonitorBindingApi(args.controller);
        return null;
    }
});
const $9168155af81732ad$var$StringMonitorPlugin = $9168155af81732ad$var$createPlugin({
    id: 'monitor-string',
    type: 'monitor',
    accept: (value, params)=>{
        if (typeof value !== 'string') return null;
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                multiline: p.optional.boolean,
                readonly: p.required.constant(true),
                rows: p.optional.number
            }));
        return result ? {
            initialValue: value,
            params: result
        } : null;
    },
    binding: {
        reader: (_args)=>$9168155af81732ad$var$stringFromUnknown
    },
    controller: (args)=>{
        var _a;
        const value = args.value;
        const multiline = value.rawValue.length > 1 || args.params.multiline;
        if (multiline) return new $9168155af81732ad$var$MultiLogController(args.document, {
            formatter: $9168155af81732ad$var$formatString,
            rows: (_a = args.params.rows) !== null && _a !== void 0 ? _a : $9168155af81732ad$var$Constants.monitor.defaultRows,
            value: value,
            viewProps: args.viewProps
        });
        return new $9168155af81732ad$var$SingleLogController(args.document, {
            formatter: $9168155af81732ad$var$formatString,
            value: value,
            viewProps: args.viewProps
        });
    }
});
class $9168155af81732ad$var$BladeApiCache {
    constructor(){
        this.map_ = new Map();
    }
    get(bc) {
        var _a;
        return (_a = this.map_.get(bc)) !== null && _a !== void 0 ? _a : null;
    }
    has(bc) {
        return this.map_.has(bc);
    }
    add(bc, api) {
        this.map_.set(bc, api);
        bc.viewProps.handleDispose(()=>{
            this.map_.delete(bc);
        });
        return api;
    }
}
class $9168155af81732ad$var$ReadWriteBinding {
    constructor(config){
        this.target = config.target;
        this.reader_ = config.reader;
        this.writer_ = config.writer;
    }
    read() {
        return this.reader_(this.target.read());
    }
    write(value) {
        this.writer_(this.target, value);
    }
    inject(value) {
        this.write(this.reader_(value));
    }
}
function $9168155af81732ad$var$createInputBindingController(plugin, args) {
    var _a;
    const result = plugin.accept(args.target.read(), args.params);
    if ($9168155af81732ad$var$isEmpty(result)) return null;
    const valueArgs = {
        target: args.target,
        initialValue: result.initialValue,
        params: result.params
    };
    const params = $9168155af81732ad$var$parseRecord(args.params, (p)=>({
            disabled: p.optional.boolean,
            hidden: p.optional.boolean,
            label: p.optional.string,
            tag: p.optional.string
        }));
    const reader = plugin.binding.reader(valueArgs);
    const constraint = plugin.binding.constraint ? plugin.binding.constraint(valueArgs) : undefined;
    const binding = new $9168155af81732ad$var$ReadWriteBinding({
        reader: reader,
        target: args.target,
        writer: plugin.binding.writer(valueArgs)
    });
    const value = new $9168155af81732ad$var$InputBindingValue($9168155af81732ad$var$createValue(reader(result.initialValue), {
        constraint: constraint,
        equals: plugin.binding.equals
    }), binding);
    const controller = plugin.controller({
        constraint: constraint,
        document: args.document,
        initialValue: result.initialValue,
        params: result.params,
        value: value,
        viewProps: $9168155af81732ad$var$ViewProps.create({
            disabled: params === null || params === void 0 ? void 0 : params.disabled,
            hidden: params === null || params === void 0 ? void 0 : params.hidden
        })
    });
    return new $9168155af81732ad$var$InputBindingController(args.document, {
        blade: $9168155af81732ad$var$createBlade(),
        props: $9168155af81732ad$var$ValueMap.fromObject({
            label: 'label' in args.params ? (_a = params === null || params === void 0 ? void 0 : params.label) !== null && _a !== void 0 ? _a : null : args.target.key
        }),
        tag: params === null || params === void 0 ? void 0 : params.tag,
        value: value,
        valueController: controller
    });
}
class $9168155af81732ad$var$ReadonlyBinding {
    constructor(config){
        this.target = config.target;
        this.reader_ = config.reader;
    }
    read() {
        return this.reader_(this.target.read());
    }
}
function $9168155af81732ad$var$createTicker(document, interval) {
    return interval === 0 ? new $9168155af81732ad$var$ManualTicker() : new $9168155af81732ad$var$IntervalTicker(document, interval !== null && interval !== void 0 ? interval : $9168155af81732ad$var$Constants.monitor.defaultInterval);
}
function $9168155af81732ad$var$createMonitorBindingController(plugin, args) {
    var _a, _b, _c;
    const result = plugin.accept(args.target.read(), args.params);
    if ($9168155af81732ad$var$isEmpty(result)) return null;
    const bindingArgs = {
        target: args.target,
        initialValue: result.initialValue,
        params: result.params
    };
    const params = $9168155af81732ad$var$parseRecord(args.params, (p)=>({
            bufferSize: p.optional.number,
            disabled: p.optional.boolean,
            hidden: p.optional.boolean,
            interval: p.optional.number,
            label: p.optional.string
        }));
    const reader = plugin.binding.reader(bindingArgs);
    const bufferSize = (_b = (_a = params === null || params === void 0 ? void 0 : params.bufferSize) !== null && _a !== void 0 ? _a : plugin.binding.defaultBufferSize && plugin.binding.defaultBufferSize(result.params)) !== null && _b !== void 0 ? _b : 1;
    const value = new $9168155af81732ad$var$MonitorBindingValue({
        binding: new $9168155af81732ad$var$ReadonlyBinding({
            reader: reader,
            target: args.target
        }),
        bufferSize: bufferSize,
        ticker: $9168155af81732ad$var$createTicker(args.document, params === null || params === void 0 ? void 0 : params.interval)
    });
    const controller = plugin.controller({
        document: args.document,
        params: result.params,
        value: value,
        viewProps: $9168155af81732ad$var$ViewProps.create({
            disabled: params === null || params === void 0 ? void 0 : params.disabled,
            hidden: params === null || params === void 0 ? void 0 : params.hidden
        })
    });
    controller.viewProps.bindDisabled(value.ticker);
    controller.viewProps.handleDispose(()=>{
        value.ticker.dispose();
    });
    return new $9168155af81732ad$var$MonitorBindingController(args.document, {
        blade: $9168155af81732ad$var$createBlade(),
        props: $9168155af81732ad$var$ValueMap.fromObject({
            label: 'label' in args.params ? (_c = params === null || params === void 0 ? void 0 : params.label) !== null && _c !== void 0 ? _c : null : args.target.key
        }),
        value: value,
        valueController: controller
    });
}
class $9168155af81732ad$var$PluginPool {
    constructor(apiCache){
        this.pluginsMap_ = {
            blades: [],
            inputs: [],
            monitors: []
        };
        this.apiCache_ = apiCache;
    }
    getAll() {
        return [
            ...this.pluginsMap_.blades,
            ...this.pluginsMap_.inputs,
            ...this.pluginsMap_.monitors
        ];
    }
    register(bundleId, r) {
        if (!$9168155af81732ad$var$isCompatible(r.core)) throw $9168155af81732ad$var$TpError.notCompatible(bundleId, r.id);
        if (r.type === 'blade') this.pluginsMap_.blades.unshift(r);
        else if (r.type === 'input') this.pluginsMap_.inputs.unshift(r);
        else if (r.type === 'monitor') this.pluginsMap_.monitors.unshift(r);
    }
    createInput_(document, target, params) {
        return this.pluginsMap_.inputs.reduce((result, plugin)=>result !== null && result !== void 0 ? result : $9168155af81732ad$var$createInputBindingController(plugin, {
                document: document,
                target: target,
                params: params
            }), null);
    }
    createMonitor_(document, target, params) {
        return this.pluginsMap_.monitors.reduce((result, plugin)=>result !== null && result !== void 0 ? result : $9168155af81732ad$var$createMonitorBindingController(plugin, {
                document: document,
                params: params,
                target: target
            }), null);
    }
    createBinding(doc, target, params) {
        const initialValue = target.read();
        if ($9168155af81732ad$var$isEmpty(initialValue)) throw new $9168155af81732ad$var$TpError({
            context: {
                key: target.key
            },
            type: 'nomatchingcontroller'
        });
        const ic = this.createInput_(doc, target, params);
        if (ic) return ic;
        const mc = this.createMonitor_(doc, target, params);
        if (mc) return mc;
        throw new $9168155af81732ad$var$TpError({
            context: {
                key: target.key
            },
            type: 'nomatchingcontroller'
        });
    }
    createBlade(document, params) {
        const bc = this.pluginsMap_.blades.reduce((result, plugin)=>result !== null && result !== void 0 ? result : $9168155af81732ad$var$createBladeController(plugin, {
                document: document,
                params: params
            }), null);
        if (!bc) throw new $9168155af81732ad$var$TpError({
            type: 'nomatchingview',
            context: {
                params: params
            }
        });
        return bc;
    }
    createInputBindingApi_(bc) {
        const api = this.pluginsMap_.inputs.reduce((result, plugin)=>{
            var _a, _b;
            if (result) return result;
            return (_b = (_a = plugin.api) === null || _a === void 0 ? void 0 : _a.call(plugin, {
                controller: bc
            })) !== null && _b !== void 0 ? _b : null;
        }, null);
        return this.apiCache_.add(bc, api !== null && api !== void 0 ? api : new $9168155af81732ad$var$BindingApi(bc));
    }
    createMonitorBindingApi_(bc) {
        const api = this.pluginsMap_.monitors.reduce((result, plugin)=>{
            var _a, _b;
            if (result) return result;
            return (_b = (_a = plugin.api) === null || _a === void 0 ? void 0 : _a.call(plugin, {
                controller: bc
            })) !== null && _b !== void 0 ? _b : null;
        }, null);
        return this.apiCache_.add(bc, api !== null && api !== void 0 ? api : new $9168155af81732ad$var$BindingApi(bc));
    }
    createBindingApi(bc) {
        if (this.apiCache_.has(bc)) return this.apiCache_.get(bc);
        if ($9168155af81732ad$var$isInputBindingController(bc)) return this.createInputBindingApi_(bc);
        if ($9168155af81732ad$var$isMonitorBindingController(bc)) return this.createMonitorBindingApi_(bc);
        throw $9168155af81732ad$var$TpError.shouldNeverHappen();
    }
    createApi(bc) {
        if (this.apiCache_.has(bc)) return this.apiCache_.get(bc);
        if ($9168155af81732ad$var$isBindingController(bc)) return this.createBindingApi(bc);
        const api = this.pluginsMap_.blades.reduce((result, plugin)=>result !== null && result !== void 0 ? result : plugin.api({
                controller: bc,
                pool: this
            }), null);
        if (!api) throw $9168155af81732ad$var$TpError.shouldNeverHappen();
        return this.apiCache_.add(bc, api);
    }
}
const $9168155af81732ad$var$sharedCache = new $9168155af81732ad$var$BladeApiCache();
function $9168155af81732ad$var$createDefaultPluginPool() {
    const pool = new $9168155af81732ad$var$PluginPool($9168155af81732ad$var$sharedCache);
    [
        $9168155af81732ad$var$Point2dInputPlugin,
        $9168155af81732ad$var$Point3dInputPlugin,
        $9168155af81732ad$var$Point4dInputPlugin,
        $9168155af81732ad$var$StringInputPlugin,
        $9168155af81732ad$var$NumberInputPlugin,
        $9168155af81732ad$var$StringColorInputPlugin,
        $9168155af81732ad$var$ObjectColorInputPlugin,
        $9168155af81732ad$var$NumberColorInputPlugin,
        $9168155af81732ad$var$BooleanInputPlugin,
        $9168155af81732ad$var$BooleanMonitorPlugin,
        $9168155af81732ad$var$StringMonitorPlugin,
        $9168155af81732ad$var$NumberMonitorPlugin,
        $9168155af81732ad$var$ButtonBladePlugin,
        $9168155af81732ad$var$FolderBladePlugin,
        $9168155af81732ad$var$TabBladePlugin
    ].forEach((p)=>{
        pool.register('core', p);
    });
    return pool;
}
class $9168155af81732ad$export$ac60a85524f159aa extends $9168155af81732ad$export$248680fe6a940b95 {
    /**
     * @hidden
     */ constructor(controller){
        super(controller);
        this.emitter_ = new $9168155af81732ad$var$Emitter();
        this.controller.value.emitter.on('change', (ev)=>{
            this.emitter_.emit('change', new $9168155af81732ad$export$684748b171755c8d(this, ev.rawValue));
        });
    }
    get label() {
        return this.controller.labelController.props.get('label');
    }
    set label(label) {
        this.controller.labelController.props.set('label', label);
    }
    get options() {
        return this.controller.valueController.props.get('options');
    }
    set options(options) {
        this.controller.valueController.props.set('options', options);
    }
    get value() {
        return this.controller.value.rawValue;
    }
    set value(value) {
        this.controller.value.rawValue = value;
    }
    on(eventName, handler) {
        const bh = handler.bind(this);
        this.emitter_.on(eventName, (ev)=>{
            bh(ev);
        }, {
            key: handler
        });
        return this;
    }
    off(eventName, handler) {
        this.emitter_.off(eventName, handler);
        return this;
    }
}
class $9168155af81732ad$export$1238ed6f25e8dd1d extends $9168155af81732ad$export$248680fe6a940b95 {
}
class $9168155af81732ad$export$19e2a27d537c8530 extends $9168155af81732ad$export$248680fe6a940b95 {
    /**
     * @hidden
     */ constructor(controller){
        super(controller);
        this.emitter_ = new $9168155af81732ad$var$Emitter();
        this.controller.value.emitter.on('change', (ev)=>{
            this.emitter_.emit('change', new $9168155af81732ad$export$684748b171755c8d(this, ev.rawValue));
        });
    }
    get label() {
        return this.controller.labelController.props.get('label');
    }
    set label(label) {
        this.controller.labelController.props.set('label', label);
    }
    get max() {
        return this.controller.valueController.sliderController.props.get('max');
    }
    set max(max) {
        this.controller.valueController.sliderController.props.set('max', max);
    }
    get min() {
        return this.controller.valueController.sliderController.props.get('min');
    }
    set min(min) {
        this.controller.valueController.sliderController.props.set('min', min);
    }
    get value() {
        return this.controller.value.rawValue;
    }
    set value(value) {
        this.controller.value.rawValue = value;
    }
    on(eventName, handler) {
        const bh = handler.bind(this);
        this.emitter_.on(eventName, (ev)=>{
            bh(ev);
        }, {
            key: handler
        });
        return this;
    }
    off(eventName, handler) {
        this.emitter_.off(eventName, handler);
        return this;
    }
}
class $9168155af81732ad$export$51e778ed12ba695a extends $9168155af81732ad$export$248680fe6a940b95 {
    /**
     * @hidden
     */ constructor(controller){
        super(controller);
        this.emitter_ = new $9168155af81732ad$var$Emitter();
        this.controller.value.emitter.on('change', (ev)=>{
            this.emitter_.emit('change', new $9168155af81732ad$export$684748b171755c8d(this, ev.rawValue));
        });
    }
    get label() {
        return this.controller.labelController.props.get('label');
    }
    set label(label) {
        this.controller.labelController.props.set('label', label);
    }
    get formatter() {
        return this.controller.valueController.props.get('formatter');
    }
    set formatter(formatter) {
        this.controller.valueController.props.set('formatter', formatter);
    }
    get value() {
        return this.controller.value.rawValue;
    }
    set value(value) {
        this.controller.value.rawValue = value;
    }
    on(eventName, handler) {
        const bh = handler.bind(this);
        this.emitter_.on(eventName, (ev)=>{
            bh(ev);
        }, {
            key: handler
        });
        return this;
    }
    off(eventName, handler) {
        this.emitter_.off(eventName, handler);
        return this;
    }
}
const $9168155af81732ad$var$ListBladePlugin = function() {
    return {
        id: 'list',
        type: 'blade',
        core: $9168155af81732ad$var$VERSION$1,
        accept (params) {
            const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                    options: p.required.custom($9168155af81732ad$var$parseListOptions),
                    value: p.required.raw,
                    view: p.required.constant('list'),
                    label: p.optional.string
                }));
            return result ? {
                params: result
            } : null;
        },
        controller (args) {
            const lc = new $9168155af81732ad$var$ListConstraint($9168155af81732ad$var$normalizeListOptions(args.params.options));
            const value = $9168155af81732ad$var$createValue(args.params.value, {
                constraint: lc
            });
            const ic = new $9168155af81732ad$var$ListController(args.document, {
                props: new $9168155af81732ad$var$ValueMap({
                    options: lc.values.value('options')
                }),
                value: value,
                viewProps: args.viewProps
            });
            return new $9168155af81732ad$var$LabeledValueBladeController(args.document, {
                blade: args.blade,
                props: $9168155af81732ad$var$ValueMap.fromObject({
                    label: args.params.label
                }),
                value: value,
                valueController: ic
            });
        },
        api (args) {
            if (!(args.controller instanceof $9168155af81732ad$var$LabeledValueBladeController)) return null;
            if (!(args.controller.valueController instanceof $9168155af81732ad$var$ListController)) return null;
            return new $9168155af81732ad$export$ac60a85524f159aa(args.controller);
        }
    };
}();
class $9168155af81732ad$var$RootApi extends $9168155af81732ad$export$c37d4c4ec53b1dee {
    /**
     * @hidden
     */ constructor(controller, pool){
        super(controller, pool);
    }
    get element() {
        return this.controller.view.element;
    }
}
/**
 * @hidden
 */ class $9168155af81732ad$var$RootController extends $9168155af81732ad$var$FolderController {
    constructor(doc, config){
        super(doc, {
            expanded: config.expanded,
            blade: config.blade,
            props: config.props,
            root: true,
            viewProps: config.viewProps
        });
    }
}
const $9168155af81732ad$var$cn = $9168155af81732ad$var$ClassName('spr');
/**
 * @hidden
 */ class $9168155af81732ad$var$SeparatorView {
    constructor(doc, config){
        this.element = doc.createElement('div');
        this.element.classList.add($9168155af81732ad$var$cn());
        config.viewProps.bindClassModifiers(this.element);
        const hrElem = doc.createElement('hr');
        hrElem.classList.add($9168155af81732ad$var$cn('r'));
        this.element.appendChild(hrElem);
    }
}
/**
 * @hidden
 */ class $9168155af81732ad$var$SeparatorController extends $9168155af81732ad$var$BladeController {
    /**
     * @hidden
     */ constructor(doc, config){
        super(Object.assign(Object.assign({}, config), {
            view: new $9168155af81732ad$var$SeparatorView(doc, {
                viewProps: config.viewProps
            })
        }));
    }
}
const $9168155af81732ad$var$SeparatorBladePlugin = {
    id: 'separator',
    type: 'blade',
    core: $9168155af81732ad$var$VERSION$1,
    accept (params) {
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                view: p.required.constant('separator')
            }));
        return result ? {
            params: result
        } : null;
    },
    controller (args) {
        return new $9168155af81732ad$var$SeparatorController(args.document, {
            blade: args.blade,
            viewProps: args.viewProps
        });
    },
    api (args) {
        if (!(args.controller instanceof $9168155af81732ad$var$SeparatorController)) return null;
        return new $9168155af81732ad$export$1238ed6f25e8dd1d(args.controller);
    }
};
const $9168155af81732ad$var$SliderBladePlugin = {
    id: 'slider',
    type: 'blade',
    core: $9168155af81732ad$var$VERSION$1,
    accept (params) {
        const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                max: p.required.number,
                min: p.required.number,
                view: p.required.constant('slider'),
                format: p.optional.function,
                label: p.optional.string,
                value: p.optional.number
            }));
        return result ? {
            params: result
        } : null;
    },
    controller (args) {
        var _a, _b;
        const initialValue = (_a = args.params.value) !== null && _a !== void 0 ? _a : 0;
        const drc = new $9168155af81732ad$var$DefiniteRangeConstraint({
            max: args.params.max,
            min: args.params.min
        });
        const v = $9168155af81732ad$var$createValue(initialValue, {
            constraint: drc
        });
        const vc = new $9168155af81732ad$var$SliderTextController(args.document, Object.assign(Object.assign({}, $9168155af81732ad$var$createSliderTextProps({
            formatter: (_b = args.params.format) !== null && _b !== void 0 ? _b : $9168155af81732ad$var$numberToString,
            keyScale: $9168155af81732ad$var$createValue(1),
            max: drc.values.value('max'),
            min: drc.values.value('min'),
            pointerScale: $9168155af81732ad$var$getSuitablePointerScale(args.params, initialValue)
        })), {
            parser: $9168155af81732ad$var$parseNumber,
            value: v,
            viewProps: args.viewProps
        }));
        return new $9168155af81732ad$var$LabeledValueBladeController(args.document, {
            blade: args.blade,
            props: $9168155af81732ad$var$ValueMap.fromObject({
                label: args.params.label
            }),
            value: v,
            valueController: vc
        });
    },
    api (args) {
        if (!(args.controller instanceof $9168155af81732ad$var$LabeledValueBladeController)) return null;
        if (!(args.controller.valueController instanceof $9168155af81732ad$var$SliderTextController)) return null;
        return new $9168155af81732ad$export$19e2a27d537c8530(args.controller);
    }
};
const $9168155af81732ad$var$TextBladePlugin = function() {
    return {
        id: 'text',
        type: 'blade',
        core: $9168155af81732ad$var$VERSION$1,
        accept (params) {
            const result = $9168155af81732ad$var$parseRecord(params, (p)=>({
                    parse: p.required.function,
                    value: p.required.raw,
                    view: p.required.constant('text'),
                    format: p.optional.function,
                    label: p.optional.string
                }));
            return result ? {
                params: result
            } : null;
        },
        controller (args) {
            var _a;
            const v = $9168155af81732ad$var$createValue(args.params.value);
            const ic = new $9168155af81732ad$var$TextController(args.document, {
                parser: args.params.parse,
                props: $9168155af81732ad$var$ValueMap.fromObject({
                    formatter: (_a = args.params.format) !== null && _a !== void 0 ? _a : (v)=>String(v)
                }),
                value: v,
                viewProps: args.viewProps
            });
            return new $9168155af81732ad$var$LabeledValueBladeController(args.document, {
                blade: args.blade,
                props: $9168155af81732ad$var$ValueMap.fromObject({
                    label: args.params.label
                }),
                value: v,
                valueController: ic
            });
        },
        api (args) {
            if (!(args.controller instanceof $9168155af81732ad$var$LabeledValueBladeController)) return null;
            if (!(args.controller.valueController instanceof $9168155af81732ad$var$TextController)) return null;
            return new $9168155af81732ad$export$51e778ed12ba695a(args.controller);
        }
    };
}();
function $9168155af81732ad$var$createDefaultWrapperElement(doc) {
    const elem = doc.createElement('div');
    elem.classList.add($9168155af81732ad$var$ClassName('dfw')());
    if (doc.body) doc.body.appendChild(elem);
    return elem;
}
function $9168155af81732ad$var$embedStyle(doc, id, css) {
    if (doc.querySelector(`style[data-tp-style=${id}]`)) return;
    const styleElem = doc.createElement('style');
    styleElem.dataset.tpStyle = id;
    styleElem.textContent = css;
    doc.head.appendChild(styleElem);
}
/**
 * The root pane of Tweakpane.
 */ class $9168155af81732ad$export$fd2e1a4921eb839b extends $9168155af81732ad$var$RootApi {
    constructor(opt_config){
        var _a, _b;
        const config = opt_config !== null && opt_config !== void 0 ? opt_config : {};
        const doc = (_a = config.document) !== null && _a !== void 0 ? _a : $9168155af81732ad$var$getWindowDocument();
        const pool = $9168155af81732ad$var$createDefaultPluginPool();
        const rootController = new $9168155af81732ad$var$RootController(doc, {
            expanded: config.expanded,
            blade: $9168155af81732ad$var$createBlade(),
            props: $9168155af81732ad$var$ValueMap.fromObject({
                title: config.title
            }),
            viewProps: $9168155af81732ad$var$ViewProps.create()
        });
        super(rootController, pool);
        this.pool_ = pool;
        this.containerElem_ = (_b = config.container) !== null && _b !== void 0 ? _b : $9168155af81732ad$var$createDefaultWrapperElement(doc);
        this.containerElem_.appendChild(this.element);
        this.doc_ = doc;
        this.usesDefaultWrapper_ = !config.container;
        this.setUpDefaultPlugins_();
    }
    get document() {
        if (!this.doc_) throw $9168155af81732ad$var$TpError.alreadyDisposed();
        return this.doc_;
    }
    dispose() {
        const containerElem = this.containerElem_;
        if (!containerElem) throw $9168155af81732ad$var$TpError.alreadyDisposed();
        if (this.usesDefaultWrapper_) {
            const parentElem = containerElem.parentElement;
            if (parentElem) parentElem.removeChild(containerElem);
        }
        this.containerElem_ = null;
        this.doc_ = null;
        super.dispose();
    }
    registerPlugin(bundle) {
        if (bundle.css) $9168155af81732ad$var$embedStyle(this.document, `plugin-${bundle.id}`, bundle.css);
        const plugins = 'plugin' in bundle ? [
            bundle.plugin
        ] : 'plugins' in bundle ? bundle.plugins : [];
        plugins.forEach((p)=>{
            this.pool_.register(bundle.id, p);
        });
    }
    setUpDefaultPlugins_() {
        this.registerPlugin({
            id: 'default',
            // NOTE: This string literal will be replaced with the default CSS by Rollup at the compilation time
            css: '.tp-tbiv_b,.tp-coltxtv_ms,.tp-colswv_b,.tp-ckbv_i,.tp-sglv_i,.tp-mllv_i,.tp-grlv_g,.tp-txtv_i,.tp-p2dpv_p,.tp-colswv_sw,.tp-rotv_b,.tp-fldv_b,.tp-p2dv_b,.tp-btnv_b,.tp-lstv_s{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:rgba(0,0,0,0);border-width:0;font-family:inherit;font-size:inherit;font-weight:inherit;margin:0;outline:none;padding:0}.tp-p2dv_b,.tp-btnv_b,.tp-lstv_s{background-color:var(--btn-bg);border-radius:var(--bld-br);color:var(--btn-fg);cursor:pointer;display:block;font-weight:bold;height:var(--cnt-usz);line-height:var(--cnt-usz);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tp-p2dv_b:hover,.tp-btnv_b:hover,.tp-lstv_s:hover{background-color:var(--btn-bg-h)}.tp-p2dv_b:focus,.tp-btnv_b:focus,.tp-lstv_s:focus{background-color:var(--btn-bg-f)}.tp-p2dv_b:active,.tp-btnv_b:active,.tp-lstv_s:active{background-color:var(--btn-bg-a)}.tp-p2dv_b:disabled,.tp-btnv_b:disabled,.tp-lstv_s:disabled{opacity:.5}.tp-rotv_c>.tp-cntv.tp-v-lst,.tp-tbpv_c>.tp-cntv.tp-v-lst,.tp-fldv_c>.tp-cntv.tp-v-lst{margin-bottom:calc(-1*var(--cnt-vp))}.tp-rotv_c>.tp-fldv.tp-v-lst .tp-fldv_c,.tp-tbpv_c>.tp-fldv.tp-v-lst .tp-fldv_c,.tp-fldv_c>.tp-fldv.tp-v-lst .tp-fldv_c{border-bottom-left-radius:0}.tp-rotv_c>.tp-fldv.tp-v-lst .tp-fldv_b,.tp-tbpv_c>.tp-fldv.tp-v-lst .tp-fldv_b,.tp-fldv_c>.tp-fldv.tp-v-lst .tp-fldv_b{border-bottom-left-radius:0}.tp-rotv_c>*:not(.tp-v-fst),.tp-tbpv_c>*:not(.tp-v-fst),.tp-fldv_c>*:not(.tp-v-fst){margin-top:var(--cnt-usp)}.tp-rotv_c>.tp-sprv:not(.tp-v-fst),.tp-tbpv_c>.tp-sprv:not(.tp-v-fst),.tp-fldv_c>.tp-sprv:not(.tp-v-fst),.tp-rotv_c>.tp-cntv:not(.tp-v-fst),.tp-tbpv_c>.tp-cntv:not(.tp-v-fst),.tp-fldv_c>.tp-cntv:not(.tp-v-fst){margin-top:var(--cnt-vp)}.tp-rotv_c>.tp-sprv+*:not(.tp-v-hidden),.tp-tbpv_c>.tp-sprv+*:not(.tp-v-hidden),.tp-fldv_c>.tp-sprv+*:not(.tp-v-hidden),.tp-rotv_c>.tp-cntv+*:not(.tp-v-hidden),.tp-tbpv_c>.tp-cntv+*:not(.tp-v-hidden),.tp-fldv_c>.tp-cntv+*:not(.tp-v-hidden){margin-top:var(--cnt-vp)}.tp-rotv_c>.tp-sprv:not(.tp-v-hidden)+.tp-sprv,.tp-tbpv_c>.tp-sprv:not(.tp-v-hidden)+.tp-sprv,.tp-fldv_c>.tp-sprv:not(.tp-v-hidden)+.tp-sprv,.tp-rotv_c>.tp-cntv:not(.tp-v-hidden)+.tp-cntv,.tp-tbpv_c>.tp-cntv:not(.tp-v-hidden)+.tp-cntv,.tp-fldv_c>.tp-cntv:not(.tp-v-hidden)+.tp-cntv{margin-top:0}.tp-tbpv_c>.tp-cntv,.tp-fldv_c>.tp-cntv{margin-left:4px}.tp-tbpv_c>.tp-fldv>.tp-fldv_b,.tp-fldv_c>.tp-fldv>.tp-fldv_b{border-top-left-radius:var(--bld-br);border-bottom-left-radius:var(--bld-br)}.tp-tbpv_c>.tp-fldv.tp-fldv-expanded>.tp-fldv_b,.tp-fldv_c>.tp-fldv.tp-fldv-expanded>.tp-fldv_b{border-bottom-left-radius:0}.tp-tbpv_c .tp-fldv>.tp-fldv_c,.tp-fldv_c .tp-fldv>.tp-fldv_c{border-bottom-left-radius:var(--bld-br)}.tp-tbpv_c>.tp-cntv+.tp-fldv>.tp-fldv_b,.tp-fldv_c>.tp-cntv+.tp-fldv>.tp-fldv_b{border-top-left-radius:0}.tp-tbpv_c>.tp-cntv+.tp-tabv>.tp-tabv_t,.tp-fldv_c>.tp-cntv+.tp-tabv>.tp-tabv_t{border-top-left-radius:0}.tp-tbpv_c>.tp-tabv>.tp-tabv_t,.tp-fldv_c>.tp-tabv>.tp-tabv_t{border-top-left-radius:var(--bld-br)}.tp-tbpv_c .tp-tabv>.tp-tabv_c,.tp-fldv_c .tp-tabv>.tp-tabv_c{border-bottom-left-radius:var(--bld-br)}.tp-rotv_b,.tp-fldv_b{background-color:var(--cnt-bg);color:var(--cnt-fg);cursor:pointer;display:block;height:calc(var(--cnt-usz) + 4px);line-height:calc(var(--cnt-usz) + 4px);overflow:hidden;padding-left:var(--cnt-hp);padding-right:calc(4px + var(--cnt-usz) + var(--cnt-hp));position:relative;text-align:left;text-overflow:ellipsis;white-space:nowrap;width:100%;transition:border-radius .2s ease-in-out .2s}.tp-rotv_b:hover,.tp-fldv_b:hover{background-color:var(--cnt-bg-h)}.tp-rotv_b:focus,.tp-fldv_b:focus{background-color:var(--cnt-bg-f)}.tp-rotv_b:active,.tp-fldv_b:active{background-color:var(--cnt-bg-a)}.tp-rotv_b:disabled,.tp-fldv_b:disabled{opacity:.5}.tp-rotv_m,.tp-fldv_m{background:linear-gradient(to left, var(--cnt-fg), var(--cnt-fg) 2px, transparent 2px, transparent 4px, var(--cnt-fg) 4px);border-radius:2px;bottom:0;content:"";display:block;height:6px;right:calc(var(--cnt-hp) + (var(--cnt-usz) + 4px - 6px)/2 - 2px);margin:auto;opacity:.5;position:absolute;top:0;transform:rotate(90deg);transition:transform .2s ease-in-out;width:6px}.tp-rotv.tp-rotv-expanded .tp-rotv_m,.tp-fldv.tp-fldv-expanded>.tp-fldv_b>.tp-fldv_m{transform:none}.tp-rotv_c,.tp-fldv_c{box-sizing:border-box;height:0;opacity:0;overflow:hidden;padding-bottom:0;padding-top:0;position:relative;transition:height .2s ease-in-out,opacity .2s linear,padding .2s ease-in-out}.tp-rotv.tp-rotv-cpl:not(.tp-rotv-expanded) .tp-rotv_c,.tp-fldv.tp-fldv-cpl:not(.tp-fldv-expanded)>.tp-fldv_c{display:none}.tp-rotv.tp-rotv-expanded .tp-rotv_c,.tp-fldv.tp-fldv-expanded>.tp-fldv_c{opacity:1;padding-bottom:var(--cnt-vp);padding-top:var(--cnt-vp);transform:none;overflow:visible;transition:height .2s ease-in-out,opacity .2s linear .2s,padding .2s ease-in-out}.tp-txtv_i,.tp-p2dpv_p,.tp-colswv_sw{background-color:var(--in-bg);border-radius:var(--bld-br);box-sizing:border-box;color:var(--in-fg);font-family:inherit;height:var(--cnt-usz);line-height:var(--cnt-usz);min-width:0;width:100%}.tp-txtv_i:hover,.tp-p2dpv_p:hover,.tp-colswv_sw:hover{background-color:var(--in-bg-h)}.tp-txtv_i:focus,.tp-p2dpv_p:focus,.tp-colswv_sw:focus{background-color:var(--in-bg-f)}.tp-txtv_i:active,.tp-p2dpv_p:active,.tp-colswv_sw:active{background-color:var(--in-bg-a)}.tp-txtv_i:disabled,.tp-p2dpv_p:disabled,.tp-colswv_sw:disabled{opacity:.5}.tp-lstv,.tp-coltxtv_m{position:relative}.tp-lstv_s{padding:0 20px 0 4px;width:100%}.tp-lstv_m,.tp-coltxtv_mm{bottom:0;margin:auto;pointer-events:none;position:absolute;right:2px;top:0}.tp-lstv_m svg,.tp-coltxtv_mm svg{bottom:0;height:16px;margin:auto;position:absolute;right:0;top:0;width:16px}.tp-lstv_m svg path,.tp-coltxtv_mm svg path{fill:currentColor}.tp-sglv_i,.tp-mllv_i,.tp-grlv_g{background-color:var(--mo-bg);border-radius:var(--bld-br);box-sizing:border-box;color:var(--mo-fg);height:var(--cnt-usz);scrollbar-color:currentColor rgba(0,0,0,0);scrollbar-width:thin;width:100%}.tp-sglv_i::-webkit-scrollbar,.tp-mllv_i::-webkit-scrollbar,.tp-grlv_g::-webkit-scrollbar{height:8px;width:8px}.tp-sglv_i::-webkit-scrollbar-corner,.tp-mllv_i::-webkit-scrollbar-corner,.tp-grlv_g::-webkit-scrollbar-corner{background-color:rgba(0,0,0,0)}.tp-sglv_i::-webkit-scrollbar-thumb,.tp-mllv_i::-webkit-scrollbar-thumb,.tp-grlv_g::-webkit-scrollbar-thumb{background-clip:padding-box;background-color:currentColor;border:rgba(0,0,0,0) solid 2px;border-radius:4px}.tp-pndtxtv,.tp-coltxtv_w{display:flex}.tp-pndtxtv_a,.tp-coltxtv_c{width:100%}.tp-pndtxtv_a+.tp-pndtxtv_a,.tp-coltxtv_c+.tp-pndtxtv_a,.tp-pndtxtv_a+.tp-coltxtv_c,.tp-coltxtv_c+.tp-coltxtv_c{margin-left:2px}.tp-rotv{--bs-bg: var(--tp-base-background-color, hsl(230, 7%, 17%));--bs-br: var(--tp-base-border-radius, 6px);--bs-ff: var(--tp-base-font-family, Roboto Mono, Source Code Pro, Menlo, Courier, monospace);--bs-sh: var(--tp-base-shadow-color, rgba(0, 0, 0, 0.2));--bld-br: var(--tp-blade-border-radius, 2px);--bld-hp: var(--tp-blade-horizontal-padding, 4px);--bld-vw: var(--tp-blade-value-width, 160px);--btn-bg: var(--tp-button-background-color, hsl(230, 7%, 70%));--btn-bg-a: var(--tp-button-background-color-active, #d6d7db);--btn-bg-f: var(--tp-button-background-color-focus, #c8cad0);--btn-bg-h: var(--tp-button-background-color-hover, #bbbcc4);--btn-fg: var(--tp-button-foreground-color, hsl(230, 7%, 17%));--cnt-bg: var(--tp-container-background-color, rgba(187, 188, 196, 0.1));--cnt-bg-a: var(--tp-container-background-color-active, rgba(187, 188, 196, 0.25));--cnt-bg-f: var(--tp-container-background-color-focus, rgba(187, 188, 196, 0.2));--cnt-bg-h: var(--tp-container-background-color-hover, rgba(187, 188, 196, 0.15));--cnt-fg: var(--tp-container-foreground-color, hsl(230, 7%, 75%));--cnt-hp: var(--tp-container-horizontal-padding, 4px);--cnt-vp: var(--tp-container-vertical-padding, 4px);--cnt-usp: var(--tp-container-unit-spacing, 4px);--cnt-usz: var(--tp-container-unit-size, 20px);--in-bg: var(--tp-input-background-color, rgba(187, 188, 196, 0.1));--in-bg-a: var(--tp-input-background-color-active, rgba(187, 188, 196, 0.25));--in-bg-f: var(--tp-input-background-color-focus, rgba(187, 188, 196, 0.2));--in-bg-h: var(--tp-input-background-color-hover, rgba(187, 188, 196, 0.15));--in-fg: var(--tp-input-foreground-color, hsl(230, 7%, 75%));--lbl-fg: var(--tp-label-foreground-color, rgba(187, 188, 196, 0.7));--mo-bg: var(--tp-monitor-background-color, rgba(0, 0, 0, 0.2));--mo-fg: var(--tp-monitor-foreground-color, rgba(187, 188, 196, 0.7));--grv-fg: var(--tp-groove-foreground-color, rgba(187, 188, 196, 0.1))}.tp-btnv_b{width:100%}.tp-btnv_t{text-align:center}.tp-ckbv_l{display:block;position:relative}.tp-ckbv_i{left:0;opacity:0;position:absolute;top:0}.tp-ckbv_w{background-color:var(--in-bg);border-radius:var(--bld-br);cursor:pointer;display:block;height:var(--cnt-usz);position:relative;width:var(--cnt-usz)}.tp-ckbv_w svg{display:block;height:16px;inset:0;margin:auto;opacity:0;position:absolute;width:16px}.tp-ckbv_w svg path{fill:none;stroke:var(--in-fg);stroke-width:2}.tp-ckbv_i:hover+.tp-ckbv_w{background-color:var(--in-bg-h)}.tp-ckbv_i:focus+.tp-ckbv_w{background-color:var(--in-bg-f)}.tp-ckbv_i:active+.tp-ckbv_w{background-color:var(--in-bg-a)}.tp-ckbv_i:checked+.tp-ckbv_w svg{opacity:1}.tp-ckbv.tp-v-disabled .tp-ckbv_w{opacity:.5}.tp-colv{position:relative}.tp-colv_h{display:flex}.tp-colv_s{flex-grow:0;flex-shrink:0;width:var(--cnt-usz)}.tp-colv_t{flex:1;margin-left:4px}.tp-colv_p{height:0;margin-top:0;opacity:0;overflow:hidden;transition:height .2s ease-in-out,opacity .2s linear,margin .2s ease-in-out}.tp-colv.tp-colv-expanded.tp-colv-cpl .tp-colv_p{overflow:visible}.tp-colv.tp-colv-expanded .tp-colv_p{margin-top:var(--cnt-usp);opacity:1}.tp-colv .tp-popv{left:calc(-1*var(--cnt-hp));right:calc(-1*var(--cnt-hp));top:var(--cnt-usz)}.tp-colpv_h,.tp-colpv_ap{margin-left:6px;margin-right:6px}.tp-colpv_h{margin-top:var(--cnt-usp)}.tp-colpv_rgb{display:flex;margin-top:var(--cnt-usp);width:100%}.tp-colpv_a{display:flex;margin-top:var(--cnt-vp);padding-top:calc(var(--cnt-vp) + 2px);position:relative}.tp-colpv_a::before{background-color:var(--grv-fg);content:"";height:2px;left:calc(-1*var(--cnt-hp));position:absolute;right:calc(-1*var(--cnt-hp));top:0}.tp-colpv.tp-v-disabled .tp-colpv_a::before{opacity:.5}.tp-colpv_ap{align-items:center;display:flex;flex:3}.tp-colpv_at{flex:1;margin-left:4px}.tp-svpv{border-radius:var(--bld-br);outline:none;overflow:hidden;position:relative}.tp-svpv.tp-v-disabled{opacity:.5}.tp-svpv_c{cursor:crosshair;display:block;height:calc(var(--cnt-usz)*4);width:100%}.tp-svpv_m{border-radius:100%;border:rgba(255,255,255,.75) solid 2px;box-sizing:border-box;filter:drop-shadow(0 0 1px rgba(0, 0, 0, 0.3));height:12px;margin-left:-6px;margin-top:-6px;pointer-events:none;position:absolute;width:12px}.tp-svpv:focus .tp-svpv_m{border-color:#fff}.tp-hplv{cursor:pointer;height:var(--cnt-usz);outline:none;position:relative}.tp-hplv.tp-v-disabled{opacity:.5}.tp-hplv_c{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAABCAYAAABubagXAAAAQ0lEQVQoU2P8z8Dwn0GCgQEDi2OK/RBgYHjBgIpfovFh8j8YBIgzFGQxuqEgPhaDOT5gOhPkdCxOZeBg+IDFZZiGAgCaSSMYtcRHLgAAAABJRU5ErkJggg==);background-position:left top;background-repeat:no-repeat;background-size:100% 100%;border-radius:2px;display:block;height:4px;left:0;margin-top:-2px;position:absolute;top:50%;width:100%}.tp-hplv_m{border-radius:var(--bld-br);border:rgba(255,255,255,.75) solid 2px;box-shadow:0 0 2px rgba(0,0,0,.1);box-sizing:border-box;height:12px;left:50%;margin-left:-6px;margin-top:-6px;position:absolute;top:50%;width:12px}.tp-hplv:focus .tp-hplv_m{border-color:#fff}.tp-aplv{cursor:pointer;height:var(--cnt-usz);outline:none;position:relative;width:100%}.tp-aplv.tp-v-disabled{opacity:.5}.tp-aplv_b{background-color:#fff;background-image:linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%),linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%);background-size:4px 4px;background-position:0 0,2px 2px;border-radius:2px;display:block;height:4px;left:0;margin-top:-2px;overflow:hidden;position:absolute;top:50%;width:100%}.tp-aplv_c{inset:0;position:absolute}.tp-aplv_m{background-color:#fff;background-image:linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%),linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%);background-size:12px 12px;background-position:0 0,6px 6px;border-radius:var(--bld-br);box-shadow:0 0 2px rgba(0,0,0,.1);height:12px;left:50%;margin-left:-6px;margin-top:-6px;overflow:hidden;position:absolute;top:50%;width:12px}.tp-aplv_p{border-radius:var(--bld-br);border:rgba(255,255,255,.75) solid 2px;box-sizing:border-box;inset:0;position:absolute}.tp-aplv:focus .tp-aplv_p{border-color:#fff}.tp-colswv{background-color:#fff;background-image:linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%),linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%);background-size:10px 10px;background-position:0 0,5px 5px;border-radius:var(--bld-br);overflow:hidden}.tp-colswv.tp-v-disabled{opacity:.5}.tp-colswv_sw{border-radius:0}.tp-colswv_b{cursor:pointer;display:block;height:var(--cnt-usz);left:0;position:absolute;top:0;width:var(--cnt-usz)}.tp-colswv_b:focus::after{border:rgba(255,255,255,.75) solid 2px;border-radius:var(--bld-br);content:"";display:block;inset:0;position:absolute}.tp-coltxtv{display:flex;width:100%}.tp-coltxtv_m{margin-right:4px}.tp-coltxtv_ms{border-radius:var(--bld-br);color:var(--lbl-fg);cursor:pointer;height:var(--cnt-usz);line-height:var(--cnt-usz);padding:0 18px 0 4px}.tp-coltxtv_ms:hover{background-color:var(--in-bg-h)}.tp-coltxtv_ms:focus{background-color:var(--in-bg-f)}.tp-coltxtv_ms:active{background-color:var(--in-bg-a)}.tp-coltxtv_mm{color:var(--lbl-fg)}.tp-coltxtv.tp-v-disabled .tp-coltxtv_mm{opacity:.5}.tp-coltxtv_w{flex:1}.tp-dfwv{position:absolute;top:8px;right:8px;width:256px}.tp-fldv{position:relative}.tp-fldv_t{padding-left:4px}.tp-fldv_b:disabled .tp-fldv_m{display:none}.tp-fldv_c{padding-left:4px}.tp-fldv_i{bottom:0;color:var(--cnt-bg);left:0;overflow:hidden;position:absolute;top:calc(var(--cnt-usz) + 4px);width:max(var(--bs-br),4px)}.tp-fldv_i::before{background-color:currentColor;bottom:0;content:"";left:0;position:absolute;top:0;width:4px}.tp-fldv_b:hover+.tp-fldv_i{color:var(--cnt-bg-h)}.tp-fldv_b:focus+.tp-fldv_i{color:var(--cnt-bg-f)}.tp-fldv_b:active+.tp-fldv_i{color:var(--cnt-bg-a)}.tp-fldv.tp-v-disabled>.tp-fldv_i{opacity:.5}.tp-grlv{position:relative}.tp-grlv_g{display:block;height:calc(var(--cnt-usz)*3)}.tp-grlv_g polyline{fill:none;stroke:var(--mo-fg);stroke-linejoin:round}.tp-grlv_t{margin-top:-4px;transition:left .05s,top .05s;visibility:hidden}.tp-grlv_t.tp-grlv_t-a{visibility:visible}.tp-grlv_t.tp-grlv_t-in{transition:none}.tp-grlv.tp-v-disabled .tp-grlv_g{opacity:.5}.tp-grlv .tp-ttv{background-color:var(--mo-fg)}.tp-grlv .tp-ttv::before{border-top-color:var(--mo-fg)}.tp-lblv{align-items:center;display:flex;line-height:1.3;padding-left:var(--cnt-hp);padding-right:var(--cnt-hp)}.tp-lblv.tp-lblv-nol{display:block}.tp-lblv_l{color:var(--lbl-fg);flex:1;-webkit-hyphens:auto;hyphens:auto;overflow:hidden;padding-left:4px;padding-right:16px}.tp-lblv.tp-v-disabled .tp-lblv_l{opacity:.5}.tp-lblv.tp-lblv-nol .tp-lblv_l{display:none}.tp-lblv_v{align-self:flex-start;flex-grow:0;flex-shrink:0;width:var(--bld-vw)}.tp-lblv.tp-lblv-nol .tp-lblv_v{width:100%}.tp-lstv_s{padding:0 20px 0 var(--bld-hp);width:100%}.tp-lstv_m{color:var(--btn-fg)}.tp-sglv_i{padding-left:var(--bld-hp);padding-right:var(--bld-hp)}.tp-sglv.tp-v-disabled .tp-sglv_i{opacity:.5}.tp-mllv_i{display:block;height:calc(var(--cnt-usz)*3);line-height:var(--cnt-usz);padding-left:var(--bld-hp);padding-right:var(--bld-hp);resize:none;white-space:pre}.tp-mllv.tp-v-disabled .tp-mllv_i{opacity:.5}.tp-p2dv{position:relative}.tp-p2dv_h{display:flex}.tp-p2dv_b{height:var(--cnt-usz);margin-right:4px;position:relative;width:var(--cnt-usz)}.tp-p2dv_b svg{display:block;height:16px;left:50%;margin-left:-8px;margin-top:-8px;position:absolute;top:50%;width:16px}.tp-p2dv_b svg path{stroke:currentColor;stroke-width:2}.tp-p2dv_b svg circle{fill:currentColor}.tp-p2dv_t{flex:1}.tp-p2dv_p{height:0;margin-top:0;opacity:0;overflow:hidden;transition:height .2s ease-in-out,opacity .2s linear,margin .2s ease-in-out}.tp-p2dv.tp-p2dv-expanded .tp-p2dv_p{margin-top:var(--cnt-usp);opacity:1}.tp-p2dv .tp-popv{left:calc(-1*var(--cnt-hp));right:calc(-1*var(--cnt-hp));top:var(--cnt-usz)}.tp-p2dpv{padding-left:calc(var(--cnt-usz) + 4px)}.tp-p2dpv_p{cursor:crosshair;height:0;overflow:hidden;padding-bottom:100%;position:relative}.tp-p2dpv.tp-v-disabled .tp-p2dpv_p{opacity:.5}.tp-p2dpv_g{display:block;height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%}.tp-p2dpv_ax{opacity:.1;stroke:var(--in-fg);stroke-dasharray:1}.tp-p2dpv_l{opacity:.5;stroke:var(--in-fg);stroke-dasharray:1}.tp-p2dpv_m{border:var(--in-fg) solid 1px;border-radius:50%;box-sizing:border-box;height:4px;margin-left:-2px;margin-top:-2px;position:absolute;width:4px}.tp-p2dpv_p:focus .tp-p2dpv_m{background-color:var(--in-fg);border-width:0}.tp-popv{background-color:var(--bs-bg);border-radius:var(--bs-br);box-shadow:0 2px 4px var(--bs-sh);display:none;max-width:var(--bld-vw);padding:var(--cnt-vp) var(--cnt-hp);position:absolute;visibility:hidden;z-index:1000}.tp-popv.tp-popv-v{display:block;visibility:visible}.tp-sldv.tp-v-disabled{opacity:.5}.tp-sldv_t{box-sizing:border-box;cursor:pointer;height:var(--cnt-usz);margin:0 6px;outline:none;position:relative}.tp-sldv_t::before{background-color:var(--in-bg);border-radius:1px;content:"";display:block;height:2px;inset:0;margin:auto;position:absolute}.tp-sldv_k{height:100%;left:0;position:absolute;top:0}.tp-sldv_k::before{background-color:var(--in-fg);border-radius:1px;content:"";display:block;height:2px;inset:0;margin-bottom:auto;margin-top:auto;position:absolute}.tp-sldv_k::after{background-color:var(--btn-bg);border-radius:var(--bld-br);bottom:0;content:"";display:block;height:12px;margin-bottom:auto;margin-top:auto;position:absolute;right:-6px;top:0;width:12px}.tp-sldv_t:hover .tp-sldv_k::after{background-color:var(--btn-bg-h)}.tp-sldv_t:focus .tp-sldv_k::after{background-color:var(--btn-bg-f)}.tp-sldv_t:active .tp-sldv_k::after{background-color:var(--btn-bg-a)}.tp-sldtxtv{display:flex}.tp-sldtxtv_s{flex:2}.tp-sldtxtv_t{flex:1;margin-left:4px}.tp-tabv{position:relative}.tp-tabv_t{align-items:flex-end;color:var(--cnt-bg);display:flex;overflow:hidden;position:relative}.tp-tabv_t:hover{color:var(--cnt-bg-h)}.tp-tabv_t:has(*:focus){color:var(--cnt-bg-f)}.tp-tabv_t:has(*:active){color:var(--cnt-bg-a)}.tp-tabv_t::before{background-color:currentColor;bottom:0;content:"";height:2px;left:0;pointer-events:none;position:absolute;right:0}.tp-tabv.tp-v-disabled .tp-tabv_t::before{opacity:.5}.tp-tabv.tp-tabv-nop .tp-tabv_t{height:calc(var(--cnt-usz) + 4px);position:relative}.tp-tabv.tp-tabv-nop .tp-tabv_t::before{background-color:var(--cnt-bg);bottom:0;content:"";height:2px;left:0;position:absolute;right:0}.tp-tabv_i{bottom:0;color:var(--cnt-bg);left:0;overflow:hidden;position:absolute;top:calc(var(--cnt-usz) + 4px);width:max(var(--bs-br),4px)}.tp-tabv_i::before{background-color:currentColor;bottom:0;content:"";left:0;position:absolute;top:0;width:4px}.tp-tabv_t:hover+.tp-tabv_i{color:var(--cnt-bg-h)}.tp-tabv_t:has(*:focus)+.tp-tabv_i{color:var(--cnt-bg-f)}.tp-tabv_t:has(*:active)+.tp-tabv_i{color:var(--cnt-bg-a)}.tp-tabv.tp-v-disabled>.tp-tabv_i{opacity:.5}.tp-tbiv{flex:1;min-width:0;position:relative}.tp-tbiv+.tp-tbiv{margin-left:2px}.tp-tbiv+.tp-tbiv.tp-v-disabled::before{opacity:.5}.tp-tbiv_b{display:block;padding-left:calc(var(--cnt-hp) + 4px);padding-right:calc(var(--cnt-hp) + 4px);position:relative;width:100%}.tp-tbiv_b:disabled{opacity:.5}.tp-tbiv_b::before{background-color:var(--cnt-bg);content:"";inset:0 0 2px;pointer-events:none;position:absolute}.tp-tbiv_b:hover::before{background-color:var(--cnt-bg-h)}.tp-tbiv_b:focus::before{background-color:var(--cnt-bg-f)}.tp-tbiv_b:active::before{background-color:var(--cnt-bg-a)}.tp-tbiv_t{color:var(--cnt-fg);height:calc(var(--cnt-usz) + 4px);line-height:calc(var(--cnt-usz) + 4px);opacity:.5;overflow:hidden;position:relative;text-overflow:ellipsis}.tp-tbiv.tp-tbiv-sel .tp-tbiv_t{opacity:1}.tp-tbpv_c{padding-bottom:var(--cnt-vp);padding-left:4px;padding-top:var(--cnt-vp)}.tp-txtv{position:relative}.tp-txtv_i{padding-left:var(--bld-hp);padding-right:var(--bld-hp)}.tp-txtv.tp-txtv-fst .tp-txtv_i{border-bottom-right-radius:0;border-top-right-radius:0}.tp-txtv.tp-txtv-mid .tp-txtv_i{border-radius:0}.tp-txtv.tp-txtv-lst .tp-txtv_i{border-bottom-left-radius:0;border-top-left-radius:0}.tp-txtv.tp-txtv-num .tp-txtv_i{text-align:right}.tp-txtv.tp-txtv-drg .tp-txtv_i{opacity:.3}.tp-txtv_k{cursor:pointer;height:100%;left:calc(var(--bld-hp) - 5px);position:absolute;top:0;width:12px}.tp-txtv_k::before{background-color:var(--in-fg);border-radius:1px;bottom:0;content:"";height:calc(var(--cnt-usz) - 4px);left:50%;margin-bottom:auto;margin-left:-1px;margin-top:auto;opacity:.1;position:absolute;top:0;transition:border-radius .1s,height .1s,transform .1s,width .1s;width:2px}.tp-txtv_k:hover::before,.tp-txtv.tp-txtv-drg .tp-txtv_k::before{opacity:1}.tp-txtv.tp-txtv-drg .tp-txtv_k::before{border-radius:50%;height:4px;transform:translateX(-1px);width:4px}.tp-txtv_g{bottom:0;display:block;height:8px;left:50%;margin:auto;overflow:visible;pointer-events:none;position:absolute;top:0;visibility:hidden;width:100%}.tp-txtv.tp-txtv-drg .tp-txtv_g{visibility:visible}.tp-txtv_gb{fill:none;stroke:var(--in-fg);stroke-dasharray:1}.tp-txtv_gh{fill:none;stroke:var(--in-fg)}.tp-txtv .tp-ttv{margin-left:6px;visibility:hidden}.tp-txtv.tp-txtv-drg .tp-ttv{visibility:visible}.tp-ttv{background-color:var(--in-fg);border-radius:var(--bld-br);color:var(--bs-bg);padding:2px 4px;pointer-events:none;position:absolute;transform:translate(-50%, -100%)}.tp-ttv::before{border-color:var(--in-fg) rgba(0,0,0,0) rgba(0,0,0,0) rgba(0,0,0,0);border-style:solid;border-width:2px;box-sizing:border-box;content:"";font-size:.9em;height:4px;left:50%;margin-left:-2px;position:absolute;top:100%;width:4px}.tp-rotv{background-color:var(--bs-bg);border-radius:var(--bs-br);box-shadow:0 2px 4px var(--bs-sh);font-family:var(--bs-ff);font-size:11px;font-weight:500;line-height:1;text-align:left}.tp-rotv_b{border-bottom-left-radius:var(--bs-br);border-bottom-right-radius:var(--bs-br);border-top-left-radius:var(--bs-br);border-top-right-radius:var(--bs-br);padding-left:calc(4px + var(--cnt-usz) + var(--cnt-hp));text-align:center}.tp-rotv.tp-rotv-expanded .tp-rotv_b{border-bottom-left-radius:0;border-bottom-right-radius:0;transition-delay:0s;transition-duration:0s}.tp-rotv.tp-rotv-not>.tp-rotv_b{display:none}.tp-rotv_b:disabled .tp-rotv_m{display:none}.tp-rotv_c>.tp-fldv.tp-v-lst>.tp-fldv_c{border-bottom-left-radius:var(--bs-br);border-bottom-right-radius:var(--bs-br)}.tp-rotv_c>.tp-fldv.tp-v-lst>.tp-fldv_i{border-bottom-left-radius:var(--bs-br)}.tp-rotv_c>.tp-fldv.tp-v-lst:not(.tp-fldv-expanded)>.tp-fldv_b{border-bottom-left-radius:var(--bs-br);border-bottom-right-radius:var(--bs-br)}.tp-rotv_c>.tp-fldv.tp-v-lst.tp-fldv-expanded>.tp-fldv_b{transition-delay:0s;transition-duration:0s}.tp-rotv_c .tp-fldv.tp-v-vlst:not(.tp-fldv-expanded)>.tp-fldv_b{border-bottom-right-radius:var(--bs-br)}.tp-rotv.tp-rotv-not .tp-rotv_c>.tp-fldv.tp-v-fst{margin-top:calc(-1*var(--cnt-vp))}.tp-rotv.tp-rotv-not .tp-rotv_c>.tp-fldv.tp-v-fst>.tp-fldv_b{border-top-left-radius:var(--bs-br);border-top-right-radius:var(--bs-br)}.tp-rotv_c>.tp-tabv.tp-v-lst>.tp-tabv_c{border-bottom-left-radius:var(--bs-br);border-bottom-right-radius:var(--bs-br)}.tp-rotv_c>.tp-tabv.tp-v-lst>.tp-tabv_i{border-bottom-left-radius:var(--bs-br)}.tp-rotv.tp-rotv-not .tp-rotv_c>.tp-tabv.tp-v-fst{margin-top:calc(-1*var(--cnt-vp))}.tp-rotv.tp-rotv-not .tp-rotv_c>.tp-tabv.tp-v-fst>.tp-tabv_t{border-top-left-radius:var(--bs-br);border-top-right-radius:var(--bs-br)}.tp-rotv.tp-v-disabled,.tp-rotv .tp-v-disabled{pointer-events:none}.tp-rotv.tp-v-hidden,.tp-rotv .tp-v-hidden{display:none}.tp-sprv_r{background-color:var(--grv-fg);border-width:0;display:block;height:2px;margin:0;width:100%}.tp-sprv.tp-v-disabled .tp-sprv_r{opacity:.5}',
            plugins: [
                $9168155af81732ad$var$ListBladePlugin,
                $9168155af81732ad$var$SeparatorBladePlugin,
                $9168155af81732ad$var$SliderBladePlugin,
                $9168155af81732ad$var$TabBladePlugin,
                $9168155af81732ad$var$TextBladePlugin
            ]
        });
    }
}
const $9168155af81732ad$export$a4ad2735b021c132 = new $9168155af81732ad$export$10303f3d0f41e8b2('4.0.5');

});


//# sourceMappingURL=cameraEditor.737f6996.js.map
